/* GleamCanvas "Diamond Art Inspirations" toolbox: free tools for diamond painters.
   Shared by the preview site and the Shopify theme. tools/build-theme-js.js copies this file
   (and dmc-colors.js) into shopify-theme/assets, so edit it here only.

   Tools: Photo to Drills, Palette Mood Boards, Kit Finder, DMC Color Finder, Drill Calculator,
   Missing Drill Helper. Tools without a render function show as "coming soon".
   Everything runs in the visitor's browser; photos never leave their device.

   Container attributes:
     data-dmc-src         URL of dmc-colors.js (loaded only when a tool needs it)
     data-design-url      link to the Design With Us page
     data-shop-url        link to all products
     data-contact-action  Shopify only: where the Missing Drill form posts (the store's /contact).
                          Without it (preview site) the form just shows its thank-you state.
   Products for the Kit Finder and the missing-drill form come from a <script type="application/json"
   data-dp-products> block (Shopify) or window.GC_PRODUCTS (preview site). */
(function () {
  "use strict";
  // The full toolbox lives in [data-dp-tools]. Other pages (shop, home) only have [data-kit-quiz]
  // links, which open the Kit Finder in a pop-up (falling back to the link's toolbox page).
  var root = document.querySelector("[data-dp-tools]");
  var quizLinks = Array.prototype.slice.call(document.querySelectorAll("[data-kit-quiz]"));
  if (!root && !quizLinks.length) return;
  var cfgEl = root || quizLinks[0];
  var cfg = {
    dmcSrc: cfgEl.getAttribute("data-dmc-src") || "assets/js/dmc-colors.js",
    designUrl: cfgEl.getAttribute("data-design-url") || "design.html",
    shopUrl: cfgEl.getAttribute("data-shop-url") || "shop.html",
    contactAction: cfgEl.getAttribute("data-contact-action") || ""
  };

  /* ---------- Small helpers ---------- */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
  }
  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
  function fmt(n) { return Math.round(n).toLocaleString("en-US"); }
  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function icon(paths) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + paths + "</svg>"; }
  var SPARKLE = '<svg class="sparkle" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 0c1 7 5 11 12 12-7 1-11 5-12 12-1-7-5-11-12-12C7 11 11 7 12 0z"/></svg>';

  /* ---------- Color math (sRGB -> CIE Lab, distance = CIE76) ---------- */
  function hexToRgb(h) { var n = parseInt(h.replace("#", ""), 16); return [n >> 16, (n >> 8) & 255, n & 255]; }
  function rgbToHex(r, g, b) { return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1); }
  function lin(c) { c /= 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
  function rgbToLab(r, g, b) {
    var R = lin(r), G = lin(g), B = lin(b);
    var x = (R * 0.4124 + G * 0.3576 + B * 0.1805) / 0.95047, y = R * 0.2126 + G * 0.7152 + B * 0.0722, z = (R * 0.0193 + G * 0.1192 + B * 0.9505) / 1.08883;
    var f = function (t) { return t > 0.008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; };
    var fx = f(x), fy = f(y), fz = f(z);
    return [116 * fy - 16, 500 * (fx - fy), 200 * (fy - fz)];
  }
  function dE(a, b) { var l = a[0] - b[0], m = a[1] - b[1], n = a[2] - b[2]; return Math.sqrt(l * l + m * m + n * n); }
  function family(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2, d = max - min;
    var s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1)), h = 0;
    if (d) h = max === r ? 60 * (((g - b) / d) % 6) : max === g ? 60 * ((b - r) / d + 2) : 60 * ((r - g) / d + 4);
    if (h < 0) h += 360;
    if (l > 0.9 && s < 0.6) return "whites";
    if (s < 0.12 || (l < 0.18 && s < 0.3)) return "grays";
    if (h >= 12 && h < 50 && l < 0.5 && s < 0.75) return "browns";
    if (h < 12 || h >= 345) return l > 0.72 ? "pinks" : "reds";
    if (h < 42) return "oranges";
    if (h < 70) return "yellows";
    if (h < 165) return "greens";
    if (h < 255) return "blues";
    if (h < 295) return "purples";
    return "pinks";
  }
  var FAMILIES = [["all", "All"], ["reds", "Reds"], ["pinks", "Pinks"], ["oranges", "Oranges"], ["yellows", "Yellows"], ["greens", "Greens"], ["blues", "Blues"], ["purples", "Purples"], ["browns", "Browns"], ["grays", "Grays & black"], ["whites", "Whites & creams"]];
  function matchQuality(d) { return d < 3 ? "Excellent match" : d < 7 ? "Good match" : d < 12 ? "Fair match" : "Closest available"; }

  /* ---------- DMC list (loaded on demand) ---------- */
  var DMC = null, dmcPromise = null;
  function loadDMC() {
    if (DMC) return Promise.resolve(DMC);
    if (!dmcPromise) {
      dmcPromise = new Promise(function (resolve, reject) {
        var ready = function () {
          DMC = window.GC_DMC.map(function (d) {
            var rgb = hexToRgb(d[2]);
            return { code: d[0], name: d[1], hex: "#" + d[2], rgb: rgb, lab: rgbToLab(rgb[0], rgb[1], rgb[2]), fam: family(rgb) };
          });
          resolve(DMC);
        };
        if (window.GC_DMC) return ready();
        var s = document.createElement("script");
        s.src = cfg.dmcSrc;
        s.onload = ready;
        s.onerror = function () { dmcPromise = null; reject(new Error("load")); };
        document.head.appendChild(s);
      });
    }
    return dmcPromise;
  }
  function nearest(lab, list, n, skip) {
    return list.filter(function (d) { return d !== skip; })
      .map(function (d) { return { d: d, dist: dE(lab, d.lab) }; })
      .sort(function (a, b) { return a.dist - b.dist; }).slice(0, n);
  }
  function byCode(code) {
    code = String(code).trim().toUpperCase();
    return DMC && DMC.filter(function (d) { return d.code.toUpperCase() === code; })[0];
  }

  /* ---------- Toolbox ---------- */
  var ICONS = {
    photo: icon('<path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5"/>'),
    palette: icon('<path d="M12 3a9 9 0 1 0 0 18c1.7 0 2-1.3 1.2-2.3-.8-1-.3-2.7 1.3-2.7H17a4 4 0 0 0 4-4c0-5-4-9-9-9z"/><circle cx="7.5" cy="11" r="1.2"/><circle cx="10.5" cy="7" r="1.2"/><circle cx="15" cy="7.5" r="1.2"/>'),
    quiz: icon('<path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2V16h5v-.1c0-.8.4-1.5 1-2A6 6 0 0 0 12 3z"/>'),
    gem: icon('<path d="M12 21 3 10l3.5-6h11L21 10z"/><path d="M3 10h18M9 4l3 6 3-6M12 10v11"/>'),
    calc: icon('<rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8 7h8M8.5 12h0M12 12h0M15.5 12h0M8.5 16h0M12 16h0M15.5 16h0" stroke-width="2.4"/>'),
    search: icon('<circle cx="11" cy="11" r="6"/><path d="m20 20-4.5-4.5"/>'),
    target: icon('<circle cx="12" cy="12" r="7"/><circle cx="12" cy="12" r="2.5"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/>'),
    timer: icon('<circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2.5M10 2h4"/>'),
    journal: icon('<path d="M6 3h11a2 2 0 0 1 2 2v16H7a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1z"/><path d="M9 8h6M9 12h6M5 19a2 2 0 0 1 2-2h12"/>')
  };
  var TOOLS = [
    { id: "photo-to-drills", group: "Create", title: "Photo to Drills", blurb: "See any photo as a diamond painting", icon: "photo", render: photoTool },
    { id: "drill-finder", group: "Create", title: "Missed Drill Finder", beta: true, blurb: "Snap your canvas; we'll circle empty spots", icon: "target", render: finderTool },
    { id: "palettes", group: "Create", title: "Palette Mood Boards", blurb: "DMC color sets for every season", icon: "palette", render: paletteTool },
    { id: "kit-finder", group: "Create", title: "Which Kit Is for Me?", blurb: "Tell us what you love; we'll suggest a kit", icon: "quiz", render: quizTool },
    { id: "dmc-finder", group: "Plan", title: "DMC Color Finder", blurb: "Look up a code or match any color", icon: "gem", render: dmcTool },
    { id: "drill-calculator", group: "Plan", title: "Drill Calculator", blurb: "Drills, bags and time for any size", icon: "calc", render: calcTool },
    { id: "missing-drills", group: "Plan", title: "Missing Drill Helper", blurb: "Short on a color? We'll help", icon: "search", render: missingTool },
    { id: "session-timer", group: "While you work", title: "Sparkle Session Timer", blurb: "Cozy work sessions with breaks", icon: "timer", render: timerTool },
    { id: "sparkle-journal", group: "While you work", title: "My Sparkle Journal", blurb: "Track every kit you're working on", icon: "journal", render: journalTool }
  ];
  var GROUPS = ["Create", "Plan", "While you work"];
  var BETA = ' <span class="badge badge-new dp-beta" title="New and still being tested">Beta</span>';
  var current = null;

  if (root) {
  root.innerHTML =
    '<div class="dp-hub" role="list">' + GROUPS.map(function (g) {
      return '<div class="dp-shelf" role="listitem"><p class="dp-shelf-title">' + g + "</p><div class=\"dp-cards\">" +
        TOOLS.filter(function (t) { return t.group === g; }).map(function (t) {
          return '<button type="button" class="dp-card' + (t.render ? "" : " is-soon") + '" data-tool="' + t.id + '"' + (t.render ? "" : " disabled") + ' aria-pressed="false">' +
            '<span class="dp-card-icon">' + ICONS[t.icon] + "</span>" +
            '<span class="dp-card-text"><strong>' + t.title + (t.beta ? BETA : "") + "</strong><small>" + (t.render ? t.blurb : "Coming soon") + "</small></span></button>";
        }).join("") + "</div></div>";
    }).join("") + "</div>" +
    '<div class="dp-panel" data-panel tabindex="-1" aria-live="polite"></div>';

  root.addEventListener("click", function (e) {
    var card = e.target.closest("[data-tool]");
    if (card && !card.disabled) open(card.getAttribute("data-tool"), true);
  });
  window.addEventListener("hashchange", function () { var t = toolFromHash(); if (t && t.id !== current) open(t.id, true); });
  }

  function toolFromHash() {
    var id = (location.hash || "").slice(1);
    return TOOLS.filter(function (t) { return t.id === id && t.render; })[0];
  }
  function open(id, scroll) {
    var tool = TOOLS.filter(function (t) { return t.id === id; })[0];
    if (!tool || !tool.render) return;
    current = id;
    $$("[data-tool]").forEach(function (c) { c.setAttribute("aria-pressed", String(c.getAttribute("data-tool") === id)); });
    var panel = $("[data-panel]");
    panel.innerHTML = '<div class="dp-panel-head"><span class="dp-card-icon">' + ICONS[tool.icon] + "</span><div><p class=\"dp-shelf-title\">" + tool.group + "</p><h2>" + tool.title + (tool.beta ? BETA : "") + "</h2></div></div>" +
      '<div class="dp-body" data-body><p class="dp-loading">' + SPARKLE + " Loading…</p></div>";
    tool.render($("[data-body]", panel));
    if (location.hash.slice(1) !== id) { try { history.replaceState(null, "", "#" + id); } catch (e) {} }
    if (scroll) panel.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  function loadFailed(body) {
    body.innerHTML = '<p class="dp-error">Sorry, the color list didn\'t load. Please check your connection and reload the page.</p>';
  }

  /* =========================================================
     Tool 1: Photo to Drills
     ========================================================= */
  var PITCH = { square: 2.5, round: 2.8 }; // common drill sizes in mm
  var SYMBOLS = "ABCDEFGHJKLMNPQRSTUVWXYZabdefghjkmnpqrstuy23456789+#@%&=?$*<>".split("");
  var MAX_CELLS = 160000;
  var photo = { src: null, name: "", w: 0, h: 0, width: 30, unit: "cm", shape: "square", colors: 24, view: "drills", zoom: 1, symbols: false, result: null,
    prodStyle: "dmc", shading: "soft", detail: 35, enhance: true, tidy: true, bright: 0, contrast: 0, sat: 0 };

  function photoTool(body) {
    body.innerHTML =
      '<p class="dp-intro">Upload a photo of a pet, a place or someone you love and see it as a diamond painting, with the exact DMC colors and drill counts. <strong>Your photo stays on your device.</strong> Nothing is uploaded.</p>' +
      '<div class="dp-photo-grid">' +
        '<div class="dp-controls">' +
          '<label class="dp-drop" data-drop><input type="file" accept="image/*" data-photo-input>' +
            '<span class="dp-drop-empty"><strong>Choose a photo</strong><small>or drag one here</small></span>' +
            '<span class="dp-drop-loaded"><img data-drop-thumb alt=""><span class="dp-drop-info"><strong>\u2713 Photo loaded</strong><small data-drop-name></small><em>Change photo</em></span></span>' +
          "</label>" +
          '<div class="dp-crop-row" data-crop-row hidden><button type="button" class="btn btn-outline btn-sm" data-crop>Crop Photo</button>' +
            '<button type="button" class="dp-link-btn" data-crop-undo hidden>Use Whole Photo</button></div>' +
          '<button type="button" class="dp-link-btn" data-sample>Try it with a sample picture</button>' +
          '<div class="dp-fieldset">' +
            '<label class="dp-label" for="dp-width">Finished width</label>' +
            '<div class="dp-inline"><input id="dp-width" class="dp-input" type="number" min="5" max="100" step="1" value="' + photo.width + '" data-width>' +
              seg("unit", [["cm", "cm"], ["in", "in"]], photo.unit) + "</div>" +
            '<p class="dp-help" data-height></p>' +
          "</div>" +
          '<div class="dp-fieldset"><span class="dp-label">Drill shape</span>' + seg("shape", [["square", "Square"], ["round", "Round"]], photo.shape) + "</div>" +
          '<div class="dp-fieldset"><label class="dp-label" for="dp-colors">Number of colors: <strong data-colors-out>' + photo.colors + "</strong></label>" +
            '<input id="dp-colors" type="range" min="6" max="60" step="1" value="' + photo.colors + '" data-colors class="dp-range">' +
            '<p class="dp-help">Fewer colors look bolder; more colors show finer detail.</p></div>' +
          '<div class="dp-fieldset"><span class="dp-label">Shading</span>' + seg("shading", [["clean", "Clean"], ["soft", "Soft"], ["smooth", "Smooth"]], photo.shading) +
            '<p class="dp-help">Clean keeps solid patches (easiest to paint). Smooth blends colors for a more photo-like look.</p></div>' +
          '<div class="dp-fieldset"><label class="dp-label" for="dp-detail">Detail: <strong data-detail-out>' + photo.detail + "</strong></label>" +
            '<input id="dp-detail" type="range" min="0" max="100" step="5" value="' + photo.detail + '" data-detail class="dp-range">' +
            '<p class="dp-help">Sharpens edges like eyes, whiskers and outlines.</p></div>' +
          '<label class="dp-check"><input type="checkbox" data-enhance' + (photo.enhance ? " checked" : "") + "> Auto-enhance colors and contrast</label>" +
          '<label class="dp-check"><input type="checkbox" data-tidy' + (photo.tidy ? " checked" : "") + "> Tidy stray single drills</label>" +
          '<details class="dp-adjust"><summary>Adjust photo</summary>' +
            [["bright", "Brightness"], ["contrast", "Contrast"], ["sat", "Color strength"]].map(function (a) {
              return '<div class="dp-fieldset"><label class="dp-label" for="dp-' + a[0] + '">' + a[1] + ': <strong data-adj-out="' + a[0] + '">' + photo[a[0]] + "</strong></label>" +
                '<input id="dp-' + a[0] + '" type="range" min="-50" max="50" step="5" value="' + photo[a[0]] + '" data-adj="' + a[0] + '" class="dp-range"></div>';
            }).join("") +
            '<button type="button" class="dp-link-btn" data-adj-reset>Reset adjustments</button>' +
          "</details>" +
          '<div class="dp-producer" data-producer hidden>' +
            '<div class="dp-fieldset"><span class="dp-label">Chart style</span>' + seg("prodstyle", [["dmc", "True DMC"], ["printed", "Printed Canvas"]], photo.prodStyle) +
              '<p class="dp-help">Printed Canvas shows your picture with every drill spot whited out and marked with its symbol, like a ready-to-paint canvas.</p></div>' +
            '<button type="button" class="btn btn-primary btn-sm" data-production>Save Print Files For Your Producer</button>' +
            '<button type="button" class="btn btn-outline btn-sm" data-production-send hidden>Send Both Files Now</button>' +
            '<p class="dp-fine" data-production-note>Saves two files: the chart in the style you chose, with a symbol on every drill, at its real size (up to 300 dpi), and the color-to-symbol card.</p>' +
            '<figure class="dp-producer-peek" data-production-peek hidden><img alt="Close-up of the saved chart, showing a symbol on every drill"><figcaption>Close-up of your chart file. The whole chart is big, so zoom in when you open it to see the symbols.</figcaption></figure>' +
          "</div>" +
        "</div>" +
        '<div class="dp-stage">' +
          '<div class="dp-suggest" data-suggest hidden aria-live="polite"></div>' +
          '<div class="dp-toolbar" data-toolbar hidden>' +
            seg("view", [["drills", "Drills"], ["flat", "True DMC"], ["printed", "Printed Canvas"], ["original", "Original"]], photo.view) +
            seg("zoom", [["1", "Fit"], ["2", "2×"], ["4", "4×"]], String(photo.zoom)) +
            '<label class="dp-check"><input type="checkbox" data-symbols> Symbols</label>' +
          "</div>" +
          '<div class="dp-stage-row" data-stage-row>' +
            '<div class="dp-canvas-wrap" data-wrap><div class="dp-empty" data-empty>' + ICONS.photo + "<p>Your diamond painting preview will appear here.</p></div>" +
              '<canvas data-canvas hidden></canvas></div>' +
            '<aside class="dp-keycard" data-keycard hidden aria-label="Color to symbol card"></aside>' +
          "</div>" +
          '<p class="dp-status" data-status role="status"></p>' +
        "</div>" +
      "</div>" +
      '<div data-results></div>';

    var fileInput = $("[data-photo-input]", body), drop = $(".dp-drop", body);
    fileInput.addEventListener("change", function () { if (fileInput.files[0]) loadPhoto(fileInput.files[0]); fileInput.value = ""; });
    ["dragenter", "dragover"].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add("is-over"); }); });
    ["dragleave", "drop"].forEach(function (ev) { drop.addEventListener(ev, function () { drop.classList.remove("is-over"); }); });
    drop.addEventListener("drop", function (e) { e.preventDefault(); var f = e.dataTransfer && e.dataTransfer.files[0]; if (f) loadPhoto(f); });
    $("[data-sample]", body).addEventListener("click", function () { setSource(sampleCanvas(), "sample", true); });

    // Producer files: the chart and the color-to-symbol card, as two separate print-ready PNGs
    var prodFiles = null;
    $("[data-production]", body).addEventListener("click", function (e) {
      var res = photo.result, btn = e.currentTarget, label = btn.textContent, noteEl = $("[data-production-note]", body), sendBtn = $("[data-production-send]", body);
      if (!res) return;
      btn.disabled = true; btn.textContent = "Preparing your files…"; sendBtn.hidden = true; $("[data-production-peek]", body).hidden = true;
      var done = function (msg) { btn.disabled = false; btn.textContent = label; if (msg) noteEl.textContent = msg; };
      var toPng = function (cv, dpi) { return new Promise(function (ok, no) { cv.toBlob(function (b) { if (!b) return no(new Error("memory")); pngWithDpi(b, dpi).then(ok, no); }, "image/png"); }); };
      setTimeout(function () {
        var size = photo.sizeText, drills = photo.shape === "round" ? "round 2.8 mm" : "square 2.5 mm", chart, card;
        var sub = size + " · " + res.cols + " × " + res.rows + " drills · " + drills + " drills · " + res.pal.length + " DMC colors";
        try {
          var printedStyle = photo.prodStyle === "printed";
          chart = printFile(res, { pitch: PITCH[photo.shape], shape: photo.shape, style: photo.prodStyle, src: photo.src, title: printedStyle ? "GleamCanvas printed canvas" : "GleamCanvas diamond painting chart", sub: sub });
          card = keyCardFile(res, { title: "Color to symbol card", sub: sub });
        } catch (err) { return done("Sorry, this painting is too big to make print files on this device. Try a smaller width or a computer."); }
        Promise.all([toPng(chart.canvas, chart.dpi), toPng(card, 300)]).then(function (blobs) {
          var base = "diamond-painting-" + res.cols + "x" + res.rows;
          var names = [base + (printedStyle ? "-printed-canvas.png" : "-chart.png"), base + "-color-key.png"];
          downloadBlob(blobs[0], names[0]);
          setTimeout(function () { downloadBlob(blobs[1], names[1]); }, 600);
          prodFiles = blobs.map(function (b, i) { return new File([b], names[i], { type: "image/png" }); });
          // Close-up of the middle of the chart (about 16 x 10 drills), so it's clear the file has every symbol
          try {
            var k = chart.cell, cw = Math.min(res.cols, 16), chh = Math.min(res.rows, 10), sx = chart.left + Math.floor((res.cols - cw) / 2) * k, sy = chart.top + Math.floor((res.rows - chh) / 2) * k;
            var pc = document.createElement("canvas"), sc = Math.min(1, 480 / (cw * k)); pc.width = Math.round(cw * k * sc); pc.height = Math.round(chh * k * sc);
            pc.getContext("2d").drawImage(chart.canvas, sx, sy, cw * k, chh * k, 0, 0, pc.width, pc.height);
            var peek = $("[data-production-peek]", body); $("img", peek).src = pc.toDataURL("image/png"); peek.hidden = false;
          } catch (x) { /* the close-up is optional */ }
          var canSend = navigator.canShare && (function () { try { return navigator.canShare({ files: prodFiles }); } catch (x) { return false; } })();
          sendBtn.hidden = !canSend;
          done("Saved 2 files: " + names[0] + " (" + chart.canvas.width + " × " + chart.canvas.height + " px at " + chart.dpi + " dpi; print at 100% for " + size + ") and " + names[1] + "." +
            (canSend ? " Tap “Send Both Files Now” to email or message them to your producer." : " Attach both to an email to your producer.") +
            " If your browser asks, allow it to download multiple files.");
        }, function () { done("Sorry, this device ran out of memory making the files. Try a smaller width or a computer."); });
      }, 40);
    });
    $("[data-production-send]", body).addEventListener("click", function () {
      if (prodFiles) navigator.share({ files: prodFiles, title: "Diamond painting print files", text: "Diamond painting chart and color key, " + photo.sizeText + ", " + (photo.result ? photo.result.pal.length : "") + " DMC colors." }).catch(function () {});
    });

    var timer;
    body.addEventListener("input", function (e) {
      var t = e.target;
      if (t.hasAttribute("data-width")) { photo.width = +t.value; updateHeight(); clearTimeout(timer); timer = setTimeout(run, 400); }
      else if (t.hasAttribute("data-colors")) { photo.colors = +t.value; $("[data-colors-out]", body).textContent = t.value; clearTimeout(timer); timer = setTimeout(run, 300); }
      else if (t.hasAttribute("data-detail")) { photo.detail = +t.value; $("[data-detail-out]", body).textContent = t.value; clearTimeout(timer); timer = setTimeout(run, 300); }
      else if (t.hasAttribute("data-adj")) { var key = t.getAttribute("data-adj"); photo[key] = +t.value; $('[data-adj-out="' + key + '"]', body).textContent = t.value; clearTimeout(timer); timer = setTimeout(run, 300); }
    });
    body.addEventListener("change", function (e) {
      if (e.target.hasAttribute("data-symbols")) {
        photo.symbols = e.target.checked; draw();
        status(photo.symbols && photo.result && photo.result.cols > 90 && photo.zoom === 1 ? "Tip: choose 2× or 4× to read the symbols on a big painting." : "");
      }
      else if (e.target.hasAttribute("data-enhance")) { photo.enhance = e.target.checked; run(); }
      else if (e.target.hasAttribute("data-tidy")) { photo.tidy = e.target.checked; run(); }
    });
    body.addEventListener("click", function (e) {
      if (e.target.closest("[data-adj-reset]")) {
        ["bright", "contrast", "sat"].forEach(function (k) { photo[k] = 0; $('[data-adj="' + k + '"]', body).value = 0; $('[data-adj-out="' + k + '"]', body).textContent = "0"; });
        run(); return;
      }
      var b = e.target.closest("[data-seg]");
      if (!b) return;
      var key = b.getAttribute("data-seg"), val = b.getAttribute("data-val");
      $$('[data-seg="' + key + '"]', body).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
      if (key === "unit") {
        var w = photo.unit === val ? photo.width : val === "in" ? Math.round(photo.width / 2.54) : Math.round(photo.width * 2.54);
        photo.unit = val; photo.width = w;
        var inp = $("[data-width]", body); inp.value = w; inp.max = val === "in" ? 40 : 100;
        updateHeight();
      } else if (key === "shape") { photo.shape = val; updateHeight(); run(); }
      else if (key === "shading") { photo.shading = val; run(); }
      else if (key === "prodstyle") { photo.prodStyle = val; $("[data-production-send]", body).hidden = true; prodFiles = null; $("[data-production-peek]", body).hidden = true; }
      else if (key === "view") { photo.view = val; draw(); }
      else if (key === "zoom") { photo.zoom = +val; applyZoom(); }
    });

    if (photo.src) { setSource(photo.src, photo.name); } else updateHeight();

    function updateHeight() {
      var el = $("[data-height]", body);
      if (!photo.src) { el.textContent = "Height follows your photo's shape."; return; }
      var hgt = photo.width * photo.h / photo.w;
      el.textContent = "Height: " + (Math.round(hgt * 10) / 10) + " " + photo.unit + " (keeps your photo's shape)";
    }
    function loadPhoto(file) {
      if (!/^image\//.test(file.type)) { status("Please choose a picture file (JPG or PNG).", true); return; }
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () { setSource(img, file.name, true); };
      img.onerror = function () { URL.revokeObjectURL(url); status("That picture couldn't be opened here. Try a JPG or PNG.", true); };
      img.src = url;
    }
    function setSource(src, name, fresh) {
      photo.src = src; photo.name = name;
      if (fresh) { photo.full = src; photo.crop = null; photo.cropShape = "free"; }
      photo.w = src.naturalWidth || src.width; photo.h = src.naturalHeight || src.height;
      showLoaded();
      if (fresh) photo.justLoaded = true; // scroll to the preview once it's ready
      updateHeight();
      run();
    }
    // Suggest a canvas size and number of colors for this photo (shown, never applied without a tap)
    var lastSuggest = null, beforeSuggest = null;
    function suggest() {
      var box = $("[data-suggest]", body), src = photo.src;
      box.hidden = false; box.className = "dp-suggest is-busy";
      box.innerHTML = '<p class="dp-help">Looking at your photo to suggest a size and number of colors\u2026</p>';
      setTimeout(function () {
        if (photo.src !== src) return;
        var sg;
        try { sg = suggestSettings(src, photo); } catch (e) { box.hidden = true; return; }
        lastSuggest = sg; box.className = "dp-suggest";
        var u = photo.unit, hgt = Math.round(sg.size * photo.h / photo.w * 10) / 10;
        var why = sg.detail === "high" ? "It has lots of fine detail and texture (like fur, beads or a landscape), so a bigger canvas keeps it crisp."
          : sg.detail === "medium" ? "It has a fair amount of detail; this size keeps the main features clear."
          : "It has smooth areas and a clear subject, so a classic size already looks great.";
        why += " " + sg.colors + " colors catch nearly every shade that matters, without extra bags you don't need.";
        if (sg.limited) why += " Your photo's resolution limits the size; a larger original would allow a bigger canvas.";
        var same = sg.size === photo.width && sg.colors === photo.colors;
        box.innerHTML = '<p class="dp-suggest-title"><span aria-hidden="true">\u2728</span> Suggested for this photo: <strong>' + sg.size + " \u00d7 " + hgt + " " + u + ", " + sg.colors + " colors</strong></p>" +
          '<p class="dp-help">' + why + "</p>" +
          (same ? '<p class="dp-help"><strong>Your current settings already match.</strong></p>'
                : '<button type="button" class="btn btn-primary btn-sm" data-suggest-use>Use These Settings</button>');
      }, 60);
    }
    function applySettings(width, colors) {
      photo.width = width; photo.colors = colors;
      $("[data-width]", body).value = width;
      $("[data-colors]", body).value = colors; $("[data-colors-out]", body).textContent = colors;
      updateHeight(); run();
    }
    body.addEventListener("click", function (e) {
      if (e.target.closest("[data-suggest-use]") && lastSuggest) {
        beforeSuggest = { width: photo.width, colors: photo.colors };
        applySettings(lastSuggest.size, lastSuggest.colors);
        $("[data-suggest]", body).innerHTML = '<p class="dp-suggest-title"><span aria-hidden="true">\u2713</span> Using the suggested <strong>' + lastSuggest.size + " " + photo.unit + ", " + lastSuggest.colors + " colors</strong>.</p>" +
          '<button type="button" class="dp-link-btn" data-suggest-undo>Undo</button>';
      } else if (e.target.closest("[data-suggest-undo]") && beforeSuggest) {
        applySettings(beforeSuggest.width, beforeSuggest.colors);
        beforeSuggest = null; suggest();
      }
    });
    // The picker turns into a "Photo loaded" card with a thumbnail, so it's clear the upload worked
    function showLoaded() {
      var drop = $("[data-drop]", body), t = document.createElement("canvas"), k = 112 / Math.max(photo.w, photo.h);
      t.width = Math.max(1, Math.round(photo.w * k)); t.height = Math.max(1, Math.round(photo.h * k));
      try { t.getContext("2d").drawImage(photo.src, 0, 0, t.width, t.height); $("[data-drop-thumb]", body).src = t.toDataURL("image/jpeg", 0.8); } catch (e) { /* thumbnail is optional */ }
      $("[data-drop-name]", body).textContent = (photo.name === "sample" ? "Sample picture" : photo.name) + (photo.crop ? " (cropped)" : "");
      drop.classList.add("is-loaded");
      $("[data-crop-row]", body).hidden = false;
      $("[data-crop-undo]", body).hidden = !photo.crop;
      $("[data-crop]", body).textContent = photo.crop ? "Change Crop" : "Crop Photo";
    }
    // Crop: the visitor drags a window over the whole photo. The original is kept, so a crop can be changed or undone.
    function useCrop(box) {
      var full = photo.full, fw = full.naturalWidth || full.width, fh = full.naturalHeight || full.height, src = full;
      if (box && (box.w < fw || box.h < fh)) {
        src = document.createElement("canvas");
        src.width = box.w; src.height = box.h;
        src.getContext("2d").drawImage(full, box.x, box.y, box.w, box.h, 0, 0, box.w, box.h);
      } else box = null;
      photo.crop = box;
      setSource(src, photo.name);
      photo.justLoaded = true; // suggest a size and colors for the new shape, and bring the preview into view
    }
    $("[data-crop]", body).addEventListener("click", function () { openCrop(useCrop); });
    $("[data-crop-undo]", body).addEventListener("click", function () { photo.cropShape = "free"; useCrop(null); });

    function openCrop(onApply) {
      var full = photo.full, W = full.naturalWidth || full.width, H = full.naturalHeight || full.height;
      var SHAPES = { free: 0, square: 1, portrait: 3 / 4, landscape: 4 / 3 };
      var shape = photo.cropShape || "free", box = photo.crop ? { x: photo.crop.x, y: photo.crop.y, w: photo.crop.w, h: photo.crop.h } : { x: 0, y: 0, w: W, h: H };
      var opener = document.activeElement, oldOverflow = document.documentElement.style.overflow, k = 1, drag = null;
      var ov = document.createElement("div");
      ov.className = "dp-crop"; ov.setAttribute("role", "dialog"); ov.setAttribute("aria-modal", "true"); ov.setAttribute("aria-label", "Crop your photo");
      ov.innerHTML =
        '<div class="dp-crop-panel">' +
          '<div class="dp-crop-head"><h3>Crop your photo</h3><p>Drag the window to move it. Drag a corner or edge to resize it.</p></div>' +
          '<div class="dp-crop-area" data-crop-area><div class="dp-crop-stage" data-crop-stage>' +
            '<div class="dp-crop-clip"><canvas data-crop-pic></canvas><div class="dp-crop-shade" data-crop-shade></div></div>' +
            '<div class="dp-crop-box" data-crop-box tabindex="0" role="group" aria-label="Crop window. Arrow keys move it; Shift and arrow keys resize it.">' +
              ["nw", "n", "ne", "e", "se", "s", "sw", "w"].map(function (h) { return '<span class="dp-crop-h dp-crop-h-' + h + '" data-h="' + h + '"></span>'; }).join("") +
            "</div>" +
          "</div></div>" +
          '<div class="dp-crop-foot">' +
            '<div class="dp-seg" role="group" aria-label="Crop shape">' + [["free", "Free"], ["square", "Square"], ["portrait", "Portrait"], ["landscape", "Landscape"]].map(function (o) {
              return '<button type="button" data-crop-shape="' + o[0] + '" aria-pressed="' + (o[0] === shape) + '">' + o[1] + "</button>";
            }).join("") + "</div>" +
            '<p class="dp-crop-size" data-crop-size aria-live="polite"></p>' +
            '<div class="dp-crop-actions"><button type="button" class="btn btn-primary btn-sm" data-crop-apply>Apply Crop</button>' +
              '<button type="button" class="btn btn-outline btn-sm" data-crop-cancel>Cancel</button>' +
              '<button type="button" class="dp-link-btn" data-crop-all>Select Whole Photo</button></div>' +
          "</div>" +
        "</div>";
      document.body.appendChild(ov);
      document.documentElement.style.overflow = "hidden";

      var area = $("[data-crop-area]", ov), stage = $("[data-crop-stage]", ov), pic = $("[data-crop-pic]", ov), boxEl = $("[data-crop-box]", ov), shade = $("[data-crop-shade]", ov);
      var ps = Math.min(1, 1400 / Math.max(W, H));
      pic.width = Math.max(1, Math.round(W * ps)); pic.height = Math.max(1, Math.round(H * ps));
      pic.getContext("2d").drawImage(full, 0, 0, pic.width, pic.height);

      function ratio() { return SHAPES[shape]; }
      function minSize() { return Math.min(W, H, Math.max(56 / k, 20)); } // big enough to grab on a phone
      function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }
      function layout() {
        k = Math.min(area.clientWidth / W, area.clientHeight / H);
        stage.style.width = Math.round(W * k) + "px"; stage.style.height = Math.round(H * k) + "px";
        paint();
      }
      function paint() {
        var s = "left:" + box.x * k + "px;top:" + box.y * k + "px;width:" + box.w * k + "px;height:" + box.h * k + "px";
        boxEl.style.cssText = s; shade.style.cssText = s;
        boxEl.classList.toggle("is-locked", !!ratio());
        var bw = Math.round(box.w), bh = Math.round(box.h), widthMm = photo.width * (photo.unit === "in" ? 25.4 : 10), cols = Math.round(widthMm / PITCH[photo.shape]);
        var hgt = Math.round(photo.width * bh / bw * 10) / 10;
        $("[data-crop-size]", ov).innerHTML = "At " + photo.width + " " + photo.unit + " wide your painting will be <strong>" + photo.width + " × " + hgt + " " + photo.unit + "</strong>." +
          (bw / cols < 1.5 ? ' <span class="dp-crop-warn">This small area may look blurry at this width.</span>' : "");
      }
      // A crop shape: the biggest window of that shape around the current centre
      function fitShape() {
        var a = ratio(); if (!a) return;
        var cx = box.x + box.w / 2, cy = box.y + box.h / 2, w = box.w, h = w / a;
        if (h > box.h) { h = box.h; w = h * a; }
        // Grow back up if the current window is nearly the whole photo in one direction
        var maxW = Math.min(W, H * a); if (box.w >= W - 1 && box.h >= H - 1) { w = maxW; h = w / a; }
        if (w < minSize()) { w = Math.min(minSize(), maxW); h = w / a; }
        box = { x: clamp(cx - w / 2, 0, W - w), y: clamp(cy - h / 2, 0, H - h), w: w, h: h };
      }
      function at(e) { var r = stage.getBoundingClientRect(); return { x: clamp((e.clientX - r.left) / k, 0, W), y: clamp((e.clientY - r.top) / k, 0, H) }; }
      function resize(h, p) {
        var s = drag.start, a = ratio(), m = minSize(), L = /w/.test(h), R = /e/.test(h), T = /n/.test(h), B = /s/.test(h);
        if (a) { // keep the shape; the opposite corner stays put
          var ax = L ? s.x + s.w : s.x, ay = T ? s.y + s.h : s.y, maxW = Math.min(L ? ax : W - ax, (T ? ay : H - ay) * a);
          var w = Math.min(Math.max(Math.abs(p.x - ax), Math.abs(p.y - ay) * a, m), maxW), hh = w / a;
          box = { x: L ? ax - w : ax, y: T ? ay - hh : ay, w: w, h: hh };
          return;
        }
        var x1 = L ? clamp(p.x, 0, s.x + s.w - m) : s.x, x2 = R ? clamp(p.x, s.x + m, W) : s.x + s.w;
        var y1 = T ? clamp(p.y, 0, s.y + s.h - m) : s.y, y2 = B ? clamp(p.y, s.y + m, H) : s.y + s.h;
        box = { x: x1, y: y1, w: x2 - x1, h: y2 - y1 };
      }
      boxEl.addEventListener("pointerdown", function (e) {
        e.preventDefault(); boxEl.focus({ preventScroll: true });
        var h = e.target.getAttribute("data-h");
        drag = { h: h, from: at(e), start: { x: box.x, y: box.y, w: box.w, h: box.h } };
        try { boxEl.setPointerCapture(e.pointerId); } catch (x) { /* dragging still works inside the window */ }
      });
      boxEl.addEventListener("pointermove", function (e) {
        if (!drag) return;
        var p = at(e);
        if (drag.h) resize(drag.h, p);
        else box = { x: clamp(drag.start.x + p.x - drag.from.x, 0, W - box.w), y: clamp(drag.start.y + p.y - drag.from.y, 0, H - box.h), w: box.w, h: box.h };
        paint();
      });
      ["pointerup", "pointercancel"].forEach(function (ev) { boxEl.addEventListener(ev, function () { drag = null; }); });
      boxEl.addEventListener("keydown", function (e) {
        var dir = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key];
        if (!dir) return;
        e.preventDefault();
        var st = Math.max(1, Math.round(Math.max(W, H) * 0.01));
        if (e.shiftKey) {
          var a = ratio(), w = clamp(box.w + (dir[0] || -dir[1]) * st, minSize(), W - box.x), hh = a ? w / a : clamp(box.h + (dir[1] || 0) * st, minSize(), H - box.y);
          if (a && box.y + hh > H) { hh = H - box.y; w = hh * a; }
          box = { x: box.x, y: box.y, w: a || dir[0] ? w : box.w, h: hh };
        } else box = { x: clamp(box.x + dir[0] * st, 0, W - box.w), y: clamp(box.y + dir[1] * st, 0, H - box.h), w: box.w, h: box.h };
        paint();
      });
      function close() {
        window.removeEventListener("resize", layout);
        document.removeEventListener("keydown", onKey, true);
        document.documentElement.style.overflow = oldOverflow;
        ov.remove();
        if (opener && opener.isConnected && !opener.hidden) opener.focus({ preventScroll: true });
        else $("[data-crop]", body).focus({ preventScroll: true });
      }
      function onKey(e) {
        if (e.key === "Escape") { e.preventDefault(); close(); return; }
        if (e.key !== "Tab") return;
        var f = $$("button, [tabindex='0']", ov), first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      ov.addEventListener("click", function (e) {
        var sb = e.target.closest("[data-crop-shape]");
        if (sb) {
          shape = sb.getAttribute("data-crop-shape");
          $$("[data-crop-shape]", ov).forEach(function (x) { x.setAttribute("aria-pressed", String(x === sb)); });
          fitShape(); paint();
        } else if (e.target.closest("[data-crop-all]")) {
          shape = "free"; box = { x: 0, y: 0, w: W, h: H };
          $$("[data-crop-shape]", ov).forEach(function (x) { x.setAttribute("aria-pressed", String(x.getAttribute("data-crop-shape") === "free")); });
          paint();
        } else if (e.target.closest("[data-crop-cancel]")) close();
        else if (e.target.closest("[data-crop-apply]")) {
          var x1 = Math.round(box.x), y1 = Math.round(box.y), x2 = Math.min(W, Math.round(box.x + box.w)), y2 = Math.min(H, Math.round(box.y + box.h));
          photo.cropShape = shape;
          close();
          try { onApply({ x: x1, y: y1, w: x2 - x1, h: y2 - y1 }); }
          catch (err) { status("Sorry, this device couldn't crop a photo this big. Try a smaller photo.", true); }
        }
      });
      window.addEventListener("resize", layout);
      document.addEventListener("keydown", onKey, true);
      layout();
      fitShape(); paint();
      boxEl.focus({ preventScroll: true });
    }
    // On phones the preview is below all the settings: bring it into view (not on computers, where it's beside them)
    function revealPreview() {
      var stage = $(".dp-stage", body), r = stage.getBoundingClientRect(), vh = window.innerHeight || 800;
      if (r.top < vh * 0.55 && r.bottom > 0) return;
      var head = document.querySelector(".site-header"), off = head && getComputedStyle(head).position === "sticky" ? head.offsetHeight : 0;
      window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - off - 12), behavior: "smooth" });
    }
    function status(msg, isError) {
      var s = $("[data-status]", body);
      s.textContent = msg || "";
      s.className = "dp-status" + (isError ? " is-error" : "");
    }

    function run() {
      if (!photo.src) return;
      status("Turning your photo into drills…");
      loadDMC().then(function () {
        setTimeout(function () {
          var widthMm = photo.width * (photo.unit === "in" ? 25.4 : 10);
          var cols = Math.max(10, Math.round(widthMm / PITCH[photo.shape]));
          var rows = Math.max(10, Math.round(cols * photo.h / photo.w));
          if (cols * rows > MAX_CELLS) { status("That's a very big canvas. Please choose a smaller width.", true); return; }
          photo.result = convert(photo.src, cols, rows, photo);
          photo.result.widthMm = widthMm;
          $("[data-toolbar]", body).hidden = false;
          $("[data-producer]", body).hidden = false;
          $("[data-production-send]", body).hidden = true; prodFiles = null; $("[data-production-peek]", body).hidden = true;
          $("[data-empty]", body).hidden = true;
          $("[data-canvas]", body).hidden = false;
          draw();
          results();
          status("");
          if (photo.justLoaded) { photo.justLoaded = false; revealPreview(); suggest(); }
        }, 30);
      }, function () { loadFailed(body); });
    }

    function draw() {
      var res = photo.result, cv = $("[data-canvas]", body);
      if (!res) return;
      var cell = clamp(Math.floor(1800 / res.cols), 3, 24), printed = photo.view === "printed", sym = (photo.symbols || printed) && photo.view !== "original";
      // Symbols need room: draw bigger drills (zoom to read them), but stay under the ~16 MP canvas limit of phones
      if (sym && cell < 14) { cell = 14; while (cell > 8 && res.cols * res.rows * cell * cell > 16e6) cell--; }
      cv.width = res.cols * cell; cv.height = res.rows * cell;
      var ctx = cv.getContext("2d");
      if (photo.view === "original") {
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(photo.src, 0, 0, cv.width, cv.height);
      } else if (printed) {
        drawPrinted(ctx, res, cell, photo.shape, photo.src);
      } else {
        drawDrills(ctx, res, cell, photo.shape, sym, photo.view === "flat");
      }
      cv.setAttribute("aria-label", photo.view === "original" ? "Your original photo" : printed ? "Printed canvas: your picture with every drill spot marked by its symbol" : "Diamond painting preview: " + res.cols + " by " + res.rows + " drills in " + res.pal.length + " DMC colors");
      cv.setAttribute("role", "img");
      keyCard();
      applyZoom();
    }
    // Color-to-symbol card beside the picture
    function keyCard() {
      var res = photo.result, el = $("[data-keycard]", body);
      if (!res) return;
      el.hidden = false; $("[data-stage-row]", body).classList.add("has-key");
      el.innerHTML = '<h4 class="dp-keycard-h">Color to symbol card <small>' + res.pal.length + " colors</small></h4>" +
        '<ol class="dp-keycard-list">' + res.pal.map(function (p) {
          return '<li><span class="dp-keycard-sym" style="background:' + p.d.hex + ";color:" + (p.d.lab[0] > 60 ? "#123447" : "#fff") + '">' + esc(p.sym) + "</span>" +
            '<span class="dp-keycard-txt"><strong>DMC ' + esc(p.d.code) + "</strong><small>" + esc(p.d.name) + "</small></span>" +
            '<span class="dp-keycard-n">' + fmt(p.count) + "</span></li>";
        }).join("") + "</ol>";
    }
    function applyZoom() {
      var cv = $("[data-canvas]", body);
      cv.style.width = (photo.zoom * 100) + "%";
      $("[data-wrap]", body).classList.toggle("is-zoomed", photo.zoom > 1);
    }

    function results() {
      // A fresh element each time, so the listeners below never pile up across re-runs
      var res = photo.result, old = $("[data-results]", body), box = document.createElement("div");
      box.setAttribute("data-results", "");
      old.parentNode.replaceChild(box, old);
      var hMm = res.widthMm * res.rows / res.cols, u = photo.unit, k = u === "in" ? 25.4 : 10;
      var size = (Math.round(res.widthMm / k * 10) / 10) + " × " + (Math.round(hMm / k * 10) / 10) + " " + u;
      var total = res.cols * res.rows;
      box.innerHTML =
        '<div class="dp-stats">' +
          stat(fmt(total), "drills to place") +
          stat(res.pal.length, "DMC colors") +
          stat(res.cols + " × " + res.rows, "drills across × down") +
          stat(size, "finished size") +
        "</div>" + wallHtml() +
        // Built-in drill calculator: spares, bags per color and time (settings shared with the Drill Calculator tool)
        '<div class="dp-plan">' +
          '<h3 class="dp-h3">Plan your painting</h3>' +
          '<div class="dp-plan-grid">' +
            '<div class="dp-plan-controls">' +
              '<div class="dp-fieldset"><label class="dp-label" for="dp-p-spare">Extra for spares: <strong data-p-spare-out>' + calc.spare + "%</strong></label>" +
                '<input id="dp-p-spare" class="dp-range" type="range" min="0" max="30" step="5" value="' + calc.spare + '" data-p="spare"></div>' +
              '<div class="dp-fieldset"><label class="dp-label" for="dp-p-bag">Drills per bag</label>' +
                '<input id="dp-p-bag" class="dp-input dp-num" type="number" min="10" max="5000" step="10" value="' + calc.bag + '" data-p="bag"></div>' +
              '<div class="dp-fieldset"><span class="dp-label">Your pace</span>' + seg("ppace", PACES.map(function (p) { return [p[0], p[1]]; }), calc.pace) + '<p class="dp-help" data-p-pace-help></p></div>' +
            "</div>" +
            '<div class="dp-plan-out" data-plan-out aria-live="polite"></div>' +
          "</div>" +
        "</div>" +
        '<div class="dp-actions">' +
          '<button type="button" class="btn btn-outline btn-sm" data-save>Save Preview Picture</button>' +
          '<button type="button" class="btn btn-outline btn-sm" data-copy-list>Copy shopping list</button>' +
          '<button type="button" class="btn btn-outline btn-sm" data-to-journal>Track it in my journal</button>' +
          '<a class="btn btn-outline btn-sm" href="' + esc(cfg.designUrl) + '">Love it? Send us a kit idea</a>' +
        "</div>" +
        '<h3 class="dp-h3">Color list <small>(' + res.pal.length + ' colors, most used first)</small></h3>' +
        '<div class="dp-legend-head" aria-hidden="true"><span>Color</span><span>Drills</span><span>With spares</span><span>Bags</span></div>' +
        '<div class="dp-legend">' + res.pal.map(function (p, i) {
          return '<div class="dp-legend-row"><span class="dp-sym">' + esc(p.sym) + '</span><i class="dp-sw" style="background:' + p.d.hex + '"></i>' +
            '<span class="dp-legend-name"><strong>DMC ' + esc(p.d.code) + "</strong>" + esc(p.d.name) + "</span>" +
            '<span class="dp-legend-count" title="Drills">' + fmt(p.count) + "</span>" +
            '<span class="dp-legend-count dp-legend-spare" data-spare-' + i + ' title="Drills with spares"></span>' +
            '<span class="dp-legend-bags" data-bags-' + i + ' title="Bags"></span></div>';
        }).join("") + "</div>" +
        '<p class="dp-fine">Preview colors are approximate: real drills sparkle and vary a little by batch and screen. Time is a rough guide; everyone\'s pace is different.</p>';

      function plan() {
        var spare = calc.spare, bag = Math.max(1, +calc.bag || 200), pace = PACES.filter(function (p) { return p[0] === calc.pace; })[0];
        var withSpare = 0, bags = 0;
        res.pal.forEach(function (p, i) {
          var need = Math.ceil(p.count * (1 + spare / 100)), b = Math.max(1, Math.ceil(need / bag));
          p.need = need; p.bags = b;
          withSpare += need; bags += b;
          box.querySelector("[data-spare-" + i + "]").textContent = fmt(need);
          box.querySelector("[data-bags-" + i + "]").textContent = b + (b === 1 ? " bag" : " bags");
        });
        var hours = total / +calc.pace, evenings = Math.max(1, Math.round(hours / 2));
        var hTxt = hours < 1 ? "under 1 hour" : hours < 10 ? (Math.round(hours * 2) / 2) + " hours" : fmt(hours) + " hours";
        $("[data-p-spare-out]", box).textContent = spare + "%";
        $("[data-p-pace-help]", box).textContent = pace[2] + ".";
        $("[data-plan-out]", box).innerHTML =
          '<div class="dp-stats">' +
            stat(fmt(withSpare), "drills with " + spare + "% spares") +
            stat(fmt(bags), "bags of " + fmt(bag) + " (at least 1 per color)") +
            stat(hTxt, "at a " + pace[1].toLowerCase() + " pace") +
            stat(evenings, "cozy evening" + (evenings === 1 ? "" : "s") + " of 2 hours") +
          "</div>";
      }
      box.addEventListener("input", function (e) {
        var key = e.target.getAttribute("data-p");
        if (!key) return;
        calc[key] = +e.target.value;
        plan();
      });
      box.addEventListener("click", function (e) {
        var b = e.target.closest('[data-seg="ppace"]');
        if (!b) return;
        calc.pace = b.getAttribute("data-val");
        $$('[data-seg="ppace"]', box).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
        plan();
      });
      plan();
      setupWall(box, res, size);
      photo.sizeText = size;
      $("[data-save]", box).addEventListener("click", function () {
        // A large, sharp copy for saving (the on-screen preview is smaller)
        var cv = document.createElement("canvas"), cell = clamp(Math.ceil(3600 / res.cols), photo.symbols || photo.view === "printed" ? 18 : 8, 30);
        while (cell > 8 && res.cols * res.rows * cell * cell > 36e6) cell--;
        cv.width = res.cols * cell; cv.height = res.rows * cell;
        var cx = cv.getContext("2d");
        if (photo.view === "original") { cx.imageSmoothingQuality = "high"; cx.drawImage(photo.src, 0, 0, cv.width, cv.height); }
        else if (photo.view === "printed") drawPrinted(cx, res, cell, photo.shape, photo.src);
        else drawDrills(cx, res, cell, photo.shape, photo.symbols, photo.view === "flat");
        cv.toBlob(function (b) {
          if (!b) return;
          var a = document.createElement("a");
          a.href = URL.createObjectURL(b); a.download = "my-diamond-painting-preview.png";
          document.body.appendChild(a); a.click(); a.remove();
          setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
        }, "image/png");
      });
      $("[data-to-journal]", box).addEventListener("click", function () {
        var p = newProject({ name: (photo.name && photo.name !== "sample" ? photo.name.replace(/\.[^.]+$/, "") : "My photo painting").slice(0, 60), kit: "Photo to Drills design", size: size + ", " + photo.shape + " drills", total: total, colors: res.pal.length, photos: [thumbFrom($("[data-canvas]", body), 480)] });
        journalView.open = p.id;
        open("sparkle-journal", true);
      });
      $("[data-copy-list]", box).addEventListener("click", function (e) {
        var btn = e.currentTarget;
        var lines = res.pal.map(function (p) {
          return "Symbol " + p.sym + " · DMC " + p.d.code + " " + p.d.name + ": " + fmt(p.count) + " drills (" + fmt(p.need) + " with spares, " + p.bags + (p.bags === 1 ? " bag)" : " bags)");
        });
        copyText(btn, "My diamond painting: " + size + ", " + (photo.shape === "round" ? "round" : "square") + " drills, " + fmt(total) + " drills in " + res.pal.length + " DMC colors\n" + lines.join("\n"), "Copy shopping list");
      });
    }
  }
  function seg(key, opts, cur) {
    return '<div class="dp-seg" role="group">' + opts.map(function (o) {
      return '<button type="button" data-seg="' + key + '" data-val="' + o[0] + '" aria-pressed="' + (o[0] === cur) + '">' + o[1] + "</button>";
    }).join("") + "</div>";
  }
  function stat(big, small) { return '<div class="dp-stat"><strong>' + big + "</strong><span>" + small + "</span></div>"; }

  /* ---------- Photo to Drills engine ----------
     1. prepare(): shrink the photo to one value per drill (true area average in linear light), then
        optional auto-levels, brightness / contrast / saturation and a gentle sharpen, ending in CIE Lab.
     2. choosePalette(): weighted k-means in Lab (pixels on edges count more, so eyes, outlines and small
        highlights keep their own colors), then each cluster is snapped to a different DMC color and refined.
     3. mapCells(): every drill gets the closest palette color, optionally with soft error
        diffusion for smoother shading; tidy() then replaces stray single drills ("confetti").
     Everything is deterministic: the same photo and settings always give the same chart. */
  var SHADING = { clean: 0, soft: 0.45, smooth: 0.8 };
  function seeded(s) { return function () { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; }; }

  // Color distance: plain Lab distance (CIE76). CIEDE2000 was tried; it is built for tiny differences and
  // made charts duller (e.g. skies lost blue) at the big steps between DMC colors.
  var pdist = dE;
  function prepare(src, cols, rows, opt) {
    var w = src.naturalWidth || src.width, h = src.naturalHeight || src.height;
    var f = clamp(Math.floor(Math.min(w / cols, h / rows)), 1, 4), tw = cols * f, th = rows * f, cur = src;
    while (w / 2 >= tw * 1.5 && h / 2 >= th * 1.5) {
      var hc = document.createElement("canvas");
      hc.width = Math.round(w / 2); hc.height = Math.round(h / 2);
      hc.getContext("2d").drawImage(cur, 0, 0, hc.width, hc.height);
      cur = hc; w = hc.width; h = hc.height;
    }
    var c = document.createElement("canvas"); c.width = tw; c.height = th;
    var x = c.getContext("2d");
    x.fillStyle = "#fff"; x.fillRect(0, 0, tw, th);
    x.imageSmoothingQuality = "high";
    x.drawImage(cur, 0, 0, tw, th);
    var d = x.getImageData(0, 0, tw, th).data, n = cols * rows;
    var LIN = new Float32Array(256); for (var t = 0; t < 256; t++) LIN[t] = lin(t);
    var R = new Float32Array(n), G = new Float32Array(n), B = new Float32Array(n);
    for (var yy = 0; yy < th; yy++) {
      var rowK = ((yy / f) | 0) * cols;
      for (var xx = 0; xx < tw; xx++) {
        var i = (yy * tw + xx) * 4, k = rowK + ((xx / f) | 0);
        R[k] += LIN[d[i]]; G[k] += LIN[d[i + 1]]; B[k] += LIN[d[i + 2]];
      }
    }
    var inv = 1 / (f * f), gam = function (v) { return v <= 0.0031308 ? 12.92 * v : 1.055 * Math.pow(v, 1 / 2.4) - 0.055; };
    for (k = 0; k < n; k++) { R[k] = gam(R[k] * inv); G[k] = gam(G[k] * inv); B[k] = gam(B[k] * inv); }
    // Auto-levels: stretch the tones so the darkest and lightest 0.5% reach (almost) black and white
    var lo = 0, hi = 1;
    if (opt.enhance) {
      var Y = new Float32Array(n);
      for (k = 0; k < n; k++) Y[k] = 0.2126 * R[k] + 0.7152 * G[k] + 0.0722 * B[k];
      Y.sort();
      lo = Math.min(Y[Math.floor(n * 0.005)], 0.1) * 0.6; hi = 1 - (1 - Math.max(Y[Math.floor(n * 0.995)], 0.85)) * 0.6; // 60% of a full stretch
    }
    var scale = 1 / (hi - lo), con = 1 + (opt.contrast || 0) / 100, bri = (opt.bright || 0) / 100 * 0.3;
    var tone = function (v) { v = ((v - lo) * scale - 0.5) * con + 0.5 + bri; return v < 0 ? 0 : v > 1 ? 1 : v; };
    var lab = new Float32Array(n * 3), sat = 1 + (opt.sat || 0) / 100 + (opt.enhance ? 0.06 : 0);
    for (k = 0; k < n; k++) {
      var L = rgbToLab(tone(R[k]) * 255, tone(G[k]) * 255, tone(B[k]) * 255);
      lab[k * 3] = L[0]; lab[k * 3 + 1] = L[1] * sat; lab[k * 3 + 2] = L[2] * sat;
    }
    // Detail: unsharp mask on lightness only, so edges crispen without color fringes
    var amt = (opt.detail || 0) / 100 * 1.4;
    if (amt > 0) {
      var Ls = new Float32Array(n);
      for (k = 0; k < n; k++) Ls[k] = lab[k * 3];
      for (var y = 0; y < rows; y++) for (var x2 = 0; x2 < cols; x2++) {
        var sum = 0, cnt = 0;
        for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) {
          var yy2 = y + dy, xx2 = x2 + dx;
          if (yy2 >= 0 && yy2 < rows && xx2 >= 0 && xx2 < cols) { sum += Ls[yy2 * cols + xx2]; cnt++; }
        }
        var kk = y * cols + x2, v = Ls[kk] + amt * (Ls[kk] - sum / cnt);
        lab[kk * 3] = v < 0 ? 0 : v > 100 ? 100 : v;
      }
    }
    return lab;
  }

  function choosePalette(lab, cols, rows, k) {
    var n = cols * rows, i, j, c;
    // Edge weight: drills where lightness changes quickly (outlines, eyes) count up to 2x
    var wt = new Float32Array(n);
    for (var y = 0; y < rows; y++) for (var x = 0; x < cols; x++) {
      i = y * cols + x;
      var gx = lab[(y * cols + Math.min(cols - 1, x + 1)) * 3] - lab[(y * cols + Math.max(0, x - 1)) * 3];
      var gy = lab[(Math.min(rows - 1, y + 1) * cols + x) * 3] - lab[(Math.max(0, y - 1) * cols + x) * 3];
      wt[i] = 1 + Math.min(1, Math.sqrt(gx * gx + gy * gy) / 20);
    }
    var step = Math.max(1, Math.floor(n / 60000)), S = [];
    for (i = 0; i < n; i += step) S.push(i);
    var m = S.length, rnd = seeded(20261015);
    var sd = function (p, ctr) { var a = lab[p * 3] - ctr[0], b = lab[p * 3 + 1] - ctr[1], e = lab[p * 3 + 2] - ctr[2]; return a * a + b * b + e * e; };
    // Start from the most common DMC colors: match each sampled drill to its nearest DMC color, then fold the
    // least-used colors into their nearest neighbour until k remain (a strong start that keeps big areas exact).
    var cnt = new Map(), near1 = new Map();
    for (j = 0; j < m; j++) {
      var q0 = S[j], key = ((Math.round(lab[q0 * 3]) * 512 + Math.round(lab[q0 * 3 + 1]) + 256) * 512) + Math.round(lab[q0 * 3 + 2]) + 256, d0 = near1.get(key);
      if (!d0) { var bd0 = Infinity, v0 = [lab[q0 * 3], lab[q0 * 3 + 1], lab[q0 * 3 + 2]]; for (var q = 0; q < DMC.length; q++) { var e0 = pdist(v0, DMC[q].lab); if (e0 < bd0) { bd0 = e0; d0 = DMC[q]; } } near1.set(key, d0); }
      cnt.set(d0, (cnt.get(d0) || 0) + wt[q0]);
    }
    var used = Array.from(cnt.keys());
    while (used.length > k) {
      used.sort(function (x, y) { return cnt.get(x) - cnt.get(y); });
      var small = used.shift(), into = used[0], bdm = Infinity;
      for (var u = 0; u < used.length; u++) { var e1 = pdist(small.lab, used[u].lab); if (e1 < bdm) { bdm = e1; into = used[u]; } }
      cnt.set(into, cnt.get(into) + cnt.get(small));
    }
    var centers = used.map(function (d) { return d.lab.slice(); });
    var K = centers.length, asg = new Int16Array(m), sums = new Float64Array(K * 4);
    function assign(list) {
      sums.fill(0);
      for (j = 0; j < m; j++) {
        var q = S[j], best = 0, bd = Infinity;
        for (c = 0; c < list.length; c++) { var e = sd(q, list[c]); if (e < bd) { bd = e; best = c; } }
        asg[j] = best;
        var w2 = wt[q];
        sums[best * 4] += lab[q * 3] * w2; sums[best * 4 + 1] += lab[q * 3 + 1] * w2; sums[best * 4 + 2] += lab[q * 3 + 2] * w2; sums[best * 4 + 3] += w2;
      }
    }
    for (var it = 0; it < 4; it++) {
      assign(centers);
      for (c = 0; c < K; c++) if (sums[c * 4 + 3] > 0) centers[c] = [sums[c * 4] / sums[c * 4 + 3], sums[c * 4 + 1] / sums[c * 4 + 3], sums[c * 4 + 2] / sums[c * 4 + 3]];
    }
    // Snap each cluster to a different DMC color (biggest clusters choose first). Of the 8 DMC colors nearest
    // the cluster's average, it takes the one that best matches the cluster's actual drills. Then refine twice.
    var weights = [];
    function snap() {
      weights = []; for (c = 0; c < K; c++) weights.push(sums[c * 4 + 3]);
      var members = centers.map(function () { return []; });
      for (j = 0; j < m; j++) if (members[asg[j]].length < 400 || rnd() < 0.15) members[asg[j]].push(S[j]);
      var order = centers.map(function (x, ci) { return ci; }).filter(function (ci) { return weights[ci] > 0; }).sort(function (a, b) { return weights[b] - weights[a]; });
      var taken = new Set(), out = [];
      order.forEach(function (ci) {
        var near = [];
        for (var q = 0; q < DMC.length; q++) if (!taken.has(DMC[q])) near.push([pdist(centers[ci], DMC[q].lab), DMC[q]]);
        near.sort(function (a, b) { return a[0] - b[0]; });
        var best = near[0][1], bc = Infinity, mem = members[ci].slice(0, 400);
        near.slice(0, 8).forEach(function (cand) {
          var cost = 0;
          for (var t = 0; t < mem.length; t++) { var p = mem[t]; cost += wt[p] * pdist([lab[p * 3], lab[p * 3 + 1], lab[p * 3 + 2]], cand[1].lab); }
          if (cost < bc) { bc = cost; best = cand[1]; }
        });
        taken.add(best); out.push(best);
      });
      return out;
    }
    var pal = snap();
    for (var rf = 0; rf < 2; rf++) {
      centers = pal.map(function (d) { return d.lab; }); K = centers.length;
      assign(centers);
      for (c = 0; c < K; c++) if (sums[c * 4 + 3] > 0) centers[c] = [sums[c * 4] / sums[c * 4 + 3], sums[c * 4 + 1] / sums[c * 4 + 3], sums[c * 4 + 2] / sums[c * 4 + 3]];
      pal = snap();
    }
    return pal;
  }

  function mapCells(lab, cols, rows, pal, dither) {
    var n = cols * rows, cells = new Int16Array(n), P = pal.length, cache = new Map();
    function best(L, a, b) {
      var key = ((Math.round(L) * 512 + Math.round(a) + 256) * 512) + Math.round(b) + 256, hit = cache.get(key);
      if (hit !== undefined) return hit;
      var bi = 0, bd = Infinity, v = [L, a, b];
      for (var q = 0; q < P; q++) { var e = pdist(v, pal[q].lab); if (e < bd) { bd = e; bi = q; } }
      cache.set(key, bi);
      return bi;
    }
    if (!dither) {
      for (var i = 0; i < n; i++) cells[i] = best(lab[i * 3], lab[i * 3 + 1], lab[i * 3 + 2]);
      return cells;
    }
    // Serpentine Floyd–Steinberg in Lab, softened and capped. Each drill may only pick one of the 3 colors
    // nearest its own true color, so blends stay in the same family (no stray far-off colors).
    var near3 = new Map();
    function cands(i) {
      var L = lab[i * 3], a = lab[i * 3 + 1], b = lab[i * 3 + 2];
      var key = ((Math.round(L) * 512 + Math.round(a) + 256) * 512) + Math.round(b) + 256, hit = near3.get(key);
      if (hit) return hit;
      var v = [L, a, b], list = [];
      for (var q = 0; q < P; q++) list.push([pdist(v, pal[q].lab), q]);
      list.sort(function (x, y) { return x[0] - y[0]; });
      hit = list.slice(0, 3).filter(function (e, z) { return z === 0 || e[0] - list[0][0] < 12; }).map(function (e) { return e[1]; });
      near3.set(key, hit);
      return hit;
    }
    var w = lab.slice(), cap = 18;
    for (var y = 0; y < rows; y++) {
      var ltr = y % 2 === 0;
      for (var s = 0; s < cols; s++) {
        var x = ltr ? s : cols - 1 - s, k = y * cols + x, dir = ltr ? 1 : -1;
        var cl = cands(k), j = cl[0];
        if (cl.length > 1) {
          var tv = [w[k * 3], w[k * 3 + 1], w[k * 3 + 2]], bd = Infinity;
          for (var ci = 0; ci < cl.length; ci++) { var e2 = pdist(tv, pal[cl[ci]].lab); if (e2 < bd) { bd = e2; j = cl[ci]; } }
        }
        cells[k] = j;
        for (var ch = 0; ch < 3; ch++) {
          var err = (w[k * 3 + ch] - pal[j].lab[ch]) * dither;
          err = err > cap ? cap : err < -cap ? -cap : err;
          if (x + dir >= 0 && x + dir < cols) w[(k + dir) * 3 + ch] += err * 7 / 16;
          if (y + 1 < rows) {
            if (x - dir >= 0 && x - dir < cols) w[(k + cols - dir) * 3 + ch] += err * 3 / 16;
            w[(k + cols) * 3 + ch] += err * 5 / 16;
            if (x + dir >= 0 && x + dir < cols) w[(k + cols + dir) * 3 + ch] += err * 1 / 16;
          }
        }
      }
    }
    return cells;
  }

  // Replace a lone drill whose neighbours mostly share one similar color (keeps real details like eye glints)
  function tidy(cells, cols, rows, pal) {
    var out = cells.slice(), tally = new Int16Array(pal.length), touched = [];
    for (var y = 0; y < rows; y++) for (var x = 0; x < cols; x++) {
      var k = y * cols + x, c = cells[k], same = 0, nb = 0;
      touched.length = 0;
      for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) {
        if (!dx && !dy) continue;
        var yy = y + dy, xx = x + dx;
        if (yy < 0 || yy >= rows || xx < 0 || xx >= cols) continue;
        var v = cells[yy * cols + xx]; nb++;
        if (v === c) same++;
        else { if (!tally[v]) touched.push(v); tally[v]++; }
      }
      if (!same) {
        var m = -1, mx = 0;
        for (var t = 0; t < touched.length; t++) if (tally[touched[t]] > mx) { mx = tally[touched[t]]; m = touched[t]; }
        if (m >= 0 && mx >= Math.max(3, Math.ceil(nb / 2)) && pdist(pal[c].lab, pal[m].lab) < 25) out[k] = m;
      }
      for (var u = 0; u < touched.length; u++) tally[touched[u]] = 0;
    }
    return out;
  }

  // Count, sort the colors most-used first and give each a symbol
  function finish(cells, pal, cols, rows) {
    var n = cols * rows, counts = new Int32Array(pal.length);
    for (var i = 0; i < n; i++) counts[cells[i]]++;
    var order = pal.map(function (p, j) { return j; }).filter(function (j) { return counts[j] > 0; }).sort(function (a, b) { return counts[b] - counts[a]; });
    var remap = new Int16Array(pal.length).fill(-1);
    order.forEach(function (oldJ, newJ) { remap[oldJ] = newJ; });
    var out = new Int16Array(n);
    for (i = 0; i < n; i++) out[i] = remap[cells[i]];
    return { cols: cols, rows: rows, cells: out, pal: order.map(function (j, nj) { return { d: pal[j], count: counts[j], sym: SYMBOLS[nj % SYMBOLS.length] }; }) };
  }

  /* ---------- Suggest a size and number of colors for a photo ----------
     Size: the photo is shrunk to each common canvas width (in drills) and compared with a sharp reference
     (up to 400 drills across), over the centre 60% where the subject usually is. How much detail a 30 cm
     (12 in) canvas loses picks the size: 30 / 40 / 50 / 60 cm. Never more drills than the photo has pixels for.
     Colors: at that size, palettes of 10 to 60 colors are tried; we take the fewest whose share of clearly
     off-color drills (> 10 Lab) and average error are close to using 60, kept between 18 and 40. */
  var SIZES_CM = [20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100];
  var SIZES_IN = [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36, 40];
  var SUGGEST_STEPS = [2.6, 4.0, 5.2]; // centre detail thresholds for 30 / 40 / 50 / 60 cm (12 / 16 / 20 / 24 in)
  function suggestSettings(src, opt) {
    var w = src.naturalWidth || src.width, h = src.naturalHeight || src.height, aspect = h / w;
    var inch = opt.unit === "in", sizes = inch ? SIZES_IN : SIZES_CM, toMm = inch ? 25.4 : 10, pitch = PITCH[opt.shape];
    var refCols = Math.min(400, Math.round(w)), refRows = Math.max(1, Math.round(refCols * aspect));
    var ref = prepare(src, refCols, refRows, { enhance: false, detail: 0 });
    function loss(cols) { // average color difference between the reference and its drill-sized version
      var rows = Math.max(1, Math.round(cols * aspect)), acc = new Float64Array(cols * rows * 4), x, y, k, i;
      var mapX = new Int32Array(refCols), mapY = new Int32Array(refRows);
      for (x = 0; x < refCols; x++) mapX[x] = Math.min(cols - 1, Math.floor(x * cols / refCols));
      for (y = 0; y < refRows; y++) mapY[y] = Math.min(rows - 1, Math.floor(y * rows / refRows));
      for (y = 0; y < refRows; y++) for (x = 0; x < refCols; x++) {
        k = (mapY[y] * cols + mapX[x]) * 4; i = (y * refCols + x) * 3;
        acc[k] += ref[i]; acc[k + 1] += ref[i + 1]; acc[k + 2] += ref[i + 2]; acc[k + 3]++;
      }
      var sum = 0, cnt0 = 0, y0 = Math.floor(refRows * 0.2), y1 = Math.ceil(refRows * 0.8), x0 = Math.floor(refCols * 0.2), x1 = Math.ceil(refCols * 0.8);
      for (y = y0; y < y1; y++) for (x = x0; x < x1; x++) {
        k = (mapY[y] * cols + mapX[x]) * 4; i = (y * refCols + x) * 3; cnt0++;
        var n = acc[k + 3], a = ref[i] - acc[k] / n, b = ref[i + 1] - acc[k + 1] / n, c = ref[i + 2] - acc[k + 2] / n;
        sum += Math.sqrt(a * a + b * b + c * c);
      }
      return sum / cnt0;
    }
    // Candidate sizes: enough photo pixels per drill (1.5+) and within the tool's limit
    var cands = sizes.map(function (s) {
      var cols = Math.max(10, Math.round(s * toMm / pitch)), rows = Math.max(10, Math.round(cols * aspect));
      return { size: s, cols: cols, rows: rows };
    }).filter(function (c) { return c.cols <= w / 1.5 && c.cols * c.rows <= MAX_CELLS; });
    if (!cands.length) cands = [{ size: sizes[0], cols: Math.max(10, Math.round(sizes[0] * toMm / pitch)) }];
    cands.forEach(function (c) { c.loss = loss(c.cols); });
    var base = inch ? 12 : 30, at30 = cands.filter(function (c) { return c.size === base; })[0], busy = at30 ? at30.loss : loss(Math.round(base * toMm / pitch));
    var level = busy < SUGGEST_STEPS[0] ? 0 : busy < SUGGEST_STEPS[1] ? 1 : busy < SUGGEST_STEPS[2] ? 2 : 3;
    var want = inch ? [12, 16, 20, 24][level] : [30, 40, 50, 60][level];
    var fits = cands.filter(function (c) { return c.size <= want; });
    var pick = fits[fits.length - 1] || cands[0], limited = pick.size < want;
    // Colors at that size, with the visitor's own photo settings
    var rowsP = Math.max(10, Math.round(pick.cols * aspect)), lab = prepare(src, pick.cols, rowsP, opt), n = pick.cols * rowsP;
    var step = Math.max(1, Math.floor(n / 20000)), errs = [];
    [10, 14, 18, 22, 26, 30, 36, 44, 52, 60].forEach(function (kk) {
      var pal = choosePalette(lab, pick.cols, rowsP, kk), sum = 0, cnt = 0, bad = 0;
      for (var i = 0; i < n; i += step) {
        var v = [lab[i * 3], lab[i * 3 + 1], lab[i * 3 + 2]], bd = Infinity;
        for (var q = 0; q < pal.length; q++) { var e = pdist(v, pal[q].lab); if (e < bd) bd = e; }
        sum += bd; cnt++; if (bd > 10) bad++;
      }
      errs.push({ k: kk, err: sum / cnt, bad: bad / cnt });
    });
    var last = errs[errs.length - 1], ok = errs.filter(function (e) { return e.bad <= last.bad + 0.02 && e.err <= last.err + 0.8; })[0];
    var colors = clamp(ok ? ok.k : 30, 18, 40);
    return {
      size: pick.size, colors: colors, limited: limited,
      detail: ["low", "medium", "high", "high"][level]
    };
  }

  function convert(src, cols, rows, opt) {
    var lab = prepare(src, cols, rows, opt);
    var pal = choosePalette(lab, cols, rows, opt.colors);
    var cells = mapCells(lab, cols, rows, pal, SHADING[opt.shading] || 0);
    if (opt.tidy) cells = tidy(cells, cols, rows, pal);
    return finish(cells, pal, cols, rows);
  }

  /* ---------- Drawing ---------- */
  // One small picture per color, reused for every drill: faceted square drills or domed round ones
  function drillSprite(hex, cell, shape) {
    var c = document.createElement("canvas"); c.width = c.height = cell;
    var x = c.getContext("2d"), g = Math.max(0.5, cell * 0.06), s = cell - 2 * g;
    var rgb = hexToRgb(hex);
    x.fillStyle = "rgb(" + Math.round(rgb[0] * 0.45) + "," + Math.round(rgb[1] * 0.45) + "," + Math.round(rgb[2] * 0.45) + ")";
    x.fillRect(0, 0, cell, cell);
    var poly = function (pts, fill) { x.fillStyle = fill; x.beginPath(); x.moveTo(pts[0], pts[1]); for (var i = 2; i < pts.length; i += 2) x.lineTo(pts[i], pts[i + 1]); x.closePath(); x.fill(); };
    if (shape === "round") {
      var r = s / 2, cx = cell / 2;
      x.fillStyle = hex; x.beginPath(); x.arc(cx, cx, r, 0, 6.2832); x.fill();
      var rg = x.createRadialGradient(cx - r * 0.35, cx - r * 0.4, r * 0.1, cx, cx, r);
      rg.addColorStop(0, "rgba(255,255,255,.42)"); rg.addColorStop(0.5, "rgba(255,255,255,.06)"); rg.addColorStop(1, "rgba(0,0,0,.26)");
      x.fillStyle = rg; x.beginPath(); x.arc(cx, cx, r, 0, 6.2832); x.fill();
      if (cell >= 9) { x.strokeStyle = "rgba(255,255,255,.2)"; x.lineWidth = Math.max(0.5, cell * 0.04); x.beginPath(); x.arc(cx, cx, r * 0.55, 0, 6.2832); x.stroke(); }
    } else {
      var a = g, b = g + s, i0 = g + s * 0.28, i1 = g + s * 0.72;
      x.fillStyle = hex; x.fillRect(a, a, s, s);
      poly([a, a, b, a, i1, i0, i0, i0], "rgba(255,255,255,.28)"); // top facet
      poly([a, a, i0, i0, i0, i1, a, b], "rgba(255,255,255,.12)"); // left
      poly([b, a, b, b, i1, i1, i1, i0], "rgba(0,0,0,.12)");       // right
      poly([a, b, i0, i1, i1, i1, b, b], "rgba(0,0,0,.24)");       // bottom
      x.fillStyle = "rgba(255,255,255,.07)"; x.fillRect(i0, i0, i1 - i0, i1 - i0);
    }
    if (cell >= 9) { x.fillStyle = "rgba(255,255,255,.75)"; x.beginPath(); x.arc(g + s * 0.3, g + s * 0.27, Math.max(0.6, cell * 0.06), 0, 6.2832); x.fill(); }
    return c;
  }
  // "Printed Canvas" view: what the blank canvas looks like before drills go on. The picture is printed across the
  // canvas (so you can see the image around the spots) and every drill spot is a white square or circle with its
  // symbol. All white spots go in one path and all symbols are batched, so even big charts draw quickly.
  function drawPrinted(ctx, res, cell, shape, src) {
    var W = res.cols * cell, H = res.rows * cell, sz = cell * 0.74, off = (cell - sz) / 2, x, y;
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(src, 0, 0, W, H);
    ctx.fillStyle = "rgba(255,255,255,.95)";
    ctx.beginPath();
    for (y = 0; y < res.rows; y++) for (x = 0; x < res.cols; x++) {
      if (shape === "round") { ctx.moveTo(x * cell + cell / 2 + sz / 2, y * cell + cell / 2); ctx.arc(x * cell + cell / 2, y * cell + cell / 2, sz / 2, 0, 6.2832); }
      else ctx.rect(x * cell + off, y * cell + off, sz, sz);
    }
    ctx.fill();
    ctx.font = "800 " + Math.max(6, Math.round(cell * 0.5)) + "px Nunito, Arial, sans-serif";
    ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.fillStyle = "#1b2a35";
    for (y = 0; y < res.rows; y++) for (x = 0; x < res.cols; x++) ctx.fillText(res.pal[res.cells[y * res.cols + x]].sym, x * cell + cell / 2, y * cell + cell / 2 + 1);
  }
  // view "drills" = realistic drills; "flat" (shown as "True DMC") = each drill in its exact DMC color,
  // with thin light lines between drills like a classic chart
  function drawDrills(ctx, res, cell, shape, symbols, flat) {
    var W = res.cols * cell, H = res.rows * cell;
    if (flat && cell >= 6) {
      var gap = Math.max(0.6, cell * 0.04), r = cell / 2 - gap;
      ctx.fillStyle = "#e3e9ed"; ctx.fillRect(0, 0, W, H);
      for (var fy = 0; fy < res.rows; fy++) for (var fx = 0; fx < res.cols; fx++) {
        ctx.fillStyle = res.pal[res.cells[fy * res.cols + fx]].d.hex;
        if (shape === "round") { ctx.beginPath(); ctx.arc(fx * cell + cell / 2, fy * cell + cell / 2, r, 0, 6.2832); ctx.fill(); }
        else ctx.fillRect(fx * cell + gap, fy * cell + gap, cell - gap * 2, cell - gap * 2);
      }
    } else if (flat || cell < 5) {
      var small = document.createElement("canvas"); small.width = res.cols; small.height = res.rows;
      var sx = small.getContext("2d"), img = sx.createImageData(res.cols, res.rows), rgbs = res.pal.map(function (p) { return p.d.rgb; });
      for (var i = 0; i < res.cells.length; i++) { var c = rgbs[res.cells[i]]; img.data[i * 4] = c[0]; img.data[i * 4 + 1] = c[1]; img.data[i * 4 + 2] = c[2]; img.data[i * 4 + 3] = 255; }
      sx.putImageData(img, 0, 0);
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(small, 0, 0, W, H);
      ctx.imageSmoothingEnabled = true;
    } else {
      var sprites = res.pal.map(function (p) { return drillSprite(p.d.hex, cell, shape); });
      for (var y = 0; y < res.rows; y++) for (var x = 0; x < res.cols; x++) ctx.drawImage(sprites[res.cells[y * res.cols + x]], x * cell, y * cell);
    }
    if (symbols) {
      ctx.font = "700 " + Math.round(cell * 0.6) + "px Nunito, sans-serif";
      ctx.textAlign = "center"; ctx.textBaseline = "middle";
      for (var yy = 0; yy < res.rows; yy++) {
        for (var xx = 0; xx < res.cols; xx++) {
          var q = res.pal[res.cells[yy * res.cols + xx]];
          ctx.fillStyle = q.d.lab[0] > 60 ? "rgba(18,52,71,.85)" : "rgba(255,255,255,.92)";
          ctx.fillText(q.sym, xx * cell + cell / 2, yy * cell + cell / 2 + 1);
        }
      }
    }
  }

  /* ---------- "See it on your wall or desk" ----------
     The finished painting (drawn as real drills, with an optional frame) placed on a background: the built-in
     sample room, a photo the visitor chooses, or their live camera (the video is drawn into the same canvas,
     so the painting and markers sit on top while they aim, then "Take photo" freezes it).
     Size: "Free size" (slider / pinch) or "True to size": the visitor drags two markers to the top and bottom
     of something with a known height (floor to ceiling 8 ft, a door, a desk...), which gives pixels per cm,
     so the painting is drawn at its real width. Measurements can be shown on the picture.
     Everything stays on the device. Settings survive re-runs of the converter. */
  var wall = { bg: null, sample: true, x: 0.5, y: 0.31, size: 0.3, frame: "wood", stream: null, live: false, video: null,
    mode: "true", showSize: true, ref: "ceil8", custom: 100, a: [0.08, 0.02], b: [0.08, 0.755], lum: 0.75 };
  var FRAMES = [["none", "None"], ["black", "Black"], ["white", "White"], ["wood", "Wood"]];
  // Typical heights in cm (US homes); "short" is the label drawn on the marker line
  var REFS = [
    ["ceil8", "Floor to ceiling (8 ft room)", 243.84, "8 ft"],
    ["ceil9", "Floor to ceiling (9 ft room)", 274.32, "9 ft"],
    ["door", "Interior door (6 ft 8 in)", 203.2, "6 ft 8 in"],
    ["counter", "Floor to kitchen counter top (36 in)", 91.44, "36 in"],
    ["desk", "Floor to desk or table top (30 in)", 76.2, "30 in"],
    ["paper", "Letter paper, long side (11 in)", 27.94, "11 in"],
    ["custom", "Something else (type its height)", null, ""]
  ];
  function refOf(id) { return REFS.filter(function (r) { return r[0] === id; })[0] || REFS[0]; }
  function refCm() {
    var r = refOf(wall.ref);
    if (r[2]) return r[2];
    return Math.max(1, +wall.custom || 1) * (photo.unit === "in" ? 2.54 : 1);
  }
  function lenLabel(cm) {
    if (photo.unit === "in") { var inch = cm / 2.54; return (Math.round(inch * 10) / 10) + " in"; }
    return (Math.round(cm * 10) / 10) + " cm";
  }

  function wallHtml() {
    return '<section class="dp-wall" data-wall>' +
      '<h3 class="dp-h3">See it on your wall or desk</h3>' +
      '<p class="dp-help">Take a photo of the spot where it will hang or stand, then drag the painting into place. Your photo stays on your device.</p>' +
      '<div class="dp-wall-actions">' +
        '<button type="button" class="btn btn-primary btn-sm" data-wall-cam>Use my camera</button>' +
        '<label class="btn btn-outline btn-sm dp-file-btn">Choose a photo<input type="file" accept="image/*" data-wall-file hidden></label>' +
        '<input type="file" accept="image/*" capture="environment" data-wall-capture hidden>' +
        '<button type="button" class="dp-link-btn" data-wall-sample>Sample room</button>' +
      "</div>" +
      '<div class="dp-wall-stage" data-wall-stage><canvas data-wall-canvas aria-label="Your painting shown on a wall. Drag to move it." role="img"></canvas>' +
        '<video playsinline muted autoplay class="dp-wall-video" data-wall-video></video></div>' +
      '<div class="dp-wall-cam-bar" data-wall-live hidden><button type="button" class="btn btn-primary btn-sm" data-wall-snap>Take photo</button><button type="button" class="btn btn-outline btn-sm" data-wall-stop>Cancel</button></div>' +
      '<div class="dp-wall-controls">' +
        '<div class="dp-fieldset"><span class="dp-label">Painting size</span>' + seg("wsize", [["true", "True to size"], ["free", "Free size"]], wall.mode) + "</div>" +
        '<div class="dp-fieldset"><span class="dp-label">Frame</span>' + seg("frame", FRAMES, wall.frame) + "</div>" +
        '<div class="dp-fieldset dp-wall-free" data-wall-free><label class="dp-label" for="dp-wall-size">Size on the photo</label>' +
          '<input id="dp-wall-size" class="dp-range" type="range" min="4" max="90" step="1" data-wall-size></div>' +
        '<div class="dp-wall-true" data-wall-true hidden>' +
          '<div class="dp-fieldset"><label class="dp-label" for="dp-wall-ref">Something in your photo with a known height</label>' +
            '<select id="dp-wall-ref" class="dp-input" data-wall-ref>' + REFS.map(function (r) { return '<option value="' + r[0] + '"' + (r[0] === wall.ref ? " selected" : "") + ">" + r[1] + "</option>"; }).join("") + "</select>" +
            '<div class="dp-inline dp-wall-custom" data-wall-custom hidden><input class="dp-input dp-num" type="number" min="1" max="2000" step="0.5" data-wall-custom-in aria-label="Height of your reference"><span data-wall-custom-unit></span></div>' +
          "</div>" +
          '<p class="dp-help">Drag the two pink markers to the top and bottom of it (for example the floor and the ceiling). It is most accurate when your reference is on the same wall, about as far from the camera as the painting.</p>' +
        "</div>" +
        '<label class="dp-check"><input type="checkbox" data-wall-measure' + (wall.showSize ? " checked" : "") + "> Show measurements</label>" +
        '<div class="dp-actions"><button type="button" class="btn btn-outline btn-sm" data-wall-save>Save this picture</button>' +
          '<button type="button" class="btn btn-outline btn-sm" data-wall-share hidden>Share</button></div>' +
      "</div>" +
      '<p class="dp-fine" data-wall-note></p>' +
    "</section>";
  }

  function setupWall(box, res, sizeText) {
    var sec = $("[data-wall]", box), cv = $("[data-wall-canvas]", sec), ctx = cv.getContext("2d");
    var sizeIn = $("[data-wall-size]", sec), note = $("[data-wall-note]", sec), liveBar = $("[data-wall-live]", sec), video = $("[data-wall-video]", sec);
    var customIn = $("[data-wall-custom-in]", sec), art = null, ptrs = {}, drag = null, raf = 0, frame = 0;
    if (wall.stream) { wall.stream.getTracks().forEach(function (t) { t.stop(); }); wall.stream = null; wall.live = false; } // a re-run replaces this panel
    var wCm = res.widthMm / 10, hCm = wCm * res.rows / res.cols;
    sizeIn.value = Math.round(wall.size * 100);
    customIn.value = wall.custom;
    $("[data-wall-custom-unit]", sec).textContent = photo.unit;
    note.textContent = "Your painting will be about " + sizeText + ".";

    // The painting itself, drawn once as real drills
    var cellA = clamp(Math.floor(1300 / res.cols), 2, 12);
    art = document.createElement("canvas"); art.width = res.cols * cellA; art.height = res.rows * cellA;
    drawDrills(art.getContext("2d"), res, cellA, photo.shape, false, false);

    function srcSize() {
      if (wall.live && video.videoWidth) return [video.videoWidth, video.videoHeight];
      var b = wall.bg || (wall.bg = sampleRoom(), wall.sample = true, wall.bg);
      return [b.naturalWidth || b.width, b.naturalHeight || b.height];
    }
    function ppcm() { // pixels per cm on the canvas, from the two markers
      var dx = (wall.a[0] - wall.b[0]) * cv.width, dy = (wall.a[1] - wall.b[1]) * cv.height;
      return Math.max(0.05, Math.sqrt(dx * dx + dy * dy) / refCm());
    }
    function rect() { // painting position on the canvas, including its frame
      var W = cv.width, pw = wall.mode === "true" ? wCm * ppcm() : W * wall.size, ph = pw * res.rows / res.cols;
      var fr = wall.frame === "none" ? 0 : pw * (wall.frame === "white" ? 0.09 : 0.05);
      return { x: wall.x * W - pw / 2 - fr, y: wall.y * cv.height - ph / 2 - fr, w: pw + fr * 2, h: ph + fr * 2, pw: pw, ph: ph, fr: fr };
    }
    function pill(text, x, y, fs, align) {
      ctx.font = "800 " + fs + "px Nunito, Arial, sans-serif";
      var tw = ctx.measureText(text).width, pad = fs * 0.45, h = fs * 1.5, left = align === "left" ? x : align === "right" ? x - tw - pad * 2 : x - tw / 2 - pad;
      ctx.fillStyle = "rgba(18,52,71,.88)";
      ctx.beginPath(); if (ctx.roundRect) ctx.roundRect(left, y - h / 2, tw + pad * 2, h, h / 2); else ctx.rect(left, y - h / 2, tw + pad * 2, h); ctx.fill();
      ctx.fillStyle = "#fff"; ctx.textBaseline = "middle"; ctx.textAlign = "left";
      ctx.fillText(text, left + pad, y + fs * 0.05);
    }
    function dimLine(x1, y1, x2, y2, t) {
      ctx.strokeStyle = "rgba(255,255,255,.95)"; ctx.lineWidth = t + 2; ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
      ctx.strokeStyle = "#123447"; ctx.lineWidth = t; ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
      var nx = y2 - y1, ny = x1 - x2, nl = Math.hypot(nx, ny) || 1, k = t * 4;
      nx = nx / nl * k; ny = ny / nl * k;
      [[x1, y1], [x2, y2]].forEach(function (p) { ctx.beginPath(); ctx.moveTo(p[0] - nx, p[1] - ny); ctx.lineTo(p[0] + nx, p[1] + ny); ctx.stroke(); });
    }
    function render() {
      var s = srcSize(), scale = Math.min(1, 1600 / Math.max(s[0], s[1])), W = Math.round(s[0] * scale), H = Math.round(s[1] * scale);
      if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; }
      ctx.drawImage(wall.live && video.videoWidth ? video : wall.bg, 0, 0, W, H);
      var r = rect();
      // Room brightness where the painting sits, so it isn't brighter than the wall around it (every 10th live frame)
      if (!wall.live || frame++ % 10 === 0) {
        try {
          var sx = clamp(Math.round(r.x), 0, W - 1), sy = clamp(Math.round(r.y), 0, H - 1), sw = clamp(Math.round(r.w), 1, W - sx), sh = clamp(Math.round(r.h), 1, H - sy);
          var d = ctx.getImageData(sx, sy, sw, sh).data, tot = 0, n = 0;
          for (var i = 0; i < d.length; i += 4 * 37) { tot += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]; n++; }
          if (n) wall.lum = tot / n / 255;
        } catch (e) { /* ignore */ }
      }
      ctx.save();
      ctx.shadowColor = "rgba(0,0,0,.38)"; ctx.shadowBlur = r.w * 0.04; ctx.shadowOffsetY = r.w * 0.018; ctx.shadowOffsetX = r.w * 0.006;
      if (wall.frame === "none") { ctx.fillStyle = "#222"; ctx.fillRect(r.x, r.y, r.w, r.h); }
      else if (wall.frame === "black") { ctx.fillStyle = "#1c1c1e"; ctx.fillRect(r.x, r.y, r.w, r.h); }
      else if (wall.frame === "white") { ctx.fillStyle = "#f6f4ef"; ctx.fillRect(r.x, r.y, r.w, r.h); }
      else {
        var g = ctx.createLinearGradient(r.x, r.y, r.x + r.w, r.y + r.h);
        g.addColorStop(0, "#a8774a"); g.addColorStop(0.5, "#8a5a33"); g.addColorStop(1, "#6e4526");
        ctx.fillStyle = g; ctx.fillRect(r.x, r.y, r.w, r.h);
      }
      ctx.restore();
      if (wall.frame !== "none") { // a little bevel so the frame reads as 3D
        ctx.strokeStyle = "rgba(255,255,255,.25)"; ctx.lineWidth = Math.max(1, r.fr * 0.12); ctx.strokeRect(r.x + ctx.lineWidth / 2, r.y + ctx.lineWidth / 2, r.w - ctx.lineWidth, r.h - ctx.lineWidth);
        ctx.strokeStyle = "rgba(0,0,0,.28)"; ctx.lineWidth = Math.max(1, r.fr * 0.1); ctx.strokeRect(r.x + r.fr, r.y + r.fr, r.pw, r.ph);
      }
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(art, r.x + r.fr, r.y + r.fr, r.pw, r.ph);
      var dim = clamp((0.72 - wall.lum) * 0.55, 0, 0.28);
      if (dim > 0) { ctx.fillStyle = "rgba(0,0,0," + dim.toFixed(3) + ")"; ctx.fillRect(r.x, r.y, r.w, r.h); }
      var sh2 = ctx.createLinearGradient(r.x, r.y, r.x + r.w, r.y + r.h);
      sh2.addColorStop(0, "rgba(255,255,255,.12)"); sh2.addColorStop(0.45, "rgba(255,255,255,0)"); sh2.addColorStop(1, "rgba(0,0,0,.06)");
      ctx.fillStyle = sh2; ctx.fillRect(r.x + r.fr, r.y + r.fr, r.pw, r.ph);

      // Labels and lines sized for the screen too (readable on phones), capped so saved pictures stay tidy
      var k = cssScale(), fs = Math.round(Math.min(Math.max(clamp(W * 0.017, 13, 30), 12 * k), W * 0.04)), t = Math.min(Math.max(1.5, W * 0.0018, 1.2 * k), W * 0.004);
      if (wall.showSize) { // width above the frame, height to the right of it (painted area, without the frame)
        var px0 = r.x + r.fr, px1 = px0 + r.pw, py0 = r.y + r.fr, py1 = py0 + r.ph, off = fs * 0.9;
        dimLine(px0, r.y - off, px1, r.y - off, t);
        pill(lenLabel(wCm), (px0 + px1) / 2, r.y - off - fs * 1.05, fs);
        dimLine(r.x + r.w + off, py0, r.x + r.w + off, py1, t);
        pill(lenLabel(hCm), r.x + r.w + off + fs * 0.6, (py0 + py1) / 2, fs, "left");
      }
      if (wall.mode === "true") { // the reference markers
        var ax = wall.a[0] * W, ay = wall.a[1] * H, bx = wall.b[0] * W, by = wall.b[1] * H, rad = markerR();
        ctx.save(); ctx.setLineDash([fs * 0.6, fs * 0.4]);
        ctx.strokeStyle = "#fff"; ctx.lineWidth = t + 2.5; ctx.beginPath(); ctx.moveTo(ax, ay); ctx.lineTo(bx, by); ctx.stroke();
        ctx.strokeStyle = "#f07cae"; ctx.lineWidth = t + 0.5; ctx.beginPath(); ctx.moveTo(ax, ay); ctx.lineTo(bx, by); ctx.stroke();
        ctx.restore();
        [[ax, ay], [bx, by]].forEach(function (p) {
          ctx.fillStyle = "#f07cae"; ctx.strokeStyle = "#fff"; ctx.lineWidth = Math.max(2, rad * 0.25);
          ctx.beginPath(); ctx.arc(p[0], p[1], rad, 0, 6.2832); ctx.fill(); ctx.stroke();
          ctx.fillStyle = "#fff"; ctx.beginPath(); ctx.arc(p[0], p[1], rad * 0.3, 0, 6.2832); ctx.fill();
        });
        var ref = refOf(wall.ref), lbl = ref[3] || lenLabel(refCm());
        pill(lbl, (ax + bx) / 2 + rad * 1.4, (ay + by) / 2, fs, "left");
      }
    }
    function cssScale() { var w = cv.getBoundingClientRect().width; return w ? cv.width / w : 1; } // canvas px per screen px
    function markerR() { return Math.max(clamp(cv.width * 0.014, 9, 22), 11 * cssScale()); }
    function loop() { render(); if (wall.live) raf = requestAnimationFrame(loop); }
    function setBg(img, isSample, keepPos) {
      // Phone photos are huge: keep a copy no bigger than 2000 px
      var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height, k = Math.min(1, 2000 / Math.max(w, h));
      var c = document.createElement("canvas"); c.width = Math.round(w * k); c.height = Math.round(h * k);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      wall.bg = c; wall.sample = !!isSample;
      if (!keepPos) {
        wall.x = 0.5; wall.y = isSample ? 0.31 : 0.42;
        if (isSample) { wall.a = [0.08, 0.02]; wall.b = [0.08, 0.755]; wall.ref = "ceil8"; } // the sample room's wall is 8 ft from ceiling to floor
        else { wall.a = [0.1, 0.12]; wall.b = [0.1, 0.88]; }
        $("[data-wall-ref]", sec).value = wall.ref;
      }
      render();
    }
    function loadFile(file) {
      if (!file || !/^image\//.test(file.type)) return;
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () { stopCam(); setBg(img, false); URL.revokeObjectURL(url); sec.scrollIntoView({ behavior: "smooth", block: "start" }); };
      img.src = url;
    }
    function stopCam() {
      if (wall.stream) wall.stream.getTracks().forEach(function (t) { t.stop(); });
      wall.stream = null; wall.live = false; cancelAnimationFrame(raf); liveBar.hidden = true; video.srcObject = null;
    }
    function syncMode() {
      $("[data-wall-free]", sec).hidden = wall.mode !== "free";
      $("[data-wall-true]", sec).hidden = wall.mode !== "true";
      $("[data-wall-custom]", sec).hidden = wall.ref !== "custom";
      note.textContent = "Your painting will be about " + sizeText + "." + (wall.mode === "true" ? " With True to size it is drawn at that real size, measured from your reference." : " Move and resize it to match your photo, or choose True to size.");
    }

    sec.addEventListener("change", function (e) {
      var t = e.target;
      if (t.matches("[data-wall-file], [data-wall-capture]")) { loadFile(t.files[0]); t.value = ""; }
      else if (t.matches("[data-wall-ref]")) { wall.ref = t.value; syncMode(); render(); }
      else if (t.matches("[data-wall-measure]")) { wall.showSize = t.checked; render(); }
    });
    sec.addEventListener("input", function (e) {
      if (e.target === sizeIn) { wall.size = +sizeIn.value / 100; render(); }
      else if (e.target === customIn) { wall.custom = +customIn.value; render(); }
    });
    sec.addEventListener("click", function (e) {
      var t = e.target;
      if (t.closest("[data-wall-sample]")) { stopCam(); setBg(sampleRoom(), true); return; }
      if (t.closest("[data-wall-cam]")) {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { $("[data-wall-capture]", sec).click(); return; }
        navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment", width: { ideal: 1920 }, height: { ideal: 1080 } }, audio: false }).then(function (st) {
          stopCam();
          wall.stream = st; video.srcObject = st; wall.live = true; liveBar.hidden = false;
          if (video.play) video.play().catch(function () {});
          wall.x = 0.5; wall.y = 0.42; wall.a = [0.1, 0.12]; wall.b = [0.1, 0.88];
          var wait = function () { if (!wall.live) return; if (video.videoWidth) loop(); else requestAnimationFrame(wait); };
          wait();
          cv.scrollIntoView({ behavior: "smooth", block: "center" });
        }, function () {
          // No camera or permission refused: fall back to the phone's own camera / file picker
          $("[data-wall-capture]", sec).click();
        });
        return;
      }
      if (t.closest("[data-wall-snap]")) {
        if (!video.videoWidth) return;
        var c = document.createElement("canvas"); c.width = video.videoWidth; c.height = video.videoHeight;
        c.getContext("2d").drawImage(video, 0, 0);
        stopCam(); setBg(c, false, true); return;
      }
      if (t.closest("[data-wall-stop]")) { stopCam(); render(); return; }
      var sb = t.closest('[data-seg="frame"], [data-seg="wsize"]');
      if (sb) {
        var key = sb.getAttribute("data-seg"), val = sb.getAttribute("data-val");
        if (key === "frame") wall.frame = val; else wall.mode = val;
        $$('[data-seg="' + key + '"]', sec).forEach(function (x) { x.setAttribute("aria-pressed", String(x === sb)); });
        syncMode(); render(); return;
      }
      if (t.closest("[data-wall-save]")) { render(); cv.toBlob(function (b) { if (b) downloadBlob(b, "my-diamond-painting-on-the-wall.jpg"); }, "image/jpeg", 0.92); return; }
      if (t.closest("[data-wall-share]")) {
        render();
        cv.toBlob(function (b) {
          if (!b) return;
          var file = new File([b], "my-diamond-painting.jpg", { type: "image/jpeg" });
          navigator.share({ files: [file], title: "My diamond painting", text: "Made with the GleamCanvas Photo to Drills tool" }).catch(function () {});
        }, "image/jpeg", 0.92);
      }
    });
    if (navigator.canShare && (function () { try { return navigator.canShare({ files: [new File(["x"], "x.jpg", { type: "image/jpeg" })] }); } catch (e) { return false; } })()) $("[data-wall-share]", sec).hidden = false;

    // Drag the markers or the painting with mouse or finger; pinch with two fingers to resize (Free size)
    function pos(e) { var b = cv.getBoundingClientRect(); return [(e.clientX - b.left) / b.width, (e.clientY - b.top) / b.height]; }
    function hitMarker(p) {
      if (wall.mode !== "true") return null;
      var lim = Math.max(markerR() * 2.2, 26 * cssScale()), best = null, bd = Infinity;
      ["a", "b"].forEach(function (k) { var d = Math.hypot((wall[k][0] - p[0]) * cv.width, (wall[k][1] - p[1]) * cv.height); if (d < lim && d < bd) { bd = d; best = k; } });
      return best;
    }
    function inPainting(p) { var r = rect(), px = p[0] * cv.width, py = p[1] * cv.height; return px >= r.x && px <= r.x + r.w && py >= r.y && py <= r.y + r.h; }
    cv.addEventListener("pointerdown", function (e) {
      ptrs[e.pointerId] = pos(e);
      var ids = Object.keys(ptrs), p = ptrs[e.pointerId];
      if (ids.length === 1) {
        var mk = hitMarker(p);
        if (mk) { drag = { marker: mk }; cv.setPointerCapture(e.pointerId); }
        else if (inPainting(p)) { drag = { dx: wall.x - p[0], dy: wall.y - p[1] }; cv.setPointerCapture(e.pointerId); }
      } else if (ids.length === 2 && wall.mode === "free") {
        var a = ptrs[ids[0]], c2 = ptrs[ids[1]];
        drag = { pinch: Math.hypot(a[0] - c2[0], a[1] - c2[1]), size: wall.size };
      }
    });
    cv.addEventListener("pointermove", function (e) {
      if (!(e.pointerId in ptrs)) { // hover cursor
        var hp = pos(e);
        cv.style.cursor = hitMarker(hp) ? "grab" : inPainting(hp) ? "move" : "default";
        return;
      }
      ptrs[e.pointerId] = pos(e);
      if (!drag) return;
      var ids = Object.keys(ptrs), p = ptrs[e.pointerId];
      if (drag.marker) wall[drag.marker] = [clamp(p[0], 0, 1), clamp(p[1], 0, 1)];
      else if (drag.pinch && ids.length === 2) {
        var a = ptrs[ids[0]], c2 = ptrs[ids[1]], d = Math.hypot(a[0] - c2[0], a[1] - c2[1]);
        wall.size = clamp(drag.size * d / drag.pinch, 0.04, 0.9); sizeIn.value = Math.round(wall.size * 100);
      } else if (!drag.pinch) { wall.x = clamp(p[0] + drag.dx, 0, 1); wall.y = clamp(p[1] + drag.dy, 0, 1); }
      if (!wall.live) render();
    });
    function up(e) { delete ptrs[e.pointerId]; if (!Object.keys(ptrs).length) drag = null; }
    cv.addEventListener("pointerup", up); cv.addEventListener("pointercancel", up);
    syncMode();
    render();
  }

  /* ---------- Print file for the producer ----------
     Two PNGs: the chart (True DMC, or the Printed Canvas style) with a symbol on every drill, drawn at real size (300 dpi target) with a title
     line; and a separate color-to-symbol card (symbol, DMC code and name, drill count) at 300 dpi. The PNG carries its dpi (pHYs chunk),
     so printing at 100% gives the exact finished size. Very big paintings use a lower dpi to stay within what the
     browser can draw (about 60 MP on computers, 16 MP on phones); the real dpi is reported. */
  function printFile(res, opt) {
    var mm = opt.pitch, phone = navigator.maxTouchPoints > 0 && Math.min(screen.width, screen.height) < 900;
    var cap = phone ? 16e6 : 60e6, dpi = 300, cell;
    for (;;) {
      cell = Math.max(8, Math.round(mm / 25.4 * dpi));
      var total = (res.cols * cell + cell * 4) * (res.rows * cell + cell * 7.2);
      if (total <= cap || dpi <= 100) break;
      dpi -= 25;
    }
    var pad = cell * 2, head = cell * 3.2, W = res.cols * cell + pad * 2, H = pad + head + res.rows * cell + pad;
    var c = document.createElement("canvas"); c.width = W; c.height = Math.round(H);
    var x = c.getContext("2d");
    x.fillStyle = "#fff"; x.fillRect(0, 0, W, c.height);
    x.fillStyle = "#123447"; x.textBaseline = "middle"; x.textAlign = "left";
    x.font = "800 " + Math.round(cell * 1.1) + "px Nunito, Arial, sans-serif";
    x.fillText(opt.title, pad, pad + head * 0.32);
    x.font = "600 " + Math.round(cell * 0.75) + "px Nunito, Arial, sans-serif";
    x.fillText(opt.sub, pad, pad + head * 0.72);
    // The chart (True DMC with a heavier line every 10 drills, easier to count) or the printed canvas; then an outline
    x.save(); x.translate(pad, pad + head);
    if (opt.style === "printed") drawPrinted(x, res, cell, opt.shape, opt.src);
    else {
      drawDrills(x, res, cell, opt.shape, true, true);
      x.strokeStyle = "rgba(18,52,71,.55)"; x.lineWidth = Math.max(1, cell * 0.06);
      for (var gx = 0; gx <= res.cols; gx += 10) { x.beginPath(); x.moveTo(gx * cell, 0); x.lineTo(gx * cell, res.rows * cell); x.stroke(); }
      for (var gy = 0; gy <= res.rows; gy += 10) { x.beginPath(); x.moveTo(0, gy * cell); x.lineTo(res.cols * cell, gy * cell); x.stroke(); }
    }
    x.strokeStyle = "#123447"; x.lineWidth = Math.max(1.5, cell * 0.1); x.strokeRect(0, 0, res.cols * cell, res.rows * cell);
    x.restore();
    return { canvas: c, dpi: dpi, cell: cell, left: pad, top: pad + head };
  }

  function keyCardFile(res, opt) {
    var dpi = 300, W = 8 * dpi, pad = 0.5 * dpi, cols = 2, colW = (W - pad * 2) / cols, rowH = 0.42 * dpi, sw = 0.32 * dpi, head = 0.75 * dpi;
    var rows = Math.ceil(res.pal.length / cols), H = Math.round(pad + head + rows * rowH + pad * 0.6);
    var c = document.createElement("canvas"); c.width = W; c.height = H;
    var x = c.getContext("2d");
    x.fillStyle = "#fff"; x.fillRect(0, 0, W, H);
    x.fillStyle = "#123447"; x.textBaseline = "middle"; x.textAlign = "left";
    x.font = "800 " + Math.round(dpi * 0.2) + "px Nunito, Arial, sans-serif"; x.fillText(opt.title, pad, pad + head * 0.25);
    x.font = "600 " + Math.round(dpi * 0.12) + "px Nunito, Arial, sans-serif"; x.fillText(opt.sub, pad, pad + head * 0.62);
    res.pal.forEach(function (p, i) {
      // fill down the first column, then the second, like a printed key
      var col = Math.floor(i / rows), row = i % rows, cx = pad + col * colW, cy = pad + head + row * rowH;
      x.fillStyle = p.d.hex; x.fillRect(cx, cy, sw, sw);
      x.strokeStyle = "rgba(18,52,71,.45)"; x.lineWidth = 3; x.strokeRect(cx + 1.5, cy + 1.5, sw - 3, sw - 3);
      x.fillStyle = p.d.lab[0] > 60 ? "#123447" : "#fff"; x.textAlign = "center";
      x.font = "800 " + Math.round(sw * 0.62) + "px Nunito, Arial, sans-serif"; x.fillText(p.sym, cx + sw / 2, cy + sw / 2 + 2);
      x.textAlign = "left"; x.fillStyle = "#123447";
      x.font = "800 " + Math.round(dpi * 0.11) + "px Nunito, Arial, sans-serif"; x.fillText("DMC " + p.d.code, cx + sw + dpi * 0.12, cy + sw * 0.3);
      x.font = "600 " + Math.round(dpi * 0.085) + "px Nunito, Arial, sans-serif"; x.fillText(p.d.name.slice(0, 30) + "  ·  " + fmt(p.count) + " drills", cx + sw + dpi * 0.12, cy + sw * 0.76);
    });
    return c;
  }

  // Write the dpi into a PNG (pHYs chunk right after IHDR) so it prints at the right physical size
  var CRC_T = null;
  function crc32(bytes) {
    if (!CRC_T) { CRC_T = new Uint32Array(256); for (var n = 0; n < 256; n++) { var c = n; for (var k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1; CRC_T[n] = c >>> 0; } }
    var crc = 0xffffffff;
    for (var i = 0; i < bytes.length; i++) crc = CRC_T[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
    return (crc ^ 0xffffffff) >>> 0;
  }
  function pngWithDpi(blob, dpi) {
    return blob.arrayBuffer().then(function (buf) {
      var src = new Uint8Array(buf), ppm = Math.round(dpi / 0.0254);
      var chunk = new Uint8Array(21), dv = new DataView(chunk.buffer);
      dv.setUint32(0, 9); chunk.set([112, 72, 89, 115], 4); // length 9, "pHYs"
      dv.setUint32(8, ppm); dv.setUint32(12, ppm); chunk[16] = 1; // pixels per metre, unit = metre
      dv.setUint32(17, crc32(chunk.subarray(4, 17)));
      var out = new Uint8Array(src.length + 21);
      out.set(src.subarray(0, 33), 0); out.set(chunk, 33); out.set(src.subarray(33), 54); // 8-byte signature + 25-byte IHDR
      return new Blob([out], { type: "image/png" });
    });
  }

  function downloadBlob(b, name) {
    var a = document.createElement("a");
    a.href = URL.createObjectURL(b); a.download = name;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
  }

  // A cozy built-in room (drawn here, so the panel works before anyone takes a photo)
  function sampleRoom() {
    var c = document.createElement("canvas"), W = 1600, H = 1100;
    c.width = W; c.height = H;
    var x = c.getContext("2d");
    var g = x.createLinearGradient(0, 0, W, H); g.addColorStop(0, "#e9e1d4"); g.addColorStop(1, "#d8cdbb");
    x.fillStyle = g; x.fillRect(0, 0, W, H * 0.78);
    var lg = x.createRadialGradient(W * 0.2, -H * 0.1, 50, W * 0.2, 0, W * 0.9); lg.addColorStop(0, "rgba(255,248,232,.55)"); lg.addColorStop(1, "rgba(255,248,232,0)");
    x.fillStyle = lg; x.fillRect(0, 0, W, H * 0.78);
    x.fillStyle = "#c9bba5"; x.fillRect(0, H * 0.74, W, 18); // baseboard
    var fl = x.createLinearGradient(0, H * 0.76, 0, H); fl.addColorStop(0, "#9a7651"); fl.addColorStop(1, "#7a5a3b");
    x.fillStyle = fl; x.fillRect(0, H * 0.76, W, H * 0.24);
    x.strokeStyle = "rgba(0,0,0,.08)"; x.lineWidth = 3;
    for (var i = 0; i < 9; i++) { x.beginPath(); x.moveTo(i * 200 + 60, H * 0.76); x.lineTo(i * 260 - 200, H); x.stroke(); }
    // sideboard
    // sideboard, about 160 cm wide and 75 cm tall
    x.fillStyle = "rgba(0,0,0,.18)"; x.fillRect(W * 0.325, H * 0.775, W * 0.35, 18);
    x.fillStyle = "#f3efe8"; x.fillRect(W * 0.335, H * 0.535, W * 0.33, H * 0.235);
    x.fillStyle = "#e4ddd2"; x.fillRect(W * 0.335, H * 0.535, W * 0.33, 14);
    x.strokeStyle = "#d6cdbf"; x.lineWidth = 3; x.strokeRect(W * 0.35, H * 0.575, W * 0.145, H * 0.17); x.strokeRect(W * 0.505, H * 0.575, W * 0.145, H * 0.17);
    x.fillStyle = "#b89a6a"; [[0.4225, 0.66], [0.5775, 0.66]].forEach(function (p) { x.beginPath(); x.arc(W * p[0], H * p[1], 6, 0, 6.3); x.fill(); });
    // vase with branches, and a small stack of books
    x.fillStyle = "#22607f"; x.beginPath(); x.ellipse(W * 0.62, H * 0.49, 30, 44, 0, 0, 6.3); x.fill(); x.fillRect(W * 0.62 - 14, H * 0.43, 28, 26);
    x.strokeStyle = "#5d4a36"; x.lineWidth = 4;
    [[-50, -160], [10, -200], [60, -145]].forEach(function (b) { x.beginPath(); x.moveTo(W * 0.62, H * 0.43); x.quadraticCurveTo(W * 0.62 + b[0] * 0.3, H * 0.43 + b[1] * 0.6, W * 0.62 + b[0], H * 0.43 + b[1]); x.stroke(); });
    x.fillStyle = "#f07cae"; [[-50, -160], [10, -200], [60, -145], [-25, -100], [35, -95]].forEach(function (b) { x.beginPath(); x.arc(W * 0.62 + b[0], H * 0.43 + b[1], 8, 0, 6.3); x.fill(); });
    [["#628da6", 0.36, 22], ["#ffc857", 0.362, 18], ["#b4c8d2", 0.358, 20]].forEach(function (b, k) { x.fillStyle = b[0]; x.fillRect(W * b[1], H * 0.535 - (k + 1) * b[2], 110 - k * 8, b[2] - 2); });
    // plant on the floor
    x.fillStyle = "#c8b49a"; x.fillRect(W * 0.86, H * 0.78, 110, 120);
    for (var l = 0; l < 13; l++) { // long leaves fanning up out of the pot
      var ang = -Math.PI / 2 + (l - 6) * 0.16, len = 150 + (l % 3) * 45, bx = W * 0.86 + 55, by = H * 0.79;
      x.fillStyle = l % 2 ? "#4f7a52" : "#5f8c5f";
      x.beginPath(); x.ellipse(bx + Math.cos(ang) * len * 0.5, by + Math.sin(ang) * len * 0.5, 16, len * 0.5, ang + Math.PI / 2, 0, 6.3); x.fill();
    }
    return c;
  }

  // A cheerful built-in sample (drawn here, so it works without uploading anything).
  function sampleCanvas() {
    var c = document.createElement("canvas"), W = 640, H = 480;
    c.width = W; c.height = H;
    var x = c.getContext("2d"), g = x.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0, "#9b7ede"); g.addColorStop(0.45, "#f07cae"); g.addColorStop(0.8, "#ffc06b");
    x.fillStyle = g; x.fillRect(0, 0, W, H);
    x.fillStyle = "#ffe08a"; x.beginPath(); x.arc(470, 160, 60, 0, 6.3); x.fill();
    x.fillStyle = "#2f7a4f"; x.beginPath(); x.moveTo(0, 360); x.quadraticCurveTo(160, 280, 330, 350); x.quadraticCurveTo(500, 300, 640, 340); x.lineTo(640, 480); x.lineTo(0, 480); x.fill();
    x.fillStyle = "#f5f9fb"; x.fillRect(0, 410, W, 70);
    x.fillStyle = "#22607f"; x.fillRect(200, 250, 200, 170);
    x.fillStyle = "#d63c4f"; x.beginPath(); x.moveTo(180, 258); x.lineTo(300, 160); x.lineTo(420, 258); x.fill();
    x.fillStyle = "#ffc857"; x.fillRect(225, 285, 45, 45); x.fillRect(330, 285, 45, 45);
    x.fillStyle = "#6b4430"; x.fillRect(278, 345, 44, 75);
    x.fillStyle = "#123447"; x.fillRect(340, 175, 26, 50);
    x.fillStyle = "#fff";
    [[60, 60], [140, 110], [560, 60], [600, 230], [90, 220], [380, 90]].forEach(function (p) { x.beginPath(); x.arc(p[0], p[1], 5, 0, 6.3); x.fill(); });
    return c;
  }

  /* =========================================================
     Tool 2: DMC Color Finder
     ========================================================= */
  var finder = { q: "", fam: "all", sel: "310", pick: "#f07cae" };

  function dmcTool(body) {
    loadDMC().then(function () {
      body.innerHTML =
        '<p class="dp-intro">Look up any of ' + DMC.length + ' DMC colors by code or name, see similar shades, or find the closest DMC color to anything you like.</p>' +
        '<div class="dp-finder">' +
          '<div class="dp-finder-list">' +
            '<label class="sr-only" for="dp-search">Search DMC colors</label>' +
            '<input id="dp-search" class="dp-input dp-search" type="search" placeholder="Search a code or name, e.g. 310 or blue" value="' + esc(finder.q) + '" data-q autocomplete="off">' +
            '<div class="dp-fams">' + FAMILIES.map(function (f) { return '<button type="button" data-fam="' + f[0] + '" aria-pressed="' + (f[0] === finder.fam) + '">' + f[1] + "</button>"; }).join("") + "</div>" +
            '<p class="dp-count" data-count></p>' +
            '<div class="dp-swatches" data-list></div>' +
          "</div>" +
          '<div class="dp-finder-side">' +
            '<div class="dp-detail" data-detail></div>' +
            '<div class="dp-match">' +
              '<h3 class="dp-h3">Match a color</h3>' +
              '<p class="dp-help">Pick any color, or tap a spot on a photo, to find the closest DMC drills.</p>' +
              '<div class="dp-inline"><input type="color" value="' + finder.pick + '" data-pick aria-label="Pick a color" class="dp-color">' +
                '<label class="dp-link-btn dp-file">Pick from a photo<input type="file" accept="image/*" data-pick-photo></label></div>' +
              '<canvas class="dp-pick-canvas" data-pick-canvas hidden aria-label="Tap the photo to pick a color"></canvas>' +
              '<div data-matches></div>' +
            "</div>" +
          "</div>" +
        "</div>" +
        '<p class="dp-fine">Screen colors are approximations of real DMC drills, which vary a little by batch, finish and screen.</p>';

      var list = $("[data-list]", body);
      function renderList() {
        var q = finder.q.trim().toLowerCase();
        var items = DMC.filter(function (d) {
          if (finder.fam !== "all" && d.fam !== finder.fam) return false;
          if (!q) return true;
          return d.code.toLowerCase().indexOf(q) === 0 || d.name.toLowerCase().indexOf(q) > -1;
        });
        // Exact code first, then the DMC chart order
        items.sort(function (a, b) { return (b.code.toLowerCase() === q) - (a.code.toLowerCase() === q); });
        $("[data-count]", body).textContent = items.length ? items.length + " color" + (items.length > 1 ? "s" : "") : "No colors match. Try another code or word.";
        list.innerHTML = items.map(function (d) {
          return '<button type="button" class="dp-swatch' + (d.code === finder.sel ? " is-on" : "") + '" data-code="' + esc(d.code) + '" title="DMC ' + esc(d.code) + " " + esc(d.name) + '">' +
            '<i style="background:' + d.hex + '"></i><strong>' + esc(d.code) + "</strong><small>" + esc(d.name) + "</small></button>";
        }).join("");
      }
      function renderDetail() {
        var d = byCode(finder.sel) || DMC[0];
        var near = nearest(d.lab, DMC, 6, d);
        $("[data-detail]", body).innerHTML =
          '<div class="dp-detail-sw" style="background:' + d.hex + '"></div>' +
          '<div class="dp-detail-info"><p class="dp-detail-code">DMC ' + esc(d.code) + "</p><p class=\"dp-detail-name\">" + esc(d.name) + "</p>" +
            '<p class="dp-help">' + d.hex.toUpperCase() + " · RGB " + d.rgb.join(", ") + "</p>" +
            '<button type="button" class="dp-link-btn" data-copy="' + esc(d.code) + '">Copy code</button></div>' +
          '<p class="dp-label dp-near-title">Similar shades</p>' +
          '<div class="dp-near">' + near.map(function (m) {
            return '<button type="button" data-code="' + esc(m.d.code) + '" title="DMC ' + esc(m.d.code) + " " + esc(m.d.name) + '"><i style="background:' + m.d.hex + '"></i>' + esc(m.d.code) + "</button>";
          }).join("") + "</div>";
      }
      function select(code) {
        finder.sel = code;
        $$(".dp-swatch.is-on", list).forEach(function (b) { b.classList.remove("is-on"); });
        var btn = list.querySelector('[data-code="' + (window.CSS && CSS.escape ? CSS.escape(code) : code) + '"]');
        if (btn) btn.classList.add("is-on");
        renderDetail();
      }
      function renderMatches(hex) {
        var rgb = hexToRgb(hex), m = nearest(rgbToLab(rgb[0], rgb[1], rgb[2]), DMC, 5);
        $("[data-matches]", body).innerHTML =
          '<div class="dp-target"><i style="background:' + hex + '"></i>Your color ' + hex.toUpperCase() + "</div>" +
          m.map(function (x) {
            return '<button type="button" class="dp-match-row" data-code="' + esc(x.d.code) + '"><i style="background:' + x.d.hex + '"></i>' +
              "<span><strong>DMC " + esc(x.d.code) + "</strong> " + esc(x.d.name) + "</span><small>" + matchQuality(x.dist) + "</small></button>";
          }).join("");
      }

      body.addEventListener("input", function (e) {
        if (e.target.hasAttribute("data-q")) { finder.q = e.target.value; renderList(); }
        else if (e.target.hasAttribute("data-pick")) { finder.pick = e.target.value; renderMatches(finder.pick); }
      });
      body.addEventListener("click", function (e) {
        var f = e.target.closest("[data-fam]");
        if (f) { finder.fam = f.getAttribute("data-fam"); $$("[data-fam]", body).forEach(function (b) { b.setAttribute("aria-pressed", String(b === f)); }); renderList(); return; }
        var c = e.target.closest("[data-code]");
        if (c) { select(c.getAttribute("data-code")); if (!c.classList.contains("dp-swatch")) $("[data-detail]", body).scrollIntoView({ behavior: "smooth", block: "nearest" }); return; }
        var cp = e.target.closest("[data-copy]");
        if (cp) {
          var txt = "DMC " + cp.getAttribute("data-copy");
          var done = function () { cp.textContent = "Copied!"; setTimeout(function () { cp.textContent = "Copy code"; }, 1500); };
          if (navigator.clipboard) navigator.clipboard.writeText(txt).then(done, function () {}); else done();
        }
      });
      var pickInput = $("[data-pick-photo]", body), pc = $("[data-pick-canvas]", body);
      pickInput.addEventListener("change", function () {
        var file = pickInput.files[0];
        pickInput.value = "";
        if (!file) return;
        var url = URL.createObjectURL(file), img = new Image();
        img.onload = function () {
          var k = Math.min(1, 900 / Math.max(img.naturalWidth, img.naturalHeight));
          pc.width = Math.round(img.naturalWidth * k); pc.height = Math.round(img.naturalHeight * k);
          pc.getContext("2d").drawImage(img, 0, 0, pc.width, pc.height);
          pc.hidden = false;
          URL.revokeObjectURL(url);
        };
        img.src = url;
      });
      pc.addEventListener("click", function (e) {
        var r = pc.getBoundingClientRect(), x = Math.round((e.clientX - r.left) / r.width * pc.width), y = Math.round((e.clientY - r.top) / r.height * pc.height);
        var x0 = clamp(x - 2, 0, pc.width - 5), y0 = clamp(y - 2, 0, pc.height - 5);
        var data = pc.getContext("2d").getImageData(x0, y0, 5, 5).data, s = [0, 0, 0];
        for (var i = 0; i < 25; i++) { s[0] += data[i * 4]; s[1] += data[i * 4 + 1]; s[2] += data[i * 4 + 2]; }
        finder.pick = rgbToHex(Math.round(s[0] / 25), Math.round(s[1] / 25), Math.round(s[2] / 25));
        $("[data-pick]", body).value = finder.pick;
        renderMatches(finder.pick);
      });

      renderList();
      renderDetail();
      renderMatches(finder.pick);
    }, function () { loadFailed(body); });
  }

  /* =========================================================
     Tool 3: Drill Calculator
     ========================================================= */
  var PACES = [["600", "Relaxed", "~600 drills an hour"], ["1000", "Steady", "~1,000 drills an hour"], ["1500", "Speedy", "~1,500 drills an hour"]];
  var calc = { w: 30, h: 40, unit: "cm", shape: "square", coverage: 100, colors: "", bag: 200, spare: 10, pace: "1000" };

  function calcTool(body) {
    body.innerHTML =
      '<p class="dp-intro">Plan any diamond painting: how many drills it takes, how many bags to order and roughly how long it will keep you happily busy.</p>' +
      '<div class="dp-calc">' +
        '<div class="dp-controls">' +
          '<div class="dp-fieldset"><span class="dp-label">Canvas size (drill area)</span>' +
            '<div class="dp-inline"><input class="dp-input dp-num" type="number" min="1" max="300" step="0.5" value="' + calc.w + '" data-c="w" aria-label="Width">' +
            '<span aria-hidden="true">×</span><input class="dp-input dp-num" type="number" min="1" max="300" step="0.5" value="' + calc.h + '" data-c="h" aria-label="Height">' +
            seg("cunit", [["cm", "cm"], ["in", "in"]], calc.unit) + "</div></div>" +
          '<div class="dp-fieldset"><span class="dp-label">Drill shape</span>' + seg("cshape", [["square", "Square (2.5 mm)"], ["round", "Round (2.8 mm)"]], calc.shape) + "</div>" +
          '<div class="dp-fieldset"><label class="dp-label" for="dp-cov">Coverage: <strong data-cov-out>' + (calc.coverage === 100 ? "Full" : calc.coverage + "%") + "</strong></label>" +
            '<input id="dp-cov" class="dp-range" type="range" min="20" max="100" step="5" value="' + calc.coverage + '" data-c="coverage">' +
            '<p class="dp-help">Partial-drill paintings leave some areas printed instead of covered.</p></div>' +
          '<div class="dp-two">' +
            '<div class="dp-fieldset"><label class="dp-label" for="dp-ncol">Number of colors <small>(optional)</small></label><input id="dp-ncol" class="dp-input" type="number" min="1" max="500" value="' + calc.colors + '" data-c="colors"></div>' +
            '<div class="dp-fieldset"><label class="dp-label" for="dp-bag">Drills per bag</label><input id="dp-bag" class="dp-input" type="number" min="10" max="5000" step="10" value="' + calc.bag + '" data-c="bag"></div>' +
          "</div>" +
          '<div class="dp-fieldset"><label class="dp-label" for="dp-spare">Extra for spares: <strong data-spare-out>' + calc.spare + "%</strong></label>" +
            '<input id="dp-spare" class="dp-range" type="range" min="0" max="30" step="5" value="' + calc.spare + '" data-c="spare"></div>' +
          '<div class="dp-fieldset"><span class="dp-label">Your pace</span>' + seg("pace", PACES.map(function (p) { return [p[0], p[1]]; }), calc.pace) + '<p class="dp-help" data-pace-help></p></div>' +
        "</div>" +
        '<div class="dp-calc-out" data-out aria-live="polite"></div>' +
      "</div>" +
      '<p class="dp-fine">Estimates only. Drill sizes, bag sizes and kits vary, so check your kit\'s instructions. Square drills are usually 2.5 mm and round drills 2.8 mm.</p>';

    body.addEventListener("input", function (e) {
      var k = e.target.getAttribute("data-c");
      if (!k) return;
      calc[k] = k === "colors" ? e.target.value : +e.target.value;
      out();
    });
    body.addEventListener("click", function (e) {
      var b = e.target.closest("[data-seg]");
      if (!b) return;
      var key = b.getAttribute("data-seg"), val = b.getAttribute("data-val");
      $$('[data-seg="' + key + '"]', body).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
      if (key === "cunit" && val !== calc.unit) {
        var f = val === "in" ? 1 / 2.54 : 2.54;
        calc.w = Math.round(calc.w * f * 10) / 10; calc.h = Math.round(calc.h * f * 10) / 10; calc.unit = val;
        $('[data-c="w"]', body).value = calc.w; $('[data-c="h"]', body).value = calc.h;
      } else if (key === "cshape") calc.shape = val;
      else if (key === "pace") calc.pace = val;
      out();
    });
    out();

    function out() {
      $("[data-cov-out]", body).textContent = calc.coverage >= 100 ? "Full" : calc.coverage + "%";
      $("[data-spare-out]", body).textContent = calc.spare + "%";
      var pace = PACES.filter(function (p) { return p[0] === calc.pace; })[0];
      $("[data-pace-help]", body).textContent = pace[2] + ". Everyone's pace is different!";
      var box = $("[data-out]", body), mm = calc.unit === "in" ? 25.4 : 10;
      if (!(calc.w > 0 && calc.h > 0)) { box.innerHTML = '<p class="dp-help">Enter a width and height to see your plan.</p>'; return; }
      var pitch = PITCH[calc.shape], cols = Math.round(calc.w * mm / pitch), rows = Math.round(calc.h * mm / pitch);
      var drills = Math.round(cols * rows * clamp(calc.coverage, 1, 100) / 100);
      var withSpare = Math.ceil(drills * (1 + calc.spare / 100));
      var nColors = parseInt(calc.colors, 10), bag = Math.max(1, calc.bag || 200);
      var bags = nColors > 0 ? nColors * Math.max(1, Math.ceil(withSpare / nColors / bag)) : Math.ceil(withSpare / bag);
      var hours = drills / +calc.pace, evenings = Math.max(1, Math.round(hours / 2));
      var hTxt = hours < 1 ? "under 1 hour" : hours < 10 ? (Math.round(hours * 2) / 2) + " hours" : fmt(hours) + " hours";
      box.innerHTML =
        '<div class="dp-big"><strong>' + fmt(drills) + "</strong><span>drills to place</span></div>" +
        '<div class="dp-stats">' +
          stat(cols + " × " + rows, "drills across × down") +
          stat(fmt(withSpare), "drills with " + calc.spare + "% spares") +
          stat(fmt(bags), "bag" + (bags === 1 ? "" : "s") + " of " + fmt(bag) + (nColors > 0 ? " (at least 1 per color)" : "")) +
          stat(hTxt, "at a " + pace[1].toLowerCase() + " pace") +
        "</div>" +
        '<p class="dp-evenings">' + SPARKLE + " That's about <strong>" + evenings + " cozy evening" + (evenings === 1 ? "" : "s") + "</strong> of two hours each.</p>";
    }
  }

  /* ---------- Shared: products, HSL, copy ---------- */
  var PRODUCTS = null;
  var MOVING = /\bspinning\b|windmill|moving (?:parts|wheels)|rotat/i;
  function products() {
    if (PRODUCTS) return PRODUCTS;
    var el = document.querySelector("[data-dp-products]"), raw = [];
    if (el) { try { raw = JSON.parse(el.textContent); } catch (e) { raw = []; } }
    else raw = (window.GC_PRODUCTS || []).map(function (p) {
      return { id: p.id, name: p.name, url: "product.html?id=" + p.id, img: p.images && p.images[0], price: p.price,
        priceText: window.GC_money ? GC_money(p.price) : "$" + p.price.toFixed(2), cat: p.category, lightUp: !!p.lightUp, text: p.short || "" };
    });
    PRODUCTS = raw.filter(function (p) { return p && p.name; }).map(function (p) {
      p.moving = MOVING.test(p.name + " " + (p.text || ""));
      p.isSet = /set of|\d-pack/i.test(p.name);
      return p;
    });
    return PRODUCTS;
  }
  function rgbToHsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2, d = max - min, h = 0, s = 0;
    if (d) {
      s = d / (1 - Math.abs(2 * l - 1));
      h = max === r ? ((g - b) / d) % 6 : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
      h *= 60; if (h < 0) h += 360;
    }
    return [h, s, l];
  }
  function hslToHex(h, s, l) {
    h = ((h % 360) + 360) % 360; s = clamp(s, 0, 1); l = clamp(l, 0, 1);
    var c = (1 - Math.abs(2 * l - 1)) * s, x = c * (1 - Math.abs((h / 60) % 2 - 1)), m = l - c / 2, rgb;
    rgb = h < 60 ? [c, x, 0] : h < 120 ? [x, c, 0] : h < 180 ? [0, c, x] : h < 240 ? [0, x, c] : h < 300 ? [x, 0, c] : [c, 0, x];
    return rgbToHex(Math.round((rgb[0] + m) * 255), Math.round((rgb[1] + m) * 255), Math.round((rgb[2] + m) * 255));
  }
  function copyText(btn, text, label) {
    var done = function () { btn.textContent = "Copied!"; setTimeout(function () { btn.textContent = label; }, 1500); };
    if (navigator.clipboard) navigator.clipboard.writeText(text).then(done, function () {}); else done();
  }
  function openFinderAt(code) {
    finder.sel = code; finder.q = ""; finder.fam = "all";
    open("dmc-finder", true);
  }
  function studioLink(hexes) {
    return cfg.designUrl + (cfg.designUrl.indexOf("?") > -1 ? "&" : "?") + "colors=" + hexes.map(function (h) { return h.replace("#", ""); }).join(",");
  }

  /* =========================================================
     Tool 4: Palette Mood Boards
     ========================================================= */
  // Codes picked by matching each mood's colors to the DMC list, then adjusted by eye.
  // `roles` = main, accent, trim for the Design Studio.
  var BOARDS = [
    { name: "Cozy Cabin", mood: "Warm wood, candlelight and a crackling fire.", uses: "cabins, winter houses, lanterns", codes: ["801", "434", "3046", "543", "498", "561", "783"], roles: ["434", "498", "543"] },
    { name: "Winter Wonderland", mood: "Fresh snow, icy blues and silver frost.", uses: "snowy villages, ornaments, trees", codes: ["B5200", "162", "813", "334", "803", "159", "160"], roles: ["803", "813", "B5200"] },
    { name: "Candy Cane Christmas", mood: "Peppermint stripes and festive cheer.", uses: "gingerbread houses, Santa scenes", codes: ["321", "B5200", "3706", "602", "909", "729", "543"], roles: ["321", "3706", "B5200"] },
    { name: "Spooky Night", mood: "Moonlit pumpkins and a little mischief.", uses: "Halloween houses, lanterns", codes: ["310", "946", "550", "704", "726", "3750", "318"], roles: ["550", "946", "726"] },
    { name: "Spring Garden", mood: "Blossoms, butter-yellow sun and new leaves.", uses: "cottages, cupcake stands, coasters", codes: ["3708", "211", "966", "3822", "913", "760", "B5200"], roles: ["3708", "913", "3822"] },
    { name: "Ocean Breeze", mood: "Sea glass, sandy shores and coral.", uses: "beach huts, coasters, bookmarks", codes: ["517", "3845", "3766", "677", "722", "820", "B5200"], roles: ["517", "3845", "B5200"] },
    { name: "Autumn Harvest", mood: "Spiced pumpkins, golden fields and cider.", uses: "fall houses, table decor", codes: ["918", "3776", "729", "902", "469", "632", "739"], roles: ["3776", "902", "729"] },
    { name: "Sweetheart", mood: "Roses, blush pinks and a touch of gold.", uses: "Valentine's gifts, keepsakes", codes: ["304", "3801", "3806", "151", "B5200", "815", "729"], roles: ["304", "151", "B5200"] }
  ];
  var HARMONIES = [["shades", "Shades"], ["neighbors", "Neighbors"], ["opposites", "Opposites"], ["trio", "Trio"]];
  var maker = { base: "#3aa6c9", harmony: "neighbors" };

  function paletteTool(body) {
    loadDMC().then(function () {
      var strip = function (codes, big) {
        return '<div class="dp-strip' + (big ? " is-big" : "") + '">' + codes.map(function (c) {
          var d = byCode(c);
          return d ? '<button type="button" class="dp-drill" data-code="' + esc(d.code) + '" title="DMC ' + esc(d.code) + " " + esc(d.name) + ' (open in the DMC Color Finder)"><i style="background:' + d.hex + '"></i><span>' + esc(d.code) + "</span></button>" : "";
        }).join("") + "</div>";
      };
      body.innerHTML =
        '<p class="dp-intro">Hand-picked DMC color sets to spark your next project. Tap any drill to look it up, copy the codes for your shopping list, or try the colors on a kit in our Design Studio.</p>' +
        '<div class="dp-boards">' + BOARDS.map(function (b, i) {
          var hexes = b.codes.map(function (c) { return byCode(c).hex; });
          return '<article class="dp-board">' +
            '<div class="dp-board-band" style="background:linear-gradient(90deg,' + hexes.map(function (h, j) { return h + " " + Math.round(j / hexes.length * 100) + "%," + h + " " + Math.round((j + 1) / hexes.length * 100) + "%"; }).join(",") + ')"></div>' +
            "<h3>" + esc(b.name) + '</h3><p class="dp-board-mood">' + esc(b.mood) + "</p>" + strip(b.codes) +
            '<p class="dp-help">Lovely for ' + esc(b.uses) + ".</p>" +
            '<div class="dp-board-actions"><button type="button" class="dp-link-btn" data-copy-board="' + i + '">Copy codes</button>' +
              '<a class="dp-link-btn" href="' + esc(studioLink(b.roles.map(function (c) { return byCode(c).hex; }))) + '">Try in Design Studio</a></div>' +
          "</article>";
        }).join("") + "</div>" +
        '<div class="dp-maker">' +
          '<h3 class="dp-h3">Make your own palette</h3>' +
          '<p class="dp-help">Pick a color you love and a style, and we\'ll build a matching set of DMC drills.</p>' +
          '<div class="dp-inline dp-maker-controls"><input type="color" class="dp-color" value="' + maker.base + '" data-base aria-label="Your starting color">' +
            '<label class="sr-only" for="dp-base-code">Or start from a DMC code</label><input id="dp-base-code" class="dp-input" type="text" placeholder="or a DMC code" data-base-code maxlength="6">' +
            seg("harmony", HARMONIES, maker.harmony) + "</div>" +
          '<p class="dp-help" data-harmony-help></p>' +
          '<div data-made></div>' +
        "</div>";

      function make() {
        var rgb = hexToRgb(maker.base), hsl = rgbToHsl(rgb[0], rgb[1], rgb[2]), h = hsl[0], s = Math.max(hsl[1], 0.35), l = clamp(hsl[2], 0.3, 0.7), hexes;
        if (maker.harmony === "shades") hexes = [0.18, 0.3, 0.42, 0.55, 0.68, 0.8, 0.9].map(function (L) { return hslToHex(h, s, L); });
        else if (maker.harmony === "neighbors") hexes = [-40, -25, -12, 0, 12, 25, 40].map(function (d, i) { return hslToHex(h + d, s, clamp(l + (i % 2 ? 0.12 : -0.05), 0.15, 0.88)); });
        else if (maker.harmony === "opposites") hexes = [hslToHex(h, s, l - 0.2), hslToHex(h, s, l), hslToHex(h, s * 0.6, 0.85), hslToHex(h + 180, s, l - 0.15), hslToHex(h + 180, s, l + 0.05), hslToHex(h + 180, s * 0.5, 0.88), hslToHex(h, 0.08, 0.95)];
        else hexes = [hslToHex(h, s, l), hslToHex(h, s, l + 0.2), hslToHex(h + 120, s, l), hslToHex(h + 120, s, l + 0.2), hslToHex(h + 240, s, l), hslToHex(h + 240, s, l + 0.2), hslToHex(h, 0.08, 0.95)];
        var used = [], codes = [];
        hexes.forEach(function (hx) {
          var c = hexToRgb(hx), pick = nearest(rgbToLab(c[0], c[1], c[2]), DMC.filter(function (d) { return used.indexOf(d) < 0; }), 1)[0].d;
          used.push(pick); codes.push(pick.code);
        });
        $("[data-harmony-help]", body).textContent = {
          shades: "Light to dark shades of one color: calm and elegant.",
          neighbors: "Colors that sit side by side on the color wheel: soft and harmonious.",
          opposites: "Your color plus its opposite for extra pop.",
          trio: "Three evenly spaced colors: playful and bright."
        }[maker.harmony];
        maker.codes = codes;
        $("[data-made]", body).innerHTML = strip(codes, true) +
          '<div class="dp-board-actions"><button type="button" class="dp-link-btn" data-copy-made>Copy codes</button>' +
          '<a class="dp-link-btn" href="' + esc(studioLink([used[3] || used[0], used[1], used[used.length - 1]].map(function (d) { return d.hex; }))) + '">Try in Design Studio</a></div>';
      }

      body.addEventListener("input", function (e) {
        if (e.target.hasAttribute("data-base")) { maker.base = e.target.value; $("[data-base-code]", body).value = ""; make(); }
        else if (e.target.hasAttribute("data-base-code")) {
          var d = byCode(e.target.value);
          if (d) { maker.base = d.hex; $("[data-base]", body).value = d.hex; make(); }
        }
      });
      body.addEventListener("click", function (e) {
        var s = e.target.closest('[data-seg="harmony"]');
        if (s) { maker.harmony = s.getAttribute("data-val"); $$('[data-seg="harmony"]', body).forEach(function (x) { x.setAttribute("aria-pressed", String(x === s)); }); make(); return; }
        var drill = e.target.closest("[data-code]");
        if (drill) { openFinderAt(drill.getAttribute("data-code")); return; }
        var cb = e.target.closest("[data-copy-board]");
        if (cb) { var b = BOARDS[+cb.getAttribute("data-copy-board")]; copyText(cb, b.name + " (DMC): " + b.codes.join(", "), "Copy codes"); return; }
        var cm = e.target.closest("[data-copy-made]");
        if (cm) copyText(cm, "My palette (DMC): " + maker.codes.join(", "), "Copy codes");
      });
      make();
    }, function () { loadFailed(body); });
  }

  /* =========================================================
     Tool 5: Which Kit Is for Me? (the Kit Finder)
     ========================================================= */
  var QUIZ = [
    { key: "who", q: "Who is it for?", opts: [["me", "Me!"], ["adult", "A gift for a grown-up"], ["young", "A young crafter (8+)"], ["family", "Something to make together"]] },
    { key: "make", q: "What would you love to make?", opts: [["holiday", "Holiday decor"], ["house", "A cozy house for all year"], ["home", "Something useful for home"], ["gift", "A little gift or keepsake"]] },
    { key: "musts", q: "Any must-haves?", multi: true, hint: "Pick any, or skip.", opts: [["lights", "Lights up"], ["moving", "Moving parts"], ["set", "Comes as a set"], ["budget", "Under $20"]] },
    { key: "time", q: "How much crafting time do you have?", opts: [["short", "An evening or two"], ["medium", "A few cozy weekends"], ["long", "A big project to savor"]] },
    { key: "level", q: "How much diamond painting have you done?", opts: [["new", "I'm brand new"], ["some", "I've done a few"], ["pro", "I'm a diamond pro"]] }
  ];
  var quiz = { step: 0, a: { musts: [] } };

  function quizTool(body) {
    var list = products().filter(function (p) { return p.cat !== "tools"; });
    if (!list.length) { body.innerHTML = '<p class="dp-intro">Our kits will appear here soon. In the meantime, <a href="' + esc(cfg.shopUrl) + '">browse the shop</a>.</p>'; return; }
    quizTool.restart = render; // used by the pop-up to start over
    render();
    body.addEventListener("click", function (e) {
      var o = e.target.closest("[data-opt]");
      if (o) {
        var q = QUIZ[quiz.step], v = o.getAttribute("data-opt");
        if (q.multi) {
          var arr = quiz.a.musts, i = arr.indexOf(v);
          if (i > -1) arr.splice(i, 1); else arr.push(v);
          o.setAttribute("aria-pressed", String(i < 0));
          return;
        }
        quiz.a[q.key] = v; quiz.step++; render(); return;
      }
      if (e.target.closest("[data-next]")) { quiz.step++; render(); return; }
      if (e.target.closest("[data-back]")) { quiz.step = Math.max(0, quiz.step - 1); render(); return; }
      if (e.target.closest("[data-restart]")) { quiz.step = 0; quiz.a = { musts: [] }; render(); }
    });

    function render() {
      if (quiz.step >= QUIZ.length) return results();
      var q = QUIZ[quiz.step];
      body.innerHTML =
        '<div class="dp-quiz">' +
          '<div class="dp-progress" aria-label="Step ' + (quiz.step + 1) + " of " + QUIZ.length + '">' + QUIZ.map(function (x, i) { return '<i class="' + (i < quiz.step ? "is-done" : i === quiz.step ? "is-now" : "") + '"></i>'; }).join("") + "</div>" +
          '<p class="dp-shelf-title">Step ' + (quiz.step + 1) + " of " + QUIZ.length + "</p>" +
          '<h3 class="dp-quiz-q">' + q.q + "</h3>" + (q.hint ? '<p class="dp-help">' + q.hint + "</p>" : "") +
          '<div class="dp-quiz-opts">' + q.opts.map(function (o) {
            var on = q.multi ? quiz.a.musts.indexOf(o[0]) > -1 : quiz.a[q.key] === o[0];
            return '<button type="button" class="dp-quiz-opt" data-opt="' + o[0] + '" aria-pressed="' + on + '">' + o[1] + "</button>";
          }).join("") + "</div>" +
          '<div class="dp-quiz-nav">' + (quiz.step ? '<button type="button" class="dp-link-btn" data-back>← Back</button>' : "<span></span>") +
            (q.multi ? '<button type="button" class="btn btn-primary btn-sm" data-next>Next</button>' : "") + "</div>" +
        "</div>";
      var first = $(".dp-quiz-opt", body);
      if (first && quiz.step) first.focus({ preventScroll: true });
    }

    function score(p) {
      var a = quiz.a, s = 0, why = [];
      var catMatch = { holiday: "holidays", house: "houses", home: "home-gifts", gift: "home-gifts" }[a.make];
      if (p.cat === catMatch) { s += 6; why.push({ holiday: "Holiday favorite", house: "Year-round home decor", home: "Made to use at home", gift: "Sweet to give" }[a.make]); }
      else if (a.make === "house" && p.cat === "holidays" && /house|cabin|cottage/i.test(p.name)) { s += 3; why.push("A cozy little house"); }
      else if (a.make === "gift" && (p.isSet || p.price < 20)) { s += 3; why.push("Easy to give"); }
      a.musts.forEach(function (m) {
        if (m === "lights") { if (p.lightUp) { s += 5; why.push("Lights up"); } else s -= 3; }
        if (m === "moving") { if (p.moving) { s += 5; why.push("Has moving parts"); } else s -= 3; }
        if (m === "set") { if (p.isSet) { s += 4; why.push("Comes as a set"); } else s -= 1; }
        if (m === "budget") { if (p.price < 20) { s += 4; why.push("Under $20"); } else s -= 4; }
      });
      if (a.time === "short" && p.price < 20) s += 2;
      if (a.time === "medium" && p.price >= 18 && p.price < 30) s += 2;
      if (a.time === "long" && (p.price >= 28 || p.moving)) s += 2;
      if (a.level === "new" && p.price < 23) s += 1;
      if (a.level === "pro" && (p.price >= 28 || p.moving)) s += 1;
      if (a.who === "young" && (p.lightUp || p.moving)) { s += 1; if (why.indexOf("Lights up") < 0 && why.indexOf("Has moving parts") < 0) why.push(p.lightUp ? "Lights up" : "Has moving parts"); }
      if (a.who === "family" && (p.isSet || p.price >= 28)) s += 1;
      if (a.who === "adult" && p.cat === "home-gifts") s += 1;
      if (p.featured) s += 0.5;
      return { p: p, s: s, why: why.slice(0, 3) };
    }

    function results() {
      var ranked = list.map(score).sort(function (x, y) { return y.s - x.s || y.p.price - x.p.price; }).slice(0, 3);
      var pen = quiz.a.level === "new" && products().filter(function (p) { return /placer pen/i.test(p.name); })[0];
      body.innerHTML =
        '<div class="dp-quiz-result">' +
          '<p class="dp-shelf-title">Your matches</p><h3 class="dp-quiz-q">We think you\'ll love…</h3>' +
          '<div class="dp-picks">' + ranked.map(function (r, i) {
            return '<a class="dp-pick" href="' + esc(r.p.url) + '">' +
              (i === 0 ? '<span class="dp-pick-top">' + SPARKLE + " Best match</span>" : "") +
              (r.p.img ? '<img src="' + esc(r.p.img) + '" alt="" loading="lazy">' : "") +
              '<span class="dp-pick-body"><strong>' + esc(r.p.name) + '</strong><span class="dp-pick-price">' + esc(window.GC_SALE && GC_SALE.on && r.p.price ? "$" + ((Math.round(r.p.price * 100) - Math.floor(Math.round(r.p.price * 100) * 15 / 100)) / 100).toFixed(2) : r.p.priceText || "") + "</span>" +
              (r.why.length ? '<span class="dp-pick-why">' + r.why.map(function (w) { return "<i>" + esc(w) + "</i>"; }).join("") + "</span>" : "") +
              '<span class="dp-pick-cta">View kit →</span></span></a>';
          }).join("") + "</div>" +
          (pen ? '<p class="dp-tipbox">' + SPARKLE + ' <span><strong>New to diamond painting?</strong> A comfy pen makes it easier. Have a look at our <a href="' + esc(pen.url) + '">' + esc(pen.name) + "</a>.</span></p>" : "") +
          '<div class="dp-quiz-nav"><button type="button" class="dp-link-btn" data-restart>↺ Start over</button><a class="btn btn-outline btn-sm" href="' + esc(cfg.shopUrl) + '">See all kits</a></div>' +
        "</div>";
    }
  }

  /* =========================================================
     Tool 6: Missing Drill Helper
     ========================================================= */
  var AMOUNTS = ["Fewer than 20", "20 to 50", "50 to 100", "More than 100", "Not sure"];
  var WHERE = ["The GleamCanvas website", "Etsy", "Amazon", "A shop or market", "It was a gift"];

  /* ---------- Missing Drill Helper: match a color from a photo of the painting ----------
     The visitor photographs their work and taps placed drills in the color they're short of. We read a small
     circle around the tap, keep the middle band of brightness (40%–85%: drops the gaps, shadows, dark facets and sparkle highlights), average
     the rest in linear light, optionally correct the lighting from a tapped white spot (canvas margin, paper),
     and list the nearest DMC colors. Everything stays on the device. */
  var MATCH_SIZES = { small: 0.012, medium: 0.022, large: 0.04 };
  function photoMatchHtml() {
    return '<div class="dp-pmatch" data-pmatch>' +
      '<h3 class="dp-h3">Not sure which color it is? Match it from a photo</h3>' +
      '<p class="dp-help">Take a photo of your painting in good daylight, then tap a patch of drills you\'ve already placed in the color you\'re running out of. Your photo stays on your device.</p>' +
      '<label class="btn btn-outline btn-sm dp-file-btn">Take Or Choose A Photo<input type="file" accept="image/*" data-pm-file hidden></label>' +
      '<div class="dp-pm-stage" data-pm-stage hidden>' +
        '<p class="dp-pm-tip" data-pm-tip>Tap the middle of a patch of the color you need.</p><p class="dp-help dp-pm-wbtip">Indoor light makes colors look warmer or bluer. For a better match, first tap <strong>Fix the lighting</strong> below, then tap something white.</p>' +
        '<canvas data-pm-canvas aria-label="Your painting. Tap a color to match it." role="img"></canvas>' +
        '<div class="dp-pm-tools">' +
          '<div class="dp-fieldset"><span class="dp-label">Area to read</span>' + seg("pmsize", [["small", "Small"], ["medium", "Medium"], ["large", "Large"]], "medium") + "</div>" +
          '<div class="dp-fieldset"><span class="dp-label">Lighting <small>(optional)</small></span>' +
            '<button type="button" class="dp-link-btn" data-pm-white>Fix the lighting: tap something white</button>' +
            '<span class="dp-pm-wb" data-pm-wb hidden>✓ Lighting corrected <button type="button" class="dp-link-btn" data-pm-wb-reset>Undo</button></span></div>' +
        "</div>" +
      "</div>" +
      '<div data-pm-result aria-live="polite"></div>' +
    "</div>";
  }
  function setupPhotoMatch(body, addToRequest) {
    var box = $("[data-pmatch]", body), cv = $("[data-pm-canvas]", box), ctx = cv.getContext("2d"), base = null;
    var size = "medium", gains = null, wantWhite = false, last = null;
    var LIN = new Float32Array(256); for (var t = 0; t < 256; t++) LIN[t] = lin(t);
    var gam = function (v) { v = v <= 0.0031308 ? 12.92 * v : 1.055 * Math.pow(v, 1 / 2.4) - 0.055; return clamp(Math.round(v * 255), 0, 255); };
    $("[data-pm-file]", box).addEventListener("change", function (e) {
      var file = e.target.files[0]; e.target.value = "";
      if (!file || !/^image\//.test(file.type)) return;
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        var k = Math.min(1, 1400 / Math.max(img.naturalWidth, img.naturalHeight));
        base = document.createElement("canvas"); base.width = Math.round(img.naturalWidth * k); base.height = Math.round(img.naturalHeight * k);
        base.getContext("2d").drawImage(img, 0, 0, base.width, base.height);
        cv.width = base.width; cv.height = base.height; ctx.drawImage(base, 0, 0);
        gains = null; last = null; $("[data-pm-wb]", box).hidden = true; $("[data-pm-white]", box).hidden = false; $("[data-pm-result]", box).innerHTML = "";
        $("[data-pm-stage]", box).hidden = false; URL.revokeObjectURL(url);
        cv.scrollIntoView({ behavior: "smooth", block: "center" });
      };
      img.src = url;
    });
    // Read the circle around (x, y): returns the averaged linear color and how mixed the spot is
    function readSpot(x, y) {
      var r = Math.max(5, Math.round(Math.min(base.width, base.height) * MATCH_SIZES[size]));
      var x0 = clamp(x - r, 0, base.width - 1), y0 = clamp(y - r, 0, base.height - 1), w = Math.min(base.width - x0, r * 2 + 1), h = Math.min(base.height - y0, r * 2 + 1);
      var d = base.getContext("2d").getImageData(x0, y0, w, h).data, px = [];
      for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) {
        var dx = x0 + xx - x, dy = y0 + yy - y; if (dx * dx + dy * dy > r * r) continue;
        var i = (yy * w + xx) * 4, R = LIN[d[i]], G = LIN[d[i + 1]], B = LIN[d[i + 2]];
        px.push([0.2126 * R + 0.7152 * G + 0.0722 * B, R, G, B]);
      }
      px.sort(function (a, b) { return a[0] - b[0]; });
      var keep = px.slice(Math.floor(px.length * 0.4), Math.max(Math.floor(px.length * 0.4) + 1, Math.floor(px.length * 0.85)));
      var s = [0, 0, 0]; keep.forEach(function (p) { s[0] += p[1]; s[1] += p[2]; s[2] += p[3]; });
      var avg = [s[0] / keep.length, s[1] / keep.length, s[2] / keep.length];
      // how mixed: spread of the kept pixels in Lab
      var labs = keep.filter(function (p, j) { return j % 3 === 0; }).map(function (p) { return rgbToLab(gam(p[1]), gam(p[2]), gam(p[3])); });
      var m = [0, 0, 0]; labs.forEach(function (l) { m[0] += l[0]; m[1] += l[1]; m[2] += l[2]; }); m = m.map(function (v) { return v / labs.length; });
      var spread = 0; labs.forEach(function (l) { spread += dE(l, m); }); spread /= labs.length;
      return { lin: avg, r: r, spread: spread };
    }
    function mark(x, y, r, color) {
      ctx.drawImage(base, 0, 0);
      ctx.lineWidth = Math.max(2, r * 0.18); ctx.strokeStyle = "#fff"; ctx.beginPath(); ctx.arc(x, y, r, 0, 6.2832); ctx.stroke();
      ctx.lineWidth = Math.max(1, r * 0.08); ctx.strokeStyle = color; ctx.beginPath(); ctx.arc(x, y, r + ctx.lineWidth * 1.5, 0, 6.2832); ctx.stroke();
    }
    function show(spot) {
      var c = spot.lin.slice();
      if (gains) c = [c[0] * gains[0], c[1] * gains[1], c[2] * gains[2]];
      var rgb = [gam(c[0]), gam(c[1]), gam(c[2])], lab = rgbToLab(rgb[0], rgb[1], rgb[2]), hex = rgbToHex(rgb[0], rgb[1], rgb[2]);
      var list = nearest(lab, DMC, 5);
      $("[data-pm-result]", box).innerHTML =
        '<div class="dp-pm-found"><i style="background:' + hex + '"></i><span><strong>Color in your photo</strong><small>' + (gains ? "Lighting corrected" : "As photographed") + "</small></span></div>" +
        (spot.spread > 11 ? '<p class="dp-error">This spot seems to mix more than one color. Tap the middle of a single-color patch, or choose a Small area.</p>' : "") +
        '<p class="dp-label">Closest DMC colors</p>' +
        list.map(function (m) {
          return '<div class="dp-pm-row"><i style="background:' + m.d.hex + '"></i><span><strong>DMC ' + esc(m.d.code) + "</strong> " + esc(m.d.name) + "<small>" + matchQuality(m.dist) + "</small></span>" +
            '<button type="button" class="btn btn-outline btn-sm" data-pm-add="' + esc(m.d.code) + '">Add To My Request</button></div>';
        }).join("") +
        '<p class="dp-fine">Phone cameras and lamps shift colors a little, so check the top matches against the codes on your bags. Daylight near a window gives the best match.</p>';
    }
    cv.addEventListener("click", function (e) {
      if (!base) return;
      var b = cv.getBoundingClientRect(), x = Math.round((e.clientX - b.left) / b.width * cv.width), y = Math.round((e.clientY - b.top) / b.height * cv.height);
      loadDMC().then(function () {
        var spot = readSpot(x, y);
        if (wantWhite) {
          wantWhite = false; $("[data-pm-tip]", box).textContent = "Tap the middle of a patch of the color you need.";
          var L = spot.lin, Y = (L[0] + L[1] + L[2]) / 3;
          if (Math.max(L[0], L[1], L[2]) > 0.93) { $("[data-pm-result]", box).innerHTML = '<p class="dp-error">That white is too bright to measure (it looks blown out in the photo). Tap a slightly shaded white area, or take the photo with a little less light.</p>'; return; }
          if (Y < 0.08) { $("[data-pm-result]", box).innerHTML = '<p class="dp-error">That spot is too dark to use as white. Try the white canvas margin or a sheet of paper.</p>'; return; }
          gains = [Y / Math.max(L[0], 1e-4), Y / Math.max(L[1], 1e-4), Y / Math.max(L[2], 1e-4)];
          $("[data-pm-wb]", box).hidden = false; $("[data-pm-white]", box).hidden = true;
          mark(x, y, spot.r, "#123447");
          if (last) show(last); else $("[data-pm-result]", box).innerHTML = '<p class="dp-help">Lighting corrected. Now tap the color you need.</p>';
          return;
        }
        last = spot; mark(x, y, spot.r, "#f07cae"); show(spot);
      }, function () {});
    });
    box.addEventListener("click", function (e) {
      var sb = e.target.closest('[data-seg="pmsize"]');
      if (sb) { size = sb.getAttribute("data-val"); $$('[data-seg="pmsize"]', box).forEach(function (x) { x.setAttribute("aria-pressed", String(x === sb)); }); return; }
      if (e.target.closest("[data-pm-white]")) { wantWhite = true; $("[data-pm-tip]", box).textContent = "Now tap something white in the photo: the canvas margin or a sheet of paper."; return; }
      if (e.target.closest("[data-pm-wb-reset]")) { gains = null; $("[data-pm-wb]", box).hidden = true; $("[data-pm-white]", box).hidden = false; if (last) show(last); return; }
      var add = e.target.closest("[data-pm-add]");
      if (add) { addToRequest(add.getAttribute("data-pm-add")); add.textContent = "✓ Added"; add.disabled = true; }
    });
  }

  /* ---------- Missing Drill Helper: find missed spots (printed circles) ----------
     On GleamCanvas canvases an empty drill spot is printed as a thin circle (usually black, sometimes colored) with a symbol inside.
     We look for exactly that, at every size from tiny to large:
       - a complete dark ring (nearly every point around it is dark),
       - light inside the ring (bare canvas), clearly lighter than the ring,
       - a dark symbol in the middle.
     A placed black drill is dark all the way through, a light drill has no dark ring, and the dark gaps between
     round drills never close into a full circle, so none of those count. All circles on one canvas share a
     size, so matches far from the most common size are dropped. If nothing qualifies we say so plainly. */
  function gapFinderHtml() {
    return '<div class="dp-gaps" data-gaps>' +
      '<p class="dp-help">A spot still waiting for its drill shows a <strong>printed circle with a symbol inside</strong> (usually black, sometimes colored). Take a clear photo of your painting in good light, straight on and close enough to see the symbols, and we\'ll circle every one we find. Your photo stays on your device.</p>' +
      '<label class="btn btn-outline btn-sm dp-file-btn">Take Or Choose A Photo<input type="file" accept="image/*" data-gap-file hidden></label>' +
      '<div class="dp-gap-stage" data-gap-stage hidden>' +
        '<p class="dp-pm-tip" data-gap-msg aria-live="polite"></p>' +
        '<canvas data-gap-canvas aria-label="Your painting with missing drills circled" role="img"></canvas>' +
        '<div class="dp-gap-list" data-gap-list></div>' +
        '<p class="dp-fine">Not a missing drill? Tap its circle to clear it. See a circle we haven’t marked? Take a closer, sharper photo in brighter light, so each symbol is easy to read.</p>' +
      "</div>" +
    "</div>";
  }

  // Plain ring search over the whole photo (one candidate per spot; findRings checks each one again).
  function ringGrid(L, w, h) {
    var sorted = Float32Array.from(L).sort(), q = function (f) { return sorted[Math.min(sorted.length - 1, Math.floor(sorted.length * f))]; };
    var dark = clamp(q(0.08) + 0.14, 0.16, 0.42); // "black" for this photo's lighting
    // smallest circle that can hold a readable symbol (smaller "rings" are just drill reflections)
    var minR = Math.max(6, Math.round(Math.min(w, h) * 0.004)), maxR = Math.max(minR + 2, Math.round(Math.min(w, h) * 0.08));
    var found = [];
    function pts(r, n) { var a = []; for (var k = 0; k < n; k++) { var t = k / n * 6.2832; a.push([Math.round(Math.cos(t) * r), Math.round(Math.sin(t) * r)]); } return a; }
    for (var r = minR; r <= maxR; r = Math.max(r + 1, Math.round(r * 1.12))) {
      // the line is checked over a thin band r-1..r+1 (a printed line is thin; wider would let rings of drills pass)
      var nR = r < 10 ? 20 : 32, band = [-1, 0, 1].map(function (dr) { return pts(Math.max(1, r + dr), nR); });
      var inner = pts(Math.max(2, Math.round(r * 0.7)), 16).concat(pts(Math.max(2, Math.min(r - 2, Math.round(r * 0.85))), 16));
      // where the symbol's ink can be: several distances from the centre (letters like C, G, U are open in the middle)
      var mid = pts(Math.max(1, Math.round(r * 0.15)), 8).concat(pts(Math.max(1, Math.round(r * 0.3)), 12), pts(Math.max(1, Math.round(r * 0.42)), 12));
      var step = Math.max(1, Math.round(r / 4)), m = r + 4;
      for (var cy = m; cy < h - m; cy += step) for (var cx = m; cx < w - m; cx += step) {
        var base = cy * w + cx, i, darkN = 0, ringSum = 0;
        // inside first: bare canvas, evenly light on two rings inside the line (cheap, rejects most places at once;
        // rings of placed dark drills with sparkles between them are light only in patches)
        var inSum = 0, inSq = 0, inLight = 0;
        for (i = 0; i < inner.length; i++) { var u = L[base + inner[i][1] * w + inner[i][0]]; inSum += u; inSq += u * u; if (u > dark + 0.15) inLight++; }
        if (inLight < inner.length * 0.75) continue;
        var li = inSum / inner.length;
        if (Math.sqrt(Math.max(0, inSq / inner.length - li * li)) > 0.18) continue;
        // a dark symbol in the middle
        var mn = L[base];
        for (i = 0; i < mid.length; i++) mn = Math.min(mn, L[base + mid[i][1] * w + mid[i][0]]);
        // the printed symbol is dark ink; a placed light drill is only shaded, never that dark in the middle
        if (mn > Math.max(dark + 0.12, li - 0.28)) continue;
        // the full ring. A point counts as dark if it's black, or clearly darker than the inside: a thin line that
        // the camera blurs to grey still counts.
        var darkVs = Math.max(dark, li - 0.22);
        var ringAt = function (b0) { // share of the ring that is dark around centre index b0 (and the ring's mean)
          var dn = 0, sum = 0;
          for (var k = 0; k < nR; k++) {
            var v = 1;
            for (var bi = 0; bi < 3; bi++) { var bv = L[b0 + band[bi][k][1] * w + band[bi][k][0]]; if (bv < v) v = bv; }
            sum += v; if (v <= darkVs) dn++;
          }
          return [dn / nR, sum / nR];
        };
        var rr = ringAt(base), frac = rr[0];
        // almost a full ring? our sampling grid may sit a pixel or two off the real centre: nudge and look again
        if (frac >= 0.55 && frac < 0.85) {
          for (var oy = -2; oy <= 2; oy++) for (var ox = -2; ox <= 2; ox++) {
            if (!ox && !oy) continue;
            var t2 = ringAt(base + oy * w + ox); if (t2[0] > frac) { frac = t2[0]; rr = t2; }
          }
        }
        if (frac < 0.85) continue;
        ringSum = rr[1] * nR;
        var lr = ringSum / nR;
        if (li - lr < 0.16) continue;
        found.push({ x: cx, y: cy, r: r, score: frac + (li - lr) });
      }
    }
    // keep the best circle in each spot
    found.sort(function (a, b) { return b.score - a.score; });
    var keep = [];
    found.forEach(function (c) { if (!keep.some(function (k) { return Math.hypot(k.x - c.x, k.y - c.y) < Math.max(k.r, c.r) * 0.9; })) keep.push(c); });
    return keep;
  }

  // Missed-spot finder. An empty spot is printed as a thin circle (usually black, sometimes colored) with a symbol inside.
  // L = brightness 0..1, S = color strength 0..1, C = color (a = red-green, b = yellow-blue; 2 values per pixel,
  // optional). Returns circles {x, y, r, score}.
  function findRings(L, w, h, S, C) {
    var n = w * h, i, x, y, k, minDim = Math.min(w, h);
    // "ink" = clearly darker than its surroundings (a dark table or a patch of dark drills is not ink)
    var R = Math.max(6, Math.round(minDim * 0.02)), W1 = w + 1, I = new Float64Array(W1 * (h + 1)), ink = new Uint8Array(n), line = new Uint8Array(n);
    for (y = 0; y < h; y++) { var row = 0; for (x = 0; x < w; x++) { row += L[y * w + x]; I[(y + 1) * W1 + x + 1] = I[y * W1 + x + 1] + row; } }
    for (y = 0; y < h; y++) {
      var y0 = Math.max(0, y - R), y1 = Math.min(h, y + R + 1);
      for (x = 0; x < w; x++) {
        var x0 = Math.max(0, x - R), x1 = Math.min(w, x + R + 1);
        var mu = (I[y1 * W1 + x1] - I[y0 * W1 + x1] - I[y1 * W1 + x0] + I[y0 * W1 + x0]) / ((x1 - x0) * (y1 - y0));
        i = y * w + x; if (L[i] < 0.62 && L[i] < mu - Math.max(0.05, mu * 0.18)) ink[i] = 1;
        // the circle's line can print fainter than the symbol (a grey line in a dull photo)
        if (L[i] < 0.78 && L[i] < mu - Math.max(0.04, mu * 0.07)) line[i] = 1;
      }
    }
    // symbols: small, fairly solid ink shapes. Each one is a place to look for a circle around it.
    var lab = new Int32Array(n), stack = new Int32Array(n), seeds = [], id = 0;
    function shapes(mask, maxFill, colored) {
      for (i = 0; i < n; i++) {
        if (!mask[i] || lab[i]) continue;
        id++; var sp = 0, cnt = 0, sumL = 0, sa = 0, sb = 0, bx0 = w, by0 = h, bx1 = 0, by1 = 0;
        stack[sp++] = i; lab[i] = id;
        while (sp) {
          var c = stack[--sp], cx = c % w, cy = (c / w) | 0; cnt++; sumL += L[c]; if (C) { sa += C[2 * c]; sb += C[2 * c + 1]; }
          if (cx < bx0) bx0 = cx; if (cx > bx1) bx1 = cx; if (cy < by0) by0 = cy; if (cy > by1) by1 = cy;
          if (cx > 0 && mask[c - 1] && !lab[c - 1]) { lab[c - 1] = id; stack[sp++] = c - 1; }
          if (cx < w - 1 && mask[c + 1] && !lab[c + 1]) { lab[c + 1] = id; stack[sp++] = c + 1; }
          if (cy > 0 && mask[c - w] && !lab[c - w]) { lab[c - w] = id; stack[sp++] = c - w; }
          if (cy < h - 1 && mask[c + w] && !lab[c + w]) { lab[c + w] = id; stack[sp++] = c + w; }
        }
        var bw = bx1 - bx0 + 1, bh = by1 - by0 + 1, sz = Math.max(bw, bh), fill = cnt / (bw * bh);
        if (sz < 5 || sz > minDim * 0.12 || cnt < 10 || bw / bh < 0.3 || bw / bh > 2.5 || fill < 0.15 || fill > maxFill) continue;
        seeds.push({ x: (bx0 + bx1) / 2, y: (by0 + by1) / 2, rMin: Math.max(6, Math.round(sz * 0.6)), rMax: Math.min(Math.round(minDim * 0.08), Math.round(sz * 1.25)), off: Math.max(2, Math.round(sz * 0.12)), id: id, dark: colored ? undefined : sumL / cnt, col: colored ? [sa / cnt, sb / cnt] : null });
      }
    }
    shapes(ink, 0.9, false);
    // symbols printed in color: clearly another color than their surroundings (not lighter). Drills are colored
    // too, but they're solid round blobs, not letter shapes, so only fairly open shapes count.
    if (C) {
      var IA = new Float64Array(W1 * (h + 1)), IB = new Float64Array(W1 * (h + 1)), cink = new Uint8Array(n);
      for (y = 0; y < h; y++) { var ra = 0, rb = 0; for (x = 0; x < w; x++) { i = y * w + x; ra += C[2 * i]; rb += C[2 * i + 1]; IA[(y + 1) * W1 + x + 1] = IA[y * W1 + x + 1] + ra; IB[(y + 1) * W1 + x + 1] = IB[y * W1 + x + 1] + rb; } }
      for (y = 0; y < h; y++) {
        var cy0 = Math.max(0, y - R), cy1 = Math.min(h, y + R + 1);
        for (x = 0; x < w; x++) {
          i = y * w + x; if (ink[i]) continue;
          var cx0 = Math.max(0, x - R), cx1 = Math.min(w, x + R + 1), ar = (cx1 - cx0) * (cy1 - cy0);
          var ma = (IA[cy1 * W1 + cx1] - IA[cy0 * W1 + cx1] - IA[cy1 * W1 + cx0] + IA[cy0 * W1 + cx0]) / ar;
          var mb = (IB[cy1 * W1 + cx1] - IB[cy0 * W1 + cx1] - IB[cy1 * W1 + cx0] + IB[cy0 * W1 + cx0]) / ar;
          var mL = (I[cy1 * W1 + cx1] - I[cy0 * W1 + cx1] - I[cy1 * W1 + cx0] + I[cy0 * W1 + cx0]) / ar;
          if (L[i] < mL + 0.05 && Math.hypot(C[2 * i] - ma, C[2 * i + 1] - mb) >= 0.15) cink[i] = 1;
        }
      }
      shapes(cink, 0.65, true);
    }
    // circles from the plain ring search are checked the same way (it also finds small circles whose symbol
    // touches the line, which the symbol search above can't separate)
    ringGrid(L, w, h).forEach(function (c) { seeds.push({ x: c.x, y: c.y, rMin: Math.max(6, c.r - 2), rMax: c.r + 2, off: 2, id: -1, grid: 1 }); });
    // how bright this photo's light things are (white drills, canvas): an empty spot's canvas is among them
    var bright = Float32Array.from(L).sort()[Math.floor(n * 0.9)];
    var NA = 36, cs = [], sn = [];
    for (k = 0; k < NA; k++) { cs.push(Math.cos(k / NA * 6.2832)); sn.push(Math.sin(k / NA * 6.2832)); }
    function at(px, py) { px = Math.round(px); py = Math.round(py); return px >= 0 && py >= 0 && px < w && py < h ? py * w + px : -1; }
    // A circle printed in color (not black): its line is one steady color all the way round, clearly different
    // from the canvas inside, and thin (that color doesn't carry on just inside or outside the line).
    var cvKey = null, cvVal = null; // the canvas color around one centre (shared by nearby sizes tried there)
    function colorRing(s, cx, cy, r, bw, need) {
      var a, j, dr;
      var r75 = Math.max(3, Math.round(r * 0.75 / 3) * 3), key = s.id + ":" + cx + ":" + cy + ":" + r75; // nearby sizes share it
      if (cvKey !== key) {
        cvKey = key; cvVal = null;
        var ca = 0, cb = 0, cn = 0, cl = [];
        for (a = 0; a < NA; a += 2) {
          j = at(cx + cs[a] * r75, cy + sn[a] * r75); if (j < 0 || lab[j] === s.id || ink[j]) continue;
          ca += C[2 * j]; cb += C[2 * j + 1]; cl.push(L[j]); cn++;
        }
        if (cn >= 9) { cl.sort(function (p, q) { return p - q; }); cvVal = [ca / cn, cb / cn, cl[cn >> 1]]; }
      }
      if (!cvVal) return false;
      var ca2 = cvVal[0], cb2 = cvVal[1], cL = cvVal[2], pts = [], miss = 0;
      for (a = 0; a < NA; a++) {
        var bj = -1, bd = 0.1;
        for (dr = -bw; dr <= bw; dr++) {
          j = at(cx + cs[a] * (r + dr), cy + sn[a] * (r + dr)); if (j < 0 || L[j] > cL + 0.03) continue;
          var d = Math.hypot(C[2 * j] - ca2, C[2 * j + 1] - cb2); if (d >= bd) { bd = d; bj = j; }
        }
        if (bj < 0) { if (++miss > NA - need) return false; continue; }
        pts.push([a, C[2 * bj], C[2 * bj + 1]]);
      }
      // one steady color (a ring of different drills is many colors)
      var ma = 0, mb = 0; pts.forEach(function (p) { ma += p[1]; mb += p[2]; }); ma /= pts.length; mb /= pts.length;
      var v = 0; pts.forEach(function (p) { v += (p[1] - ma) * (p[1] - ma) + (p[2] - mb) * (p[2] - mb); });
      if (Math.sqrt(v / pts.length) > 0.08) return false;
      // thin: just inside and just outside, the line's color is mostly gone
      var gap = Math.max(2, Math.round(r * 0.12)), rin = r - bw - gap, rout = r + bw + gap, sameIn = 0, sameOut = 0;
      for (a = 0; a < NA; a++) {
        j = at(cx + cs[a] * rin, cy + sn[a] * rin); if (j >= 0 && lab[j] !== s.id && Math.hypot(C[2 * j] - ma, C[2 * j + 1] - mb) < 0.1 * 0.6) sameIn++;
        j = at(cx + cs[a] * rout, cy + sn[a] * rout); if (j >= 0 && Math.hypot(C[2 * j] - ma, C[2 * j + 1] - mb) < 0.1 * 0.6) sameOut++;
      }
      return sameIn <= NA * 0.12 && sameOut <= NA * 0.35;
    }
    function test(s, cx, cy, r) {
      var bw = Math.max(1, Math.round(r * 0.05)), need = s.grid ? 28 : 32, hit = 0, j, dr, a, colored = false;
      // 1. a thin ink line nearly all the way round (photos often show it a little broken)
      for (a = 0; a < NA; a++) {
        for (dr = -bw; dr <= bw; dr++) { j = at(cx + cs[a] * (r + dr), cy + sn[a] * (r + dr)); if (j >= 0 && line[j]) { hit++; break; } }
        if (a + 1 - hit > NA - need) { if (!C || !colorRing(s, cx, cy, r, bw, need)) return null; colored = true; hit = need; break; }
      }
      // 2. bare canvas just inside the line (apart from the symbol) and mostly no ink just outside it
      var gap = Math.max(2, Math.round(r * 0.12)), rin = r - bw - gap, rout = r + bw + gap, inN = 0, outN = 0, lis = [], los = [], sats = [], lineS = 0, ia = 0, ib = 0;
      for (a = 0; a < NA; a++) {
        j = at(cx + cs[a] * rin, cy + sn[a] * rin);
        if (j >= 0 && lab[j] !== s.id) { if (ink[j]) inN++; lis.push(L[j]); if (S) sats.push(S[j]); if (C) { ia += C[2 * j]; ib += C[2 * j + 1]; } }
        j = at(cx + cs[a] * rout, cy + sn[a] * rout); if (j >= 0) { if (ink[j]) outN++; los.push(L[j]); }
        var mn = 1;
        for (dr = -bw; dr <= bw; dr++) { j = at(cx + cs[a] * (r + dr), cy + sn[a] * (r + dr)); if (j >= 0 && L[j] < mn) mn = L[j]; }
        lineS += mn;
      }
      if ((!s.grid && inN > 4) || outN > (s.grid ? 12 : 9) || lis.length < NA / 2) return null;
      lis.sort(function (p, q) { return p - q; });
      var li = lis[lis.length >> 1];
      if (s.dark !== undefined && li - s.dark < 0.2) return null; // the symbol is printed ink, not a fleck or a shadow
      // a colored symbol is clearly another color than the canvas around it (a drill's shine is the drill's color)
      if (s.col && Math.hypot(s.col[0] - ia / lis.length, s.col[1] - ib / lis.length) < 0.15 * 1.3) return null;
      if (li < bright * 0.6) return null; // too dark to be bare canvas (a speckled table, a shadow)
      // the empty spot is pale canvas, not a colored drill (a shine on a bright drill can look like a ring)
      if (S) { sats.sort(function (p, q) { return p - q; }); if (sats[sats.length >> 1] > 0.35) return null; }
      // halfway in it's plain canvas too: hardly any other ink, and no colored drill
      var rm = Math.round(r * 0.6), midInk = 0, midCol = 0, midN = 0;
      for (a = 0; a < NA; a++) {
        j = at(cx + cs[a] * rm, cy + sn[a] * rm); if (j < 0 || lab[j] === s.id) continue;
        midN++; if (ink[j]) midInk++; if (S && S[j] > 0.35) midCol++;
      }
      if (midInk > Math.max(3, midN * 0.15) || midCol > midN * 0.3) return null;
      // 3. the line is clearly darker than the canvas inside it (a colored circle was checked by its color instead)
      if (!colored && li - lineS / NA < li * 0.12) return null;
      // ...and it's a line, not a dark background: mostly lighter again just outside it
      los.sort(function (p, q) { return p - q; });
      var lo = los[los.length >> 1]; if (!colored && lo - lineS / NA < 0.1) return null;
      return { x: Math.round(cx), y: Math.round(cy), r: r, score: hit / NA - inN / NA - outN / NA * 0.5 };
    }
    var found = [];
    seeds.forEach(function (s) {
      // coarse look around the seed, then fine-tune the best centre and size
      var best = null, st = Math.max(1, Math.round(s.off / 2)), ox, oy, r, t;
      for (oy = -s.off; oy <= s.off; oy += st) for (ox = -s.off; ox <= s.off; ox += st) for (r = s.rMin; r <= s.rMax; r++) {
        t = test(s, s.x + ox, s.y + oy, r); if (t && (!best || t.score > best.score)) best = t;
      }
      if (!best) return;
      var b0 = best;
      if (st > 1) for (oy = -st + 1; oy < st; oy++) for (ox = -st + 1; ox < st; ox++) for (r = b0.r - 1; r <= b0.r + 1; r++) {
        t = test(s, b0.x + ox, b0.y + oy, r); if (t && t.score > best.score) best = t;
      }
      found.push(best);
    });
    // keep the best circle in each spot
    found.sort(function (a, b) { return b.score - a.score; });
    var keep = [];
    found.forEach(function (c) { if (!keep.some(function (q) { return Math.hypot(q.x - c.x, q.y - c.y) < Math.max(q.r, c.r) * 0.9; })) keep.push(c); });
    if (keep.length < 2) return keep;
    // all circles on one canvas share a size: keep the size with the most (and clearest) circles, drop the rest
    var bestR = keep[0].r, bestS = 0;
    keep.forEach(function (c0) {
      var sc = 0; keep.forEach(function (c1) { if (Math.abs(c1.r - c0.r) <= c0.r * 0.2) sc += c1.score; });
      if (sc > bestS) { bestS = sc; bestR = c0.r; }
    });
    return keep.filter(function (c) { return Math.abs(c.r - bestR) <= bestR * 0.3; });
  }

  function setupGapFinder(body, addToRequest) {
    var box = $("[data-gaps]", body), cv = $("[data-gap-canvas]", box), ctx = cv.getContext("2d");
    var base = null, circles = [], cleared = [], pix = null, pw = 0, ph = 0;
    var LIN = new Float32Array(256); for (var t = 0; t < 256; t++) LIN[t] = lin(t);
    var gam = function (v) { v = v <= 0.0031308 ? 12.92 * v : 1.055 * Math.pow(v, 1 / 2.4) - 0.055; return clamp(Math.round(v * 255), 0, 255); };
    // The drills right next to a missing spot (not inside its circle): read the 8 neighbours around it, group
    // them by color and return the main color(s), most common first
    function nearColors(c) {
      // drills are wider than the printed circle: their centres sit about 2.9 radii away
      var reads = [], dist = c.r * 2.9, rr = Math.max(2, Math.round(c.r * 0.6)), looked = 0;
      // the bare canvas inside the circle (between the symbol and the line) is our white: it corrects the
      // lighting, and drills that look just like it are really bare canvas next to the spot
      var cw = readAt(c.x, c.y, Math.round(c.r * 0.88), Math.round(c.r * 0.62)), cY = 0.2126 * cw[0] + 0.7152 * cw[1] + 0.0722 * cw[2];
      var cLab = rgbToLab(gam(cw[0]), gam(cw[1]), gam(cw[2])), gains = [1, 1, 1];
      // (exposure too: the white canvas becomes a bright white, about L 92)
      if (Math.hypot(cLab[1], cLab[2]) < 18 && cY > 0.05) gains = [0.8 / Math.max(cw[0], 1e-4), 0.8 / Math.max(cw[1], 1e-4), 0.8 / Math.max(cw[2], 1e-4)];
      var fix = function (v) { return [Math.min(1, v[0] * gains[0]), Math.min(1, v[1] * gains[1]), Math.min(1, v[2] * gains[2])]; };
      var white = fix(cw), whiteLab = rgbToLab(gam(white[0]), gam(white[1]), gam(white[2]));
      for (var a = 0; a < 8; a++) {
        var sx = Math.round(c.x + Math.cos(a * 0.7854) * dist), sy = Math.round(c.y + Math.sin(a * 0.7854) * dist);
        if (sx - rr < 0 || sy - rr < 0 || sx + rr >= pw || sy + rr >= ph) continue;
        var raw = readAt(sx, sy, rr, 0), lv = fix(raw), lb = rgbToLab(gam(lv[0]), gam(lv[1]), gam(lv[2]));
        looked++;
        // a drill is one color (its facets vary only a little for how colorful it is); a gap between drills or the
        // printed canvas is a mix. Bare canvas looks like the white inside the circle.
        if ((raw.mix > 6 && raw.mix > 0.25 * Math.hypot(lb[1], lb[2])) || dE(lb, whiteLab) < 8) continue;
        reads.push({ lin: lv, lab: lb });
      }
      // same color = same hue, even if one drill sits in shadow; its color is read from the best-lit one
      var same = function (p, q) {
        var cp = Math.hypot(p[1], p[2]), cq = Math.hypot(q[1], q[2]);
        if (cp < 12 || cq < 12) return cp < 12 && cq < 12 && Math.abs(p[0] - q[0]) < 25; // whites, grays, blacks
        var dh = Math.abs(Math.atan2(p[2], p[1]) - Math.atan2(q[2], q[1])) * 57.3; if (dh > 180) dh = 360 - dh;
        return dh < 15 && cp / cq < 1.7 && cq / cp < 1.7 && Math.abs(p[0] - q[0]) < 30;
      };
      var groups = [];
      reads.forEach(function (rd) {
        var g = groups.filter(function (q) { return same(q.lab, rd.lab); })[0];
        if (!g) { groups.push({ n: 1, top: rd, lab: rd.lab }); return; }
        g.n++; if (rd.lab[0] > g.top.lab[0]) { g.top = rd; g.lab = rd.lab; }
      });
      groups.sort(function (p, q) { return q.n - p.n; });
      return groups.filter(function (g, j) { return j === 0 || g.n >= 2; }).slice(0, 2).map(function (g) {
        var rgb = [gam(g.top.lin[0]), gam(g.top.lin[1]), gam(g.top.lin[2])];
        return { n: g.n, of: looked, hex: rgbToHex(rgb[0], rgb[1], rgb[2]), dmc: nearest(g.lab, DMC, 1)[0].d };
      });
    }
    // average color (linear) in a disc, or a ring from r0 to r, at (x, y); like the photo matcher it skips the
    // shadows and gaps (darkest 40%) and the sparkles (brightest 15%)
    function readAt(x, y, r, r0) {
      var px = [];
      for (var yy = -r; yy <= r; yy++) for (var xx = -r; xx <= r; xx++) {
        var d2 = xx * xx + yy * yy, X = x + xx, Y = y + yy;
        if (d2 > r * r || d2 < r0 * r0 || X < 0 || Y < 0 || X >= pw || Y >= ph) continue;
        var i = (Y * pw + X) * 4, R = LIN[pix[i]], G = LIN[pix[i + 1]], B = LIN[pix[i + 2]];
        px.push([0.2126 * R + 0.7152 * G + 0.0722 * B, R, G, B]);
      }
      px.sort(function (p, q) { return p[0] - q[0]; });
      var keep = px.slice(Math.floor(px.length * 0.4), Math.max(Math.floor(px.length * 0.4) + 1, Math.floor(px.length * 0.85))), sum = [0, 0, 0];
      keep.forEach(function (p) { sum[0] += p[1]; sum[1] += p[2]; sum[2] += p[3]; });
      var out = keep.length ? [sum[0] / keep.length, sum[1] / keep.length, sum[2] / keep.length] : [0, 0, 0];
      // how mixed the colors are (spread of a*, b*): a drill is one color, a gap between drills or printed canvas is not
      var labs = keep.filter(function (p, j) { return j % 2 === 0; }).map(function (p) { return rgbToLab(gam(p[1]), gam(p[2]), gam(p[3])); });
      var ma = 0, mb = 0; labs.forEach(function (l) { ma += l[1]; mb += l[2]; }); ma /= labs.length || 1; mb /= labs.length || 1;
      var v = 0; labs.forEach(function (l) { v += (l[1] - ma) * (l[1] - ma) + (l[2] - mb) * (l[2] - mb); });
      out.mix = Math.sqrt(v / (labs.length || 1));
      return out;
    }
    function list(shown) {
      var out = $("[data-gap-list]", box);
      if (!shown.length) { out.innerHTML = ""; return; }
      loadDMC().then(function () {
        out.innerHTML = shown.map(function (c, j) {
          return '<div class="dp-gap-item"><b class="dp-gap-num">' + (j + 1) + '</b><div><p class="dp-label">Drills right next to it</p>' +
            (nearColors(c).map(function (m) {
              return '<div class="dp-pm-row"><i style="background:' + m.dmc.hex + '"></i><span><strong>DMC ' + esc(m.dmc.code) + "</strong> " + esc(m.dmc.name) +
                '<small><em class="dp-gap-photo" style="background:' + m.hex + '" title="In your photo (lighting corrected)"></em>' + m.n + " of " + m.of + " spots around it</small></span>" +
                '<button type="button" class="btn btn-outline btn-sm" data-gap-add="' + esc(m.dmc.code) + '">Add To My Request</button></div>';
            }).join("") || '<p class="dp-help">No drills placed right next to it yet.</p>') + "</div></div>";
        }).join("") +
        '<p class="dp-fine">A missing drill is usually the same color as the drills around it, but not always. Check the symbol in its circle against the color key on your canvas. Phone cameras and lamps shift colors a little, so compare with the codes on your bags.</p>';
      }, function () { out.innerHTML = ""; });
    }
    function draw() {
      ctx.drawImage(base, 0, 0);
      var shown = circles.filter(function (c, i) { return cleared.indexOf(i) < 0; });
      var k = cv.width / Math.max(1, cv.getBoundingClientRect().width || cv.width); // canvas pixels per screen pixel
      shown.forEach(function (c, j) {
        var r = Math.max(c.r * 1.45, cv.width * 0.012);
        ctx.fillStyle = "rgba(240,124,174,.28)"; ctx.beginPath(); ctx.arc(c.x, c.y, r, 0, 6.2832); ctx.fill();
        ctx.lineWidth = Math.max(3, r * 0.22); ctx.strokeStyle = "#fff"; ctx.beginPath(); ctx.arc(c.x, c.y, r, 0, 6.2832); ctx.stroke();
        ctx.lineWidth = Math.max(2, r * 0.12); ctx.strokeStyle = "#e0457f"; ctx.beginPath(); ctx.arc(c.x, c.y, r, 0, 6.2832); ctx.stroke();
        // its number, on a navy dot at the top right of the circle (about 22 px wide on screen)
        var br = 11 * k, bx = Math.min(cv.width - br, c.x + r * 0.75), by = Math.max(br, c.y - r * 0.75);
        ctx.fillStyle = "#22607f"; ctx.beginPath(); ctx.arc(bx, by, br, 0, 6.2832); ctx.fill();
        ctx.lineWidth = 2 * k; ctx.strokeStyle = "#fff"; ctx.stroke();
        ctx.fillStyle = "#fff"; ctx.font = "800 " + Math.round(13 * k) + "px Nunito, sans-serif"; ctx.textAlign = "center"; ctx.textBaseline = "middle";
        ctx.fillText(String(j + 1), bx, by + k);
      });
      box.setAttribute("data-found", JSON.stringify(shown.map(function (c) { return [c.x, c.y, c.r]; })));
      $("[data-gap-msg]", box).textContent = shown.length
        ? "Found " + shown.length + " missing " + (shown.length === 1 ? "drill" : "drills") + " (circles with a symbol), circled in pink and numbered."
        : "Missing drill not found.";
      list(shown);
    }
    box.addEventListener("click", function (e) {
      var add = e.target.closest("[data-gap-add]");
      if (add && addToRequest) { addToRequest(add.getAttribute("data-gap-add")); add.textContent = "✓ Added"; add.disabled = true; }
    });
    $("[data-gap-file]", box).addEventListener("change", function (e) {
      var file = e.target.files[0]; e.target.value = "";
      if (!file || !/^image\//.test(file.type)) return;
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        var k = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight)), w = Math.round(img.naturalWidth * k), h = Math.round(img.naturalHeight * k);
        base = document.createElement("canvas"); base.width = w; base.height = h; base.getContext("2d").drawImage(img, 0, 0, w, h);
        cv.width = w; cv.height = h; URL.revokeObjectURL(url);
        $("[data-gap-stage]", box).hidden = false;
        $("[data-gap-msg]", box).textContent = "Looking for circles with a symbol…";
        ctx.drawImage(base, 0, 0);
        setTimeout(function () {
          var d = base.getContext("2d").getImageData(0, 0, w, h).data, L = new Float32Array(w * h), S = new Float32Array(w * h), C = new Float32Array(w * h * 2);
          for (var i = 0; i < w * h; i++) {
            var cr = d[i * 4], cg = d[i * 4 + 1], cb = d[i * 4 + 2], cmx = Math.max(cr, cg, cb);
            L[i] = (0.2126 * cr + 0.7152 * cg + 0.0722 * cb) / 255; S[i] = cmx ? (cmx - Math.min(cr, cg, cb)) / cmx : 0;
            C[2 * i] = (cr - cg) / 255; C[2 * i + 1] = ((cr + cg) / 2 - cb) / 255;
          }
          circles = findRings(L, w, h, S, C); cleared = []; pix = d; pw = w; ph = h;
          // number them like reading a page: top to bottom, left to right
          circles.sort(function (a, b) { return Math.abs(a.y - b.y) > Math.max(a.r, b.r) ? a.y - b.y : a.x - b.x; });
          draw();
          cv.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 40);
      };
      img.src = url;
    });
    cv.addEventListener("click", function (e) {
      if (!circles.length) return;
      var b = cv.getBoundingClientRect(), x = (e.clientX - b.left) / b.width * cv.width, y = (e.clientY - b.top) / b.height * cv.height, best = -1, bd = Infinity;
      circles.forEach(function (c, i) { if (cleared.indexOf(i) >= 0) return; var dd = Math.hypot(c.x - x, c.y - y); if (dd < bd) { bd = dd; best = i; } });
      if (best >= 0 && bd < Math.max(circles[best].r * 2.5, cv.width * 0.02)) { cleared.push(best); draw(); }
    });
  }

  /* ---------- Tool: Missed Drill Finder (on its own; colors it finds go to the Missing Drill Helper's request) ---------- */
  var pendingCodes = []; // DMC codes waiting to be put in the Missing Drill Helper's request form
  function finderTool(body) {
    body.innerHTML = '<p class="dp-intro">Photograph your painting and we\'ll circle every spot still waiting for its drill, and tell you the color of the drills right next to it.</p>' +
      gapFinderHtml() +
      '<div class="dp-gap-go" data-gap-go hidden><span data-gap-go-text></span><button type="button" class="btn btn-primary btn-sm" data-gap-go-btn>Go To My Request</button></div>';
    var codes = [];
    setupGapFinder(body, function (code) {
      if (codes.indexOf(code) < 0) codes.push(code);
      $("[data-gap-go]", body).hidden = false;
      $("[data-gap-go-text]", body).textContent = "Ready to request: DMC " + codes.join(", ");
    });
    $("[data-gap-go-btn]", body).addEventListener("click", function () { pendingCodes = codes.slice(); open("missing-drills", true); });
  }

  function missingTool(body) {
    var posted = /[?&]contact_posted=true/.test(location.search);
    if (posted) { thanks(); return; }
    var kits = products().filter(function (p) { return p.cat !== "tools"; });
    var row = function (n) {
      return '<div class="dp-miss-row" data-row>' +
        '<label class="sr-only" for="dp-sym-' + n + '">Symbol</label><input id="dp-sym-' + n + '" class="dp-input" type="text" maxlength="6" placeholder="Symbol" data-sym>' +
        '<label class="sr-only" for="dp-code-' + n + '">DMC code</label><input id="dp-code-' + n + '" class="dp-input" type="text" maxlength="6" placeholder="DMC code" data-code-in>' +
        '<label class="sr-only" for="dp-amt-' + n + '">How many</label><select id="dp-amt-' + n + '" class="dp-input" data-amt>' + AMOUNTS.map(function (a) { return "<option>" + a + "</option>"; }).join("") + "</select>" +
        '<input type="hidden" data-row-out></div>';
    };
    var rows = 1;
    body.innerHTML =
      '<p class="dp-intro">Running short of a color is frustrating. Here\'s how to find it fast, and how to ask us for more.</p>' +
      '<div class="dp-miss">' +
        '<div class="dp-miss-help">' +
          '<h3 class="dp-h3">Before you write</h3>' +
          '<ol class="dp-steps">' +
            "<li><strong>Check the extras.</strong> Every kit includes spare drills, so count what's left in the bag before you start worrying.</li>" +
            "<li><strong>Look in the corners.</strong> Drills love to hide in bag seams, tray corners and under your work mat.</li>" +
            "<li><strong>Double-check the symbol.</strong> Some colors look alike under lamp light. Compare the code on the bag with the legend.</li>" +
          "</ol>" +
          photoMatchHtml() +
          '<p class="dp-help dp-gap-pointer">Not sure where a drill is missing? The <button type="button" class="dp-link-btn" data-goto="drill-finder">Missed Drill Finder</button> circles empty spots in a photo of your painting.</p>' +
          '<h3 class="dp-h3">Need to keep going tonight?</h3>' +
          '<p class="dp-help">Type the DMC code you\'re short of to see close stand-ins you might already have.</p>' +
          '<div class="dp-inline"><label class="sr-only" for="dp-sub">DMC code</label><input id="dp-sub" class="dp-input" type="text" maxlength="6" placeholder="e.g. 321" data-sub></div>' +
          '<div data-subs></div>' +
        "</div>" +
        '<form class="dp-miss-form" data-miss-form' + (cfg.contactAction ? ' method="post" action="' + esc(cfg.contactAction) + '" accept-charset="UTF-8"' : "") + ">" +
          (cfg.contactAction ? '<input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[Request]" value="Missing drills">' : "") +
          '<h3 class="dp-h3">Ask us for more drills</h3>' +
          '<div class="dp-two">' +
            '<div class="dp-fieldset"><label class="dp-label" for="dp-m-name">Your name *</label><input id="dp-m-name" class="dp-input" name="contact[name]" autocomplete="name" required></div>' +
            '<div class="dp-fieldset"><label class="dp-label" for="dp-m-email">Email *</label><input id="dp-m-email" class="dp-input" type="email" name="contact[email]" autocomplete="email" required></div>' +
          "</div>" +
          '<div class="dp-fieldset"><label class="dp-label" for="dp-m-kit">Which kit? *</label><select id="dp-m-kit" class="dp-input" name="contact[Kit]" required><option value="">Choose your kit</option>' +
            kits.map(function (p) { return "<option>" + esc(p.name) + "</option>"; }).join("") + "<option>Another kit</option></select></div>" +
          '<div class="dp-two">' +
            '<div class="dp-fieldset"><label class="dp-label" for="dp-m-where">Where did you get it?</label><select id="dp-m-where" class="dp-input" name="contact[Bought from]">' + WHERE.map(function (w) { return "<option>" + w + "</option>"; }).join("") + "</select></div>" +
            '<div class="dp-fieldset"><label class="dp-label" for="dp-m-order">Order number <small>(if you have it)</small></label><input id="dp-m-order" class="dp-input" name="contact[Order number]"></div>' +
          "</div>" +
          '<div class="dp-fieldset"><span class="dp-label">Missing colors *</span><p class="dp-help" style="margin:0 0 8px">The symbol from your canvas, the DMC code on the bag if you know it, and roughly how many you need.</p>' +
            '<div data-rows>' + row(1) + "</div>" +
            '<button type="button" class="dp-link-btn" data-add-row>+ Add another color</button><p class="dp-error" data-rows-error hidden>Please add the symbol or DMC code for at least one color.</p></div>' +
          '<div class="dp-fieldset"><label class="dp-label" for="dp-m-notes">Anything else? <small>(optional)</small></label><textarea id="dp-m-notes" class="dp-input" name="contact[body]" rows="3"></textarea></div>' +
          '<button type="submit" class="btn btn-primary">Send my request</button>' +
          '<p class="dp-fine">Have a photo of your canvas? Reply to our email with it. Pictures help us match the color.</p>' +
        "</form>" +
      "</div>";

    body.addEventListener("input", function (e) {
      if (e.target.closest("[data-row]")) { $("[data-rows-error]", body).hidden = true; return; }
      if (!e.target.hasAttribute("data-sub")) return;
      var box = $("[data-subs]", body), code = e.target.value;
      if (!code.trim()) { box.innerHTML = ""; return; }
      loadDMC().then(function () {
        var d = byCode(code);
        if (!d) { box.innerHTML = '<p class="dp-help">We don\'t know that code. Check the number on the bag (e.g. 310, 3865, B5200).</p>'; return; }
        box.innerHTML = '<div class="dp-target"><i style="background:' + d.hex + '"></i>DMC ' + esc(d.code) + " " + esc(d.name) + "</div>" +
          nearest(d.lab, DMC, 4, d).map(function (m) {
            return '<button type="button" class="dp-match-row" data-code="' + esc(m.d.code) + '"><i style="background:' + m.d.hex + '"></i><span><strong>DMC ' + esc(m.d.code) + "</strong> " + esc(m.d.name) + "</span><small>" + matchQuality(m.dist) + "</small></button>";
          }).join("") +
          '<p class="dp-fine">A close stand-in usually blends in well, especially in busy areas.</p>';
      }, function () {});
    });
    body.addEventListener("click", function (e) {
      if (e.target.closest("[data-add-row]")) {
        if (rows >= 8) return;
        rows++;
        $("[data-rows]", body).insertAdjacentHTML("beforeend", row(rows));
        $("[data-rows] [data-row]:last-child [data-sym]", body).focus();
        if (rows >= 8) e.target.closest("[data-add-row]").hidden = true;
        return;
      }
      var go = e.target.closest("[data-goto]");
      if (go) { open(go.getAttribute("data-goto"), true); return; }
      var c = e.target.closest(".dp-match-row[data-code]");
      if (c) openFinderAt(c.getAttribute("data-code"));
    });
    // "Add To My Request" from the photo matcher and the missed-spot finder: put the DMC code in the first empty color row
    function addToRequest(code) {
      var target = $$("[data-row]", body).filter(function (r) { return !$("[data-code-in]", r).value.trim() && !$("[data-sym]", r).value.trim(); })[0];
      if (!target && rows < 8) { $("[data-add-row]", body).click(); target = $("[data-rows] [data-row]:last-child", body); }
      if (!target) return;
      var inp = $("[data-code-in]", target); inp.value = code;
      $("[data-rows-error]", body).hidden = true;
      target.classList.add("is-flash"); setTimeout(function () { target.classList.remove("is-flash"); }, 1600);
      target.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    setupPhotoMatch(body, addToRequest);
    // colors chosen in the Missed Drill Finder
    if (pendingCodes.length) { pendingCodes.forEach(addToRequest); pendingCodes = []; }
    $("[data-miss-form]", body).addEventListener("submit", function (e) {
      var filled = 0;
      $$("[data-row]", body).forEach(function (r, i) {
        var sym = $("[data-sym]", r).value.trim(), code = $("[data-code-in]", r).value.trim(), out = $("[data-row-out]", r);
        out.removeAttribute("name");
        if (!sym && !code) return;
        filled++;
        out.name = "contact[Missing color " + filled + "]";
        out.value = [sym && "Symbol " + sym, code && "DMC " + code, $("[data-amt]", r).value].filter(Boolean).join(" · ");
      });
      var err = $("[data-rows-error]", body);
      err.hidden = filled > 0;
      if (!filled) { e.preventDefault(); $("[data-sym]", body).focus(); return; }
      if (!cfg.contactAction) { e.preventDefault(); thanks(true); }
    });

    function thanks(preview) {
      body.innerHTML = '<div class="cf-thanks">' + SPARKLE + "<h3>Thank you! Your request is on its way.</h3><p>We'll reply by email to help you finish your sparkle.</p>" +
        (preview ? '<p class="ds-mode-note"><strong>Preview mode:</strong> nothing was sent. On the Shopify store, requests arrive in your store email.</p>' : "") +
        '<button type="button" class="dp-link-btn" data-again>Send another request</button></div>';
      $("[data-again]", body).addEventListener("click", function () {
        if (!preview) { try { history.replaceState(null, "", location.pathname + "#missing-drills"); } catch (e) {} }
        open("missing-drills", false); // fresh panel, so listeners aren't doubled
      });
    }
  }

  /* =========================================================
     Shared: the journal's storage (this device only)
     ========================================================= */
  var J_KEY = "gc_journal", T_KEY = "gc_timer";
  var STATUSES = [["planned", "Planned"], ["active", "In progress"], ["done", "Finished"]];
  function store(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); return true; }
    catch (e) { return false; } // full (usually too many photos) or blocked
  }
  function today() { var d = new Date(); return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2); }
  function niceDate(s) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(s || "")) return "";
    var p = s.split("-"); return new Date(+p[0], +p[1] - 1, +p[2]).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  }
  function hm(min) {
    min = Math.round(min || 0);
    if (min < 60) return min + " min";
    var h = Math.floor(min / 60), m = min % 60;
    return h + "h" + (m ? " " + m + "m" : "");
  }
  function cleanProject(p) {
    if (!p || typeof p !== "object") return null;
    var num = function (v, max) { v = Math.round(+v || 0); return clamp(v, 0, max || 1e7); };
    var str = function (v, n) { return typeof v === "string" ? v.slice(0, n) : ""; };
    return {
      id: str(p.id, 40) || ("p" + Date.now() + Math.random().toString(36).slice(2, 6)),
      name: str(p.name, 60) || "My project", kit: str(p.kit, 80), size: str(p.size, 40),
      status: STATUSES.some(function (s) { return s[0] === p.status; }) ? p.status : "planned",
      total: num(p.total), placed: num(p.placed), minutes: num(p.minutes), colors: num(p.colors, 999),
      started: str(p.started, 10), finished: str(p.finished, 10), notes: str(p.notes, 4000), updated: Math.max(0, +p.updated || 0),
      photos: Array.isArray(p.photos) ? p.photos.filter(function (u) { return typeof u === "string" && /^data:image\/(jpeg|png);base64,/.test(u); }).slice(0, 8) : [],
      log: Array.isArray(p.log) ? p.log.filter(function (l) { return l && typeof l === "object"; }).slice(-200).map(function (l) {
        return { d: str(l.d, 10) || today(), min: num(l.min, 1440), drills: num(l.drills, 1e6), note: str(l.note, 200) };
      }) : []
    };
  }
  function loadJournal() {
    try {
      var j = JSON.parse(localStorage.getItem(J_KEY) || "null");
      if (j && Array.isArray(j.projects)) return { projects: j.projects.map(cleanProject).filter(Boolean), deleted: cleanDeleted(j.deleted) };
    } catch (e) {}
    return { projects: [], deleted: [] };
  }
  function cleanDeleted(d) { return Array.isArray(d) ? d.filter(function (x) { return x && typeof x.id === "string"; }).slice(-300).map(function (x) { return { id: x.id.slice(0, 40), at: +x.at || 0 }; }) : []; }
  var journal = loadJournal();
  // Save the journal; pass the project that changed so syncing knows it's the newest copy
  function saveJournal(changed) {
    if (changed) changed.updated = Date.now();
    var ok = store(J_KEY, journal);
    scheduleSync();
    return ok;
  }

  /* ---------- Journal and the cloud (signed-in customers only; see gc-cloud.js) ---------- */
  var sync = { state: "", at: 0, timer: null, busy: false };
  function cloudReady() { var c = window.GCCloud && window.GCCloud.status(); return !!(c && c.loggedIn && c.cloud === "ok"); }
  function scheduleSync() {
    if (!cloudReady()) return;
    clearTimeout(sync.timer);
    sync.timer = setTimeout(syncJournal, 2500);
  }
  // Combine this device's journal with the cloud copy: newest version of each project wins,
  // deleted projects stay deleted, and photos (kept on each device) are never lost.
  function mergeJournals(local, remote) {
    var del = {}, byId = {}, order = [];
    cleanDeleted(local.deleted).concat(cleanDeleted(remote && remote.deleted)).forEach(function (d) { del[d.id] = Math.max(del[d.id] || 0, d.at); });
    [(remote && Array.isArray(remote.projects) ? remote.projects : []).map(cleanProject).filter(Boolean), local.projects].forEach(function (list) {
      list.forEach(function (p) {
        var cur = byId[p.id];
        if (!cur) { byId[p.id] = p; order.push(p.id); return; }
        if (p.updated > cur.updated) { if (!p.photos.length && cur.photos.length) p.photos = cur.photos; byId[p.id] = p; }
        else if (!cur.photos.length && p.photos.length) cur.photos = p.photos;
      });
    });
    var projects = order.map(function (id) { return byId[id]; }).filter(function (p) { return !(del[p.id] && del[p.id] >= p.updated); });
    projects.sort(function (a, b) { return b.updated - a.updated; });
    return { projects: projects, deleted: Object.keys(del).map(function (id) { return { id: id, at: del[id] }; }).slice(-300) };
  }
  function syncJournal() {
    if (!cloudReady() || sync.busy) return Promise.resolve(false);
    sync.busy = true; sync.state = "syncing"; paintSync();
    return GCCloud.load("journal").then(function (remote) {
      var merged = mergeJournals(journal, remote);
      journal.projects = merged.projects; journal.deleted = merged.deleted;
      store(J_KEY, journal);
      // Photos stay on this device for now, so the cloud copy leaves them out
      return GCCloud.save("journal", { projects: journal.projects.map(function (p) { return Object.assign({}, p, { photos: [] }); }), deleted: journal.deleted });
    }).then(function () {
      sync.state = "ok"; sync.at = Date.now();
    }, function (e) {
      sync.state = e && e.message === "too-big" ? "too-big" : "error";
    }).then(function () {
      sync.busy = false; paintSync(); refreshJournalView();
      return true;
    });
  }
  var CLOUD_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 18a4.5 4.5 0 0 1-.6-9A6 6 0 0 1 18 9.5a4.3 4.3 0 0 1-.5 8.5z"/></svg>';
  function cloudChip() {
    var c = window.GCCloud && window.GCCloud.status();
    if (!c || c.mode === "off") return "";
    if (!c.loggedIn || c.cloud !== "ok") return '<button type="button" class="dp-cloud is-off" data-j="cloud">' + CLOUD_ICON + "Save to my account</button>";
    var txt = { syncing: "Saving to your account…", error: "Couldn't reach the cloud. We'll try again.", "too-big": "Your journal is too big to save. Try removing a project." }[sync.state] ||
      (sync.at ? "Saved to your account" : "Linked to your account");
    return '<span class="dp-cloud is-on' + (sync.state === "error" || sync.state === "too-big" ? " is-warn" : "") + '" data-cloud-chip role="status">' + CLOUD_ICON + esc(txt) + "</span>";
  }
  function paintSync() { Array.prototype.slice.call(document.querySelectorAll("[data-cloud-chip]")).forEach(function (el) { el.outerHTML = cloudChip(); }); }
  var journalBody = null;
  function refreshJournalView() {
    if (!journalBody || !journalBody.isConnected) return;
    var active = document.activeElement;
    if (active && journalBody.contains(active) && /INPUT|TEXTAREA|SELECT/.test(active.tagName)) return; // don't interrupt typing
    journalTool(journalBody);
  }
  if (window.GCCloud) {
    GCCloud.ready.then(function () { if (cloudReady()) syncJournal(); });
    GCCloud.onChange(function () { if (cloudReady()) syncJournal(); else refreshJournalView(); });
  }
  function findProject(id) { return journal.projects.filter(function (p) { return p.id === id; })[0]; }
  function newProject(fields) {
    var p = cleanProject(Object.assign({ status: "planned", started: today() }, fields || {}));
    journal.projects.unshift(p);
    saveJournal(p);
    return p;
  }
  // Add time and drills to a project (from the timer or a manual entry)
  function logToProject(id, min, drills, note) {
    var p = findProject(id);
    if (!p || (!min && !drills)) return false;
    p.minutes += Math.round(min); p.placed += Math.round(drills);
    if (p.status === "planned") { p.status = "active"; if (!p.started) p.started = today(); }
    p.log.push({ d: today(), min: Math.round(min), drills: Math.round(drills), note: note || "" });
    saveJournal(p);
    return true;
  }
  // Shrink a photo to a small JPEG so it fits in the browser's storage
  function thumbFrom(src, max) {
    var w = src.naturalWidth || src.width, h = src.naturalHeight || src.height, k = Math.min(1, max / Math.max(w, h));
    var c = document.createElement("canvas"); c.width = Math.round(w * k); c.height = Math.round(h * k);
    var x = c.getContext("2d"); x.fillStyle = "#fff"; x.fillRect(0, 0, c.width, c.height); x.drawImage(src, 0, 0, c.width, c.height);
    return c.toDataURL("image/jpeg", 0.78);
  }
  var journalView = { open: null, filter: "all" }; // which project is open in the journal

  /* =========================================================
     Tool 7: Sparkle Session Timer
     ========================================================= */
  var BREAK_TIPS = [
    "Roll your shoulders back five times and let your hands rest.",
    "Look at something far away for 20 seconds. Your eyes will thank you.",
    "Stretch your fingers wide, then make a gentle fist. Repeat a few times.",
    "Stand up, take a little walk and grab some water.",
    "Close the drill trays so nothing spills while you're away.",
    "Tilt your head gently side to side to loosen your neck."
  ];
  var timer = (function () {
    var t = { phase: "focus", running: false, endAt: 0, left: 25 * 60000, focus: 25, brk: 5, project: "", drills: 0, sound: true, day: today(), sessions: 0, minutesToday: 0, tip: 0 };
    try {
      var s = JSON.parse(localStorage.getItem(T_KEY) || "null");
      if (s && typeof s === "object") Object.keys(t).forEach(function (k) { if (typeof s[k] === typeof t[k]) t[k] = s[k]; });
    } catch (e) {}
    t.focus = clamp(Math.round(t.focus), 1, 180); t.brk = clamp(Math.round(t.brk), 1, 60);
    if (t.phase !== "break") t.phase = "focus";
    if (t.day !== today()) { t.day = today(); t.sessions = 0; t.minutesToday = 0; }
    return t;
  })();
  var timerTitle = document.title, timerTicker = null, timerUI = null;
  function saveTimer() { store(T_KEY, timer); }
  function phaseMs() { return (timer.phase === "focus" ? timer.focus : timer.brk) * 60000; }
  function timeLeft() { return timer.running ? Math.max(0, timer.endAt - Date.now()) : timer.left; }
  function mmss(ms) { var s = Math.ceil(ms / 1000), m = Math.floor(s / 60); return m + ":" + ("0" + (s % 60)).slice(-2); }
  function chime() {
    if (!timer.sound) return;
    try {
      var A = window.AudioContext || window.webkitAudioContext, ctx = new A();
      [[659.25, 0], [880, 0.22], [1318.5, 0.44]].forEach(function (n) {
        var o = ctx.createOscillator(), g = ctx.createGain();
        o.type = "sine"; o.frequency.value = n[0];
        g.gain.setValueAtTime(0.0001, ctx.currentTime + n[1]);
        g.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + n[1] + 0.03);
        g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + n[1] + 1.2);
        o.connect(g); g.connect(ctx.destination); o.start(ctx.currentTime + n[1]); o.stop(ctx.currentTime + n[1] + 1.3);
      });
      setTimeout(function () { ctx.close(); }, 2500);
    } catch (e) {}
  }
  // Log the focus time so far (and the drills counted) to today's totals and the chosen project
  function logFocus(ms) {
    var min = Math.round(ms / 60000);
    if (min < 1 && !timer.drills) return "";
    timer.minutesToday += min;
    if (min >= 1) timer.sessions++;
    var msg = "";
    if (timer.project && logToProject(timer.project, min, timer.drills, "Timer session")) msg = " Logged " + hm(min) + (timer.drills ? " and " + fmt(timer.drills) + " drills" : "") + " to " + findProject(timer.project).name + ".";
    timer.drills = 0;
    return msg;
  }
  function finishPhase() {
    var msg;
    if (timer.phase === "focus") {
      msg = "Lovely work! Time for a break." + logFocus(phaseMs());
      timer.phase = "break"; timer.tip = (timer.tip + 1) % BREAK_TIPS.length;
    } else {
      msg = "Break's over. Ready for another sparkle session?";
      timer.phase = "focus";
    }
    timer.running = false; timer.left = phaseMs();
    saveTimer(); chime();
    timerFlash = msg;
    renderTimerUI();
  }
  var timerFlash = "";
  function tick() {
    if (timer.running && Date.now() >= timer.endAt) finishPhase();
    if (timer.running) document.title = "(" + mmss(timeLeft()) + ") " + (timer.phase === "focus" ? "Sparkling" : "Break") + " · " + timerTitle;
    else if (document.title !== timerTitle) document.title = timerTitle;
    if (timerUI && timerUI.isConnected) paintTimer();
    if (!timer.running && timerTicker) { clearInterval(timerTicker); timerTicker = null; }
  }
  function startTicker() { if (!timerTicker) timerTicker = setInterval(tick, 250); tick(); }
  if (root && timer.running) startTicker(); // keeps counting after a reload

  function paintTimer() {
    var el = timerUI, left = timeLeft(), total = phaseMs(), frac = total ? 1 - left / total : 0;
    $("[data-t-time]", el).textContent = mmss(left);
    var ring = $("[data-t-ring]", el);
    ring.style.strokeDashoffset = String(2 * Math.PI * 108 * (1 - frac));
    ring.style.opacity = frac > 0.002 ? "1" : "0"; // no stray dot before it starts
    var elapsedMin = (total - left) / 60000, pace = $("[data-t-pace]", el); // the pace line only exists during a session
    if (pace) pace.textContent = timer.phase === "focus" && timer.drills && elapsedMin >= 1 ? "About " + fmt(timer.drills / elapsedMin * 60) + " drills an hour" : "";
  }
  function renderTimerUI() { if (timerUI && timerUI.isConnected) timerTool(timerUI, true); }

  function timerTool(body, keepFlash) {
    timerUI = body;
    if (!keepFlash) timerFlash = "";
    var focus = timer.phase === "focus", opts = journal.projects.filter(function (p) { return p.status !== "done"; });
    if (timer.project && !findProject(timer.project)) timer.project = "";
    body.innerHTML =
      '<p class="dp-intro">Sparkle in cozy, focused sessions with gentle breaks to rest your eyes and hands. Count your drills as you go, and your time is saved to your journal.</p>' +
      '<div class="dp-timer">' +
        '<div class="dp-timer-face' + (focus ? "" : " is-break") + '">' +
          '<svg viewBox="0 0 240 240" aria-hidden="true"><circle cx="120" cy="120" r="108" class="dp-ring-bg"/>' +
            '<circle cx="120" cy="120" r="108" class="dp-ring" data-t-ring style="stroke-dasharray:' + (2 * Math.PI * 108).toFixed(1) + '"/></svg>' +
          '<div class="dp-timer-read"><span class="dp-timer-phase">' + (focus ? "Sparkle time" : "Break time") + '</span><strong data-t-time role="timer" aria-live="off"></strong>' +
            '<span class="dp-timer-today">Today: ' + timer.sessions + " session" + (timer.sessions === 1 ? "" : "s") + " · " + hm(timer.minutesToday) + "</span></div>" +
        "</div>" +
        '<div class="dp-timer-side">' +
          (timerFlash ? '<p class="dp-tipbox" role="status">' + SPARKLE + " <span>" + esc(timerFlash) + "</span></p>" : "") +
          (!focus ? '<p class="dp-tipbox dp-break-tip">' + SPARKLE + ' <span><strong>Break tip:</strong> ' + esc(BREAK_TIPS[timer.tip % BREAK_TIPS.length]) + "</span></p>" : "") +
          '<div class="dp-timer-btns">' +
            '<button type="button" class="btn btn-primary" data-t="toggle">' + (timer.running ? "Pause" : (timeLeft() < phaseMs() ? "Resume" : (focus ? "Start sparkling" : "Start break"))) + "</button>" +
            (focus && timeLeft() < phaseMs() - 60000 ? '<button type="button" class="btn btn-outline" data-t="log">Finish &amp; log</button>' : "") +
            '<button type="button" class="btn btn-outline" data-t="skip">' + (focus ? "Skip to break" : "Skip break") + "</button>" +
            '<button type="button" class="dp-link-btn" data-t="reset">Reset</button>' +
          "</div>" +
          (focus ? '<div class="dp-counter"><span class="dp-label">Drills placed this session</span>' +
            '<div class="dp-inline"><button type="button" class="dp-count-btn" data-t="minus" aria-label="One less">−</button><strong class="dp-count-num" data-t-drills>' + fmt(timer.drills) + "</strong>" +
            '<button type="button" class="dp-count-btn" data-t="add" data-n="1">+1</button><button type="button" class="dp-count-btn" data-t="add" data-n="10">+10</button><button type="button" class="dp-count-btn" data-t="add" data-n="50">+50</button></div>' +
            '<p class="dp-help" data-t-pace></p></div>' : "") +
          '<div class="dp-fieldset"><label class="dp-label" for="dp-t-proj">Working on</label><select id="dp-t-proj" class="dp-input" data-t-proj><option value="">Just sparkling (don\'t log)</option>' +
            opts.map(function (p) { return '<option value="' + esc(p.id) + '"' + (p.id === timer.project ? " selected" : "") + ">" + esc(p.name) + "</option>"; }).join("") + "</select>" +
            (journal.projects.length ? "" : '<p class="dp-help">Start a project in <button type="button" class="dp-link-btn" data-goto="sparkle-journal">My Sparkle Journal</button> to log your time to it.</p>') + "</div>" +
          '<div class="dp-two">' +
            '<div class="dp-fieldset"><span class="dp-label">Session</span>' + seg("tfocus", [["25", "25 min"], ["45", "45"], ["60", "60"]], String(timer.focus)) + "</div>" +
            '<div class="dp-fieldset"><span class="dp-label">Break</span>' + seg("tbreak", [["5", "5 min"], ["10", "10"], ["15", "15"]], String(timer.brk)) + "</div>" +
          "</div>" +
          '<label class="dp-check"><input type="checkbox" data-t-sound' + (timer.sound ? " checked" : "") + "> Gentle chime when time's up</label>" +
        "</div>" +
      "</div>" +
      '<p class="dp-fine">The timer keeps going if you switch tools or tabs; the time left shows in the browser tab. Your sessions are saved on this device.</p>';
    paintTimer();
    if (body.dataset.bound) return;
    body.dataset.bound = "1";
    body.addEventListener("click", function (e) {
      var go = e.target.closest("[data-goto]");
      if (go) { open(go.getAttribute("data-goto"), true); return; }
      var s = e.target.closest("[data-seg]");
      if (s && (s.getAttribute("data-seg") === "tfocus" || s.getAttribute("data-seg") === "tbreak")) {
        var v = +s.getAttribute("data-val"), isF = s.getAttribute("data-seg") === "tfocus";
        if (isF) timer.focus = v; else timer.brk = v;
        if (!timer.running && ((isF && timer.phase === "focus") || (!isF && timer.phase === "break"))) timer.left = phaseMs();
        saveTimer(); timerTool(body, true); return;
      }
      var b = e.target.closest("[data-t]");
      if (!b) return;
      var a = b.getAttribute("data-t");
      if (a === "toggle") {
        if (timer.running) { timer.left = timeLeft(); timer.running = false; }
        else { timer.endAt = Date.now() + timer.left; timer.running = true; timerFlash = ""; startTicker(); }
      } else if (a === "skip") {
        if (timer.phase === "focus") { timerFlash = "Time for a break." + logFocus(phaseMs() - timeLeft()); timer.phase = "break"; timer.tip = (timer.tip + 1) % BREAK_TIPS.length; }
        else { timer.phase = "focus"; timerFlash = ""; }
        timer.running = false; timer.left = phaseMs();
      } else if (a === "log") {
        timerFlash = "Session saved." + logFocus(phaseMs() - timeLeft());
        timer.running = false; timer.left = phaseMs();
      } else if (a === "reset") { timer.running = false; timer.left = phaseMs(); timer.drills = 0; timerFlash = ""; }
      else if (a === "add") { timer.drills += +b.getAttribute("data-n"); $("[data-t-drills]", body).textContent = fmt(timer.drills); saveTimer(); paintTimer(); return; }
      else if (a === "minus") { timer.drills = Math.max(0, timer.drills - 1); $("[data-t-drills]", body).textContent = fmt(timer.drills); saveTimer(); paintTimer(); return; }
      saveTimer(); tick(); timerTool(body, true);
    });
    body.addEventListener("change", function (e) {
      if (e.target.hasAttribute("data-t-proj")) { timer.project = e.target.value; saveTimer(); }
      if (e.target.hasAttribute("data-t-sound")) { timer.sound = e.target.checked; saveTimer(); }
    });
  }

  /* =========================================================
     Tool 8: My Sparkle Journal
     ========================================================= */
  function journalTool(body) {
    journalBody = body;
    if (!body.dataset.bound) { body.dataset.bound = "1"; bindJournal(body); }
    var p = journalView.open && findProject(journalView.open);
    if (p) journalDetail(body, p); else { journalView.open = null; journalList(body); }
  }
  function progressBar(p) {
    var pct = p.total ? Math.min(100, Math.round(p.placed / p.total * 100)) : (p.status === "done" ? 100 : 0);
    return '<div class="dp-prog" role="img" aria-label="' + pct + '% done"><i style="width:' + pct + '%"></i></div>' +
      '<p class="dp-prog-text"><strong>' + pct + "%</strong> " + (p.total ? fmt(p.placed) + " of " + fmt(p.total) + " drills" : fmt(p.placed) + " drills placed") + "</p>";
  }
  function journalList(body) {
    var ps = journal.projects, done = ps.filter(function (p) { return p.status === "done"; }).length;
    var mins = ps.reduce(function (n, p) { return n + p.minutes; }, 0), drills = ps.reduce(function (n, p) { return n + p.placed; }, 0);
    var shown = ps.filter(function (p) { return journalView.filter === "all" || p.status === journalView.filter; });
    body.innerHTML =
      '<p class="dp-intro">Keep track of every kit you\'re working on: progress, time, photos and notes. Your journal is saved on this device' + (cloudReady() ? " and in your GleamCanvas account (photos stay on this device for now)." : ". Sign up for a free account to keep it safe in our cloud, too.") + "</p>" +
      '<div class="dp-stats">' + stat(ps.length, "project" + (ps.length === 1 ? "" : "s")) + stat(done, "finished") + stat(hm(mins), "spent sparkling") + stat(fmt(drills), "drills placed") + "</div>" +
      '<div class="dp-j-bar">' +
        seg("jfilter", [["all", "All"]].concat(STATUSES), journalView.filter) +
        '<div class="dp-inline">' + cloudChip() + '<button type="button" class="btn btn-primary btn-sm" data-j="new">+ New project</button>' +
        '<button type="button" class="dp-link-btn" data-j="backup">Back up</button><label class="dp-link-btn dp-file">Restore<input type="file" accept=".json,application/json" data-j-restore></label></div>' +
      "</div>" +
      '<p class="dp-status" data-j-msg role="status"></p>' +
      (shown.length ? '<div class="dp-j-grid">' + shown.map(function (p) {
        var st = STATUSES.filter(function (s) { return s[0] === p.status; })[0][1];
        return '<button type="button" class="dp-j-card" data-j-open="' + esc(p.id) + '">' +
          '<span class="dp-j-thumb">' + (p.photos[0] ? '<img src="' + p.photos[0] + '" alt="">' : ICONS.journal) + '<span class="dp-j-status is-' + p.status + '">' + st + "</span></span>" +
          '<span class="dp-j-body"><strong>' + esc(p.name) + "</strong>" + (p.kit ? "<small>" + esc(p.kit) + "</small>" : "") + progressBar(p) +
          '<span class="dp-j-meta">' + hm(p.minutes) + (p.log.length ? " · last sparkled " + niceDate(p.log[p.log.length - 1].d) : "") + "</span></span></button>";
      }).join("") + "</div>"
      : '<div class="dp-j-empty">' + SPARKLE + "<h3>" + (ps.length ? "No projects here yet" : "Start your first project") + "</h3>" +
        "<p>Add a kit you're working on, or plan a new one.</p>" +
        '<div class="dp-inline"><button type="button" class="btn btn-primary btn-sm" data-j="new">+ New project</button>' +
        '<button type="button" class="btn btn-outline btn-sm" data-goto="photo-to-drills">Start from a photo</button>' +
        '<button type="button" class="btn btn-outline btn-sm" data-goto="kit-finder">Help me choose a kit</button></div></div>');
  }
  function journalDetail(body, p) {
    var kits = products().filter(function (k) { return k.cat !== "tools"; }).map(function (k) { return k.name; });
    if (p.kit && kits.indexOf(p.kit) < 0) kits.push(p.kit);
    body.innerHTML =
      '<div class="dp-j-top"><button type="button" class="dp-link-btn" data-j="back">← All projects</button>' + cloudChip() + "</div>" +
      '<div class="dp-j-detail">' +
        '<div class="dp-j-main">' +
          '<div class="dp-fieldset"><label class="dp-label" for="dp-j-name">Project name</label><input id="dp-j-name" class="dp-input" maxlength="60" value="' + esc(p.name) + '" data-jf="name"></div>' +
          '<div class="dp-two">' +
            '<div class="dp-fieldset"><label class="dp-label" for="dp-j-kit">Kit</label><select id="dp-j-kit" class="dp-input" data-jf="kit"><option value="">Choose a kit</option>' +
              kits.concat(["Photo to Drills design", "Another kit"]).filter(function (k, i, a) { return a.indexOf(k) === i; }).map(function (k) { return "<option" + (k === p.kit ? " selected" : "") + ">" + esc(k) + "</option>"; }).join("") + "</select></div>" +
            '<div class="dp-fieldset"><label class="dp-label" for="dp-j-size">Size <small>(optional)</small></label><input id="dp-j-size" class="dp-input" maxlength="40" value="' + esc(p.size) + '" placeholder="e.g. 30 × 40 cm" data-jf="size"></div>' +
          "</div>" +
          '<div class="dp-fieldset"><span class="dp-label">Status</span>' + seg("jstatus", STATUSES, p.status) + "</div>" +
          '<div class="dp-two">' +
            '<div class="dp-fieldset"><label class="dp-label" for="dp-j-start">Started</label><input id="dp-j-start" class="dp-input" type="date" value="' + esc(p.started) + '" data-jf="started"></div>' +
            '<div class="dp-fieldset"><label class="dp-label" for="dp-j-fin">Finished</label><input id="dp-j-fin" class="dp-input" type="date" value="' + esc(p.finished) + '" data-jf="finished"></div>' +
          "</div>" +
          '<div class="dp-fieldset"><label class="dp-label" for="dp-j-notes">Notes</label><textarea id="dp-j-notes" class="dp-input dp-j-notes" rows="4" maxlength="4000" placeholder="Colors you swapped, tricky bits, who it\'s for…" data-jf="notes">' + esc(p.notes) + "</textarea></div>" +
        "</div>" +
        '<div class="dp-j-side">' +
          '<div class="dp-j-progress"><span class="dp-label">Progress</span>' + progressBar(p) +
            '<div class="dp-two"><div class="dp-fieldset"><label class="dp-label" for="dp-j-total">Total drills</label><input id="dp-j-total" class="dp-input" type="number" min="0" value="' + (p.total || "") + '" placeholder="e.g. 9,600" data-jf="total"></div>' +
            '<div class="dp-fieldset"><label class="dp-label" for="dp-j-placed">Placed so far</label><input id="dp-j-placed" class="dp-input" type="number" min="0" value="' + (p.placed || "") + '" data-jf="placed"></div></div>' +
            '<p class="dp-help">' + hm(p.minutes) + " spent sparkling" + (p.colors ? " · " + p.colors + " colors" : "") + "</p>" +
            '<button type="button" class="btn btn-primary btn-sm" data-goto-timer="' + esc(p.id) + '">Start a timed session</button>' +
          "</div>" +
          '<div class="dp-j-log"><span class="dp-label">Log a session</span>' +
            '<div class="dp-inline"><input class="dp-input dp-num" type="number" min="0" max="1440" placeholder="min" aria-label="Minutes" data-jl="min">' +
            '<input class="dp-input dp-num" type="number" min="0" placeholder="drills" aria-label="Drills placed" data-jl="drills">' +
            '<button type="button" class="btn btn-outline btn-sm" data-j="log">Add</button></div>' +
            (p.log.length ? '<ul class="dp-j-entries">' + p.log.slice().reverse().slice(0, 8).map(function (l) {
              return "<li><strong>" + niceDate(l.d) + "</strong> " + hm(l.min) + (l.drills ? " · " + fmt(l.drills) + " drills" : "") + (l.note ? " <small>" + esc(l.note) + "</small>" : "") + "</li>";
            }).join("") + "</ul>" : '<p class="dp-help">No sessions yet.</p>') +
          "</div>" +
        "</div>" +
      "</div>" +
      '<div class="dp-j-photos"><span class="dp-label">Progress photos <small>(up to 8, saved small on this device)</small></span><div class="dp-j-photo-grid">' +
        p.photos.map(function (u, i) { return '<div class="dp-j-photo"><img src="' + u + '" alt="Progress photo ' + (i + 1) + '"><button type="button" data-j-delphoto="' + i + '" aria-label="Remove photo">&times;</button></div>'; }).join("") +
        (p.photos.length < 8 ? '<label class="dp-j-photo dp-j-addphoto"><input type="file" accept="image/*" data-j-photo>+ Add photo</label>' : "") +
      "</div></div>" +
      '<p class="dp-status" data-j-msg role="status"></p>' +
      '<div class="dp-j-danger"><button type="button" class="dp-link-btn" data-j="delete">Delete this project</button></div>';
  }
  function bindJournal(body) {
    var msg = function (t) { var m = $("[data-j-msg]", body); if (m) m.textContent = t; };
    body.addEventListener("click", function (e) {
      var go = e.target.closest("[data-goto]");
      if (go) { open(go.getAttribute("data-goto"), true); return; }
      var gt = e.target.closest("[data-goto-timer]");
      if (gt) { timer.project = gt.getAttribute("data-goto-timer"); if (timer.phase !== "focus" && !timer.running) { timer.phase = "focus"; timer.left = phaseMs(); } saveTimer(); open("session-timer", true); return; }
      var s = e.target.closest("[data-seg]");
      if (s && s.getAttribute("data-seg") === "jfilter") { journalView.filter = s.getAttribute("data-val"); journalTool(body); return; }
      var p = journalView.open && findProject(journalView.open);
      if (s && s.getAttribute("data-seg") === "jstatus" && p) {
        p.status = s.getAttribute("data-val");
        if (p.status === "done" && !p.finished) p.finished = today();
        if (p.status === "done" && p.total && p.placed < p.total) p.placed = p.total;
        saveJournal(p); journalTool(body); return;
      }
      var card = e.target.closest("[data-j-open]");
      if (card) { journalView.open = card.getAttribute("data-j-open"); journalTool(body); body.scrollIntoView({ block: "start", behavior: "smooth" }); return; }
      var dp = e.target.closest("[data-j-delphoto]");
      if (dp && p) { p.photos.splice(+dp.getAttribute("data-j-delphoto"), 1); saveJournal(p); journalTool(body); return; }
      var b = e.target.closest("[data-j]");
      if (!b) return;
      var a = b.getAttribute("data-j");
      if (a === "cloud") { if (window.GCCloud) GCCloud.invite("Create a free GleamCanvas account to keep your Sparkle Journal safe in our cloud and see it on any phone or computer."); return; }
      if (a === "new") { var np = newProject({ name: "My project " + (journal.projects.length + 1), status: "active" }); journalView.open = np.id; journalTool(body); var nm = $("#dp-j-name", body); if (nm) { nm.focus(); nm.select(); } }
      else if (a === "back") { journalView.open = null; journalTool(body); }
      else if (a === "delete" && p) {
        if (!window.confirm('Delete "' + p.name + '"? This can\'t be undone.')) return;
        journal.projects = journal.projects.filter(function (x) { return x !== p; });
        journal.deleted = (journal.deleted || []).concat([{ id: p.id, at: Date.now() }]).slice(-300); // so other devices delete it too
        if (timer.project === p.id) { timer.project = ""; saveTimer(); }
        saveJournal(); journalView.open = null; journalTool(body);
      } else if (a === "log" && p) {
        var mi = +($('[data-jl="min"]', body).value || 0), dr = +($('[data-jl="drills"]', body).value || 0);
        if (!(mi > 0 || dr > 0)) { msg("Add the minutes and/or drills for this session."); return; }
        logToProject(p.id, clamp(mi, 0, 1440), clamp(dr, 0, 1e6), ""); journalTool(body);
      } else if (a === "backup") {
        var blob = new Blob([JSON.stringify({ app: "GleamCanvas Sparkle Journal", saved: today(), projects: journal.projects })], { type: "application/json" });
        var link = document.createElement("a");
        link.href = URL.createObjectURL(blob); link.download = "my-sparkle-journal-" + today() + ".json";
        document.body.appendChild(link); link.click(); link.remove();
        setTimeout(function () { URL.revokeObjectURL(link.href); }, 2000);
        msg("Backup saved. Keep the file somewhere safe; use Restore to bring it back on any device.");
      }
    });
    body.addEventListener("input", function (e) {
      var k = e.target.getAttribute("data-jf"), p = journalView.open && findProject(journalView.open);
      if (!k || !p || e.target.tagName === "SELECT") return;
      if (k === "total" || k === "placed") p[k] = Math.max(0, Math.round(+e.target.value || 0));
      else p[k] = e.target.value.slice(0, k === "notes" ? 4000 : 60);
      if (!saveJournal(p)) msg("Your journal is full on this device. Remove a few photos to make room.");
    });
    body.addEventListener("change", function (e) {
      var t = e.target, p = journalView.open && findProject(journalView.open);
      if (t.getAttribute("data-jf") === "kit" && p) { p.kit = t.value; saveJournal(p); return; }
      if ((t.getAttribute("data-jf") === "total" || t.getAttribute("data-jf") === "placed") && p) { journalTool(body); return; } // refresh the progress bar
      if (t.hasAttribute("data-j-photo") && p && t.files[0]) {
        var url = URL.createObjectURL(t.files[0]), img = new Image();
        img.onload = function () {
          p.photos.push(thumbFrom(img, 640)); URL.revokeObjectURL(url);
          if (!saveJournal(p)) { p.photos.pop(); msg("There's no more room for photos on this device. Remove one and try again."); return; }
          journalTool(body);
        };
        img.onerror = function () { URL.revokeObjectURL(url); msg("That picture couldn't be opened. Try a JPG or PNG."); };
        img.src = url;
        return;
      }
      if (t.hasAttribute("data-j-restore") && t.files[0]) {
        t.files[0].text().then(function (txt) {
          var data = JSON.parse(txt), list = Array.isArray(data.projects) ? data.projects.map(cleanProject).filter(Boolean) : [];
          if (!list.length) throw new Error("empty");
          var known = {}; journal.projects.forEach(function (x) { known[x.id] = true; });
          var added = list.filter(function (x) { return !known[x.id]; });
          journal.projects = added.concat(journal.projects);
          added.forEach(function (x) { x.updated = Date.now(); });
          saveJournal(); journalTool(body);
          msg("Restored " + added.length + " project" + (added.length === 1 ? "" : "s") + (list.length > added.length ? " (" + (list.length - added.length) + " you already had were kept as they are)." : "."));
        }).catch(function () { msg("That file couldn't be restored. Choose a Sparkle Journal backup (.json)."); });
        t.value = "";
      }
    });
  }

  /* ---------- Kit Finder pop-up (shop and home pages) ---------- */
  var quizDialog = null;
  function openQuizDialog() {
    if (!quizDialog) {
      quizDialog = document.createElement("dialog");
      quizDialog.className = "dp-modal";
      quizDialog.setAttribute("aria-labelledby", "dp-modal-title");
      quizDialog.innerHTML =
        '<div class="dp-modal-head"><span class="dp-card-icon">' + ICONS.quiz + '</span><div><p class="dp-shelf-title">Kit Finder</p><h2 id="dp-modal-title">Which Kit Is for Me?</h2></div>' +
        '<button type="button" class="dp-modal-close" aria-label="Close" data-close>' + icon('<path d="M6 6l12 12M18 6 6 18"/>') + "</button></div>" +
        '<div class="dp-modal-body" data-quiz-body></div>';
      document.body.appendChild(quizDialog);
      quizDialog.addEventListener("click", function (e) {
        // Close on the × button or a click on the dimmed backdrop (outside the box)
        if (e.target.closest("[data-close]") || e.target === quizDialog) quizDialog.close();
      });
      quizDialog.addEventListener("close", function () { document.body.classList.remove("no-scroll"); });
      quizTool(quizDialog.querySelector("[data-quiz-body]"));
    }
    if (quizDialog.open) return;
    if (quiz.step >= QUIZ.length && quizTool.restart) { quiz.step = 0; quiz.a = { musts: [] }; quizTool.restart(); } // start fresh after a finished quiz
    document.body.classList.add("no-scroll");
    quizDialog.showModal();
  }
  quizLinks.forEach(function (a) {
    a.addEventListener("click", function (e) {
      if (typeof HTMLDialogElement !== "function" || !HTMLDialogElement.prototype.showModal) return; // old browsers follow the link
      e.preventDefault();
      openQuizDialog();
    });
  });

  /* ---------- Start ---------- */
  if (root) {
    var first = toolFromHash();
    // Coming back from Shopify's contact form (…?contact_posted=true#contact_form)
    if (!first && /[?&]contact_posted=/.test(location.search)) first = TOOLS.filter(function (t) { return t.id === "missing-drills"; })[0];
    open(first ? first.id : "photo-to-drills", !!first);
  }
})();
